import gql from 'graphql-tag'
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: any
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: any
  /**
   * Loose type that allows any value. Be careful when passing in large `Int` or `Float` literals,
   * as they may not be parsed correctly on the server side. Use `String` literals if you are
   * dealing with really large numbers to be on the safe side.
   */
  Mixed: any
  /** Can be used as an argument to upload files using https://github.com/jaydenseric/graphql-multipart-request-spec */
  Upload: any
};

export type Address = {
  __typename?: 'Address'
  id: Scalars['ID']
  company?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  street_1?: Maybe<Scalars['String']>
  street_2?: Maybe<Scalars['String']>
  street_3?: Maybe<Scalars['String']>
  zipcode?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  validation_response?: Maybe<AddressValidationResponse>
  country?: Maybe<Country>
  order?: Maybe<Order>
  package?: Maybe<Package>
};

export enum AddressColumn {
  Name = 'NAME',
  City = 'CITY',
  Company = 'COMPANY',
  Street_1 = 'STREET_1',
  Street_2 = 'STREET_2',
  Street_3 = 'STREET_3',
  Zipcode = 'ZIPCODE',
  Phone = 'PHONE'
}

export type AddressCorrectionTileCategory = {
  __typename?: 'AddressCorrectionTileCategory'
  hgv: AddressCorrectionTileInfo
  libert: AddressCorrectionTileInfo
  obu: AddressCorrectionTileInfo
};

export type AddressCorrectionTileInfo = {
  __typename?: 'AddressCorrectionTileInfo'
  today: Scalars['Int']
  recent: Scalars['Int']
  older: Scalars['Int']
};

export type AddressCorrectionTileStatistics = {
  __typename?: 'AddressCorrectionTileStatistics'
  as24: AddressCorrectionTileCategory
  total_energies: AddressCorrectionTileCategory
  circle_k: AddressCorrectionTileCategory
};

export type AddressValidationCountry = {
  __typename?: 'AddressValidationCountry'
  id: Scalars['ID']
  name: Scalars['String']
  alpha_two: Scalars['String']
  alpha_three: Scalars['String']
  code: Scalars['Int']
  unshippable: Scalars['Boolean']
};

export type AddressValidationRepresentant = {
  __typename?: 'AddressValidationRepresentant'
  id: Scalars['ID']
  email: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  department?: Maybe<Department>
};

export enum AddressValidationResponse {
  Valid = 'VALID',
  ZipcodeIncorrect = 'ZIPCODE_INCORRECT',
  CityOrCountryIncorrect = 'CITY_OR_COUNTRY_INCORRECT',
  CountryUnshippable = 'COUNTRY_UNSHIPPABLE',
  InvalidInput = 'INVALID_INPUT',
  DatabaseNotReady = 'DATABASE_NOT_READY'
}

export type AlertConfirmedEvent = {
  __typename?: 'AlertConfirmedEvent'
  id: Scalars['ID']
  user: User
  alert: AlertReceiverSnapshot
  action: AlertReceiverAction
};

export type AlertReceiver = {
  __typename?: 'AlertReceiver'
  id: Scalars['ID']
  email: Scalars['String']
  alert: Scalars['String']
};

export enum AlertReceiverAction {
  Create = 'create',
  Delete = 'delete'
}

export type AlertReceiverSnapshot = {
  __typename?: 'AlertReceiverSnapshot'
  email: Scalars['String']
  alert: Scalars['String']
};

export type Application = {
  __typename?: 'Application'
  id: Scalars['ID']
  d0491_enrfiller: Scalars['String']
  label?: Maybe<Scalars['String']>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  products: Array<Product>
  packageItemApplications: Array<PackageItemApplication>
};

export type AtlandesLabel = {
  __typename?: 'AtlandesLabel'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  packageItem: PackageItem
};

export type AuthPayload = {
  __typename?: 'AuthPayload'
  access_token?: Maybe<Scalars['String']>
  refresh_token?: Maybe<Scalars['String']>
  expires_in?: Maybe<Scalars['Int']>
  token_type?: Maybe<Scalars['String']>
  user?: Maybe<User>
};

export type Author = {
  __typename?: 'Author'
  name: Scalars['String']
  email: Scalars['String']
};

export type AvailableSupportTicketTag = {
  __typename?: 'AvailableSupportTicketTag'
  value: Scalars['String']
  label: Scalars['String']
  isContact?: Maybe<Scalars['Boolean']>
};

export type AvailableZipcode = {
  __typename?: 'AvailableZipcode'
  zipcode_from: Scalars['String']
  zipcode_to: Scalars['String']
};

export type Country = {
  __typename?: 'Country'
  id: Scalars['ID']
  iso_num: Scalars['Int']
  iso_a2: Scalars['String']
  iso_a3?: Maybe<Scalars['String']>
  eu: Scalars['String']
  carrier_eu: Scalars['String']
  name: Scalars['String']
  rti?: Maybe<Scalars['String']>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export type CountryTrendsStatistics = {
  __typename?: 'CountryTrendsStatistics'
  destination: Scalars['String']
  percentage: Scalars['String']
};

export type DeliveryNote = {
  __typename?: 'DeliveryNote'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  package: Package
};

export type Department = {
  __typename?: 'Department'
  id: Scalars['ID']
  code?: Maybe<Scalars['String']>
  logo_code?: Maybe<Scalars['String']>
  address?: Maybe<Address>
  returnTagAddress?: Maybe<Address>
  returnObuAddress?: Maybe<Address>
  entity: Entity
  label?: Maybe<Scalars['String']>
};

export type DocTemplate = {
  __typename?: 'DocTemplate'
  id: Scalars['ID']
  for_languages?: Maybe<Array<Scalars['String']>>
  department: Department
  doc_type: DocType
  doc_name: Scalars['String']
  description: Scalars['String']
  html: Scalars['String']
  flows: Array<Flow>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  default_for_department: Scalars['Boolean']
};

export enum DocTemplateColumn {
  Id = 'ID',
  DocType = 'DOC_TYPE',
  DocName = 'DOC_NAME',
  Description = 'DESCRIPTION',
  Html = 'HTML',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  DepartmentId = 'DEPARTMENT_ID',
  Flows = 'FLOWS',
  ForLanguages = 'FOR_LANGUAGES'
}

export type DocTemplateEvent = {
  __typename?: 'DocTemplateEvent'
  event: DocTemplateEventKind
  id: Scalars['ID']
  data?: Maybe<DocTemplate>
};

export enum DocTemplateEventKind {
  DocTemplateCreatedSuccess = 'DOC_TEMPLATE_CREATED_SUCCESS',
  DocTemplateCreatedNotFound = 'DOC_TEMPLATE_CREATED_NOT_FOUND',
  DocTemplateCouldNotBeCreatedWithSameDepartmentLanguageAndType = 'DOC_TEMPLATE_COULD_NOT_BE_CREATED_WITH_SAME_DEPARTMENT_LANGUAGE_AND_TYPE',
  DefaltDocTemplateCouldNotBeDuplicated = 'DEFALT_DOC_TEMPLATE_COULD_NOT_BE_DUPLICATED',
  DocTemplateCreatedError = 'DOC_TEMPLATE_CREATED_ERROR',
  DocTemplateUpdatedSuccess = 'DOC_TEMPLATE_UPDATED_SUCCESS',
  DocTemplateUpdatedNotFound = 'DOC_TEMPLATE_UPDATED_NOT_FOUND',
  DocTemplateUpdatedError = 'DOC_TEMPLATE_UPDATED_ERROR',
  DocTemplateDeletedSuccess = 'DOC_TEMPLATE_DELETED_SUCCESS',
  DocTemplateCannotBeDeletedBecauseItsDefault = 'DOC_TEMPLATE_CANNOT_BE_DELETED_BECAUSE_ITS_DEFAULT',
  DocTemplateNotFoundForDeletion = 'DOC_TEMPLATE_NOT_FOUND_FOR_DELETION',
  DocTemplateDeletedError = 'DOC_TEMPLATE_DELETED_ERROR'
}

/** A paginated list of DocTemplate items. */
export type DocTemplatePaginator = {
  __typename?: 'DocTemplatePaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of DocTemplate items. */
  data: Array<DocTemplate>
};

export enum DocType {
  LetterTemplate = 'LETTER_TEMPLATE',
  InvoiceTemplate = 'INVOICE_TEMPLATE',
  DeliveryNoteTemplate = 'DELIVERY_NOTE_TEMPLATE'
}

export type Entity = {
  __typename?: 'Entity'
  id: Scalars['ID']
  name: Scalars['String']
  slug: Scalars['String']
  products: Array<Product>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export enum EntityColumn {
  Slug = 'SLUG'
}

export type File = {
  __typename?: 'File'
  id: Scalars['ID']
  filename: Scalars['String']
  path?: Maybe<Scalars['String']>
  downloadUrl?: Maybe<Scalars['String']>
  expires_at?: Maybe<Scalars['DateTime']>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export enum FileColumn {
  Id = 'ID',
  Filename = 'FILENAME',
  Path = 'PATH',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type FileExportEvent = {
  __typename?: 'FileExportEvent'
  for_user_id: Scalars['ID']
  event: FileExportEventKind
  url?: Maybe<Scalars['String']>
};

export enum FileExportEventKind {
  NoPackagesFoundToExport = 'NO_PACKAGES_FOUND_TO_EXPORT',
  CannotSendMailForPackagesExport = 'CANNOT_SEND_MAIL_FOR_PACKAGES_EXPORT',
  PackagesExportedSuccessfully = 'PACKAGES_EXPORTED_SUCCESSFULLY',
  PackagesExportFailed = 'PACKAGES_EXPORT_FAILED',
  NoPndPackagesFoundToExport = 'NO_PND_PACKAGES_FOUND_TO_EXPORT',
  CannotSendMailForPndPackagesExport = 'CANNOT_SEND_MAIL_FOR_PND_PACKAGES_EXPORT',
  PndPackagesExportedSuccessfully = 'PND_PACKAGES_EXPORTED_SUCCESSFULLY',
  PndPackagesExportFailed = 'PND_PACKAGES_EXPORT_FAILED',
  NoImportFilesFoundToExport = 'NO_IMPORT_FILES_FOUND_TO_EXPORT',
  CannotSendMailForImportFilesExport = 'CANNOT_SEND_MAIL_FOR_IMPORT_FILES_EXPORT',
  ImportFilesExportedSuccessfully = 'IMPORT_FILES_EXPORTED_SUCCESSFULLY',
  ImportFilesExportFailed = 'IMPORT_FILES_EXPORT_FAILED',
  DashboardDataPackageTypeNotSupported = 'DASHBOARD_DATA_PACKAGE_TYPE_NOT_SUPPORTED',
  DashboardDataPackateEntityNotSupported = 'DASHBOARD_DATA_PACKATE_ENTITY_NOT_SUPPORTED',
  NoDashboardDataFoundToExport = 'NO_DASHBOARD_DATA_FOUND_TO_EXPORT',
  CannotSendMailForDashboardDataExport = 'CANNOT_SEND_MAIL_FOR_DASHBOARD_DATA_EXPORT',
  DashboardDataExportedSuccessfully = 'DASHBOARD_DATA_EXPORTED_SUCCESSFULLY',
  DashboardDataExportFailed = 'DASHBOARD_DATA_EXPORT_FAILED',
  NoPackageItemsToExport = 'NO_PACKAGE_ITEMS_TO_EXPORT',
  CannotSendMailForPackageItemsExport = 'CANNOT_SEND_MAIL_FOR_PACKAGE_ITEMS_EXPORT',
  PackageItemsExportedSuccessfully = 'PACKAGE_ITEMS_EXPORTED_SUCCESSFULLY',
  PackageItemsExportFailed = 'PACKAGE_ITEMS_EXPORT_FAILED'
}

/** A paginated list of File items. */
export type FilePaginator = {
  __typename?: 'FilePaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of File items. */
  data: Array<File>
};

export type Fileable = LosangeLabel | AtlandesLabel | StocksFile | TransitiqueLabel | TrashStocksFile | DeliveryNote | Invoice | Letter | TransportLabel | PersonalizationInFile | PersonalizationOutFile | ImportFile | TaskCompletedReport;

export enum Flow {
  TagB2B = 'TAG_B2B',
  TagB2C = 'TAG_B2C',
  Obu = 'OBU'
}

export type ForgotPasswordInput = {
  email: Scalars['String']
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse'
  status: Scalars['String']
  message?: Maybe<Scalars['String']>
};

export type GecotransTracking = {
  __typename?: 'GecotransTracking'
  id: Scalars['ID']
  code_exp?: Maybe<Scalars['String']>
  entete?: Maybe<Scalars['String']>
  ot?: Maybe<Scalars['String']>
  id_colis?: Maybe<Scalars['String']>
  reference_bl?: Maybe<Scalars['String']>
  no_tracking?: Maybe<Scalars['String']>
  no_bt?: Maybe<Scalars['String']>
  date_expe?: Maybe<Scalars['String']>
  code_trp?: Maybe<Scalars['String']>
  prix?: Maybe<Scalars['String']>
  statut?: Maybe<Scalars['String']>
  ss_statut?: Maybe<Scalars['String']>
  date_evt?: Maybe<Scalars['String']>
  libelle_evt?: Maybe<Scalars['String']>
  url_tracking?: Maybe<Scalars['String']>
  url_emarge?: Maybe<Scalars['String']>
  create_ts?: Maybe<Scalars['DateTime']>
  generated_datetime?: Maybe<Scalars['DateTime']>
  created_at?: Maybe<Scalars['DateTime']>
  updated_at?: Maybe<Scalars['DateTime']>
};

export type HgvPackage = PackageInterface & {
  __typename?: 'HgvPackage'
  id: Scalars['ID']
  address_validated: Scalars['Int']
  order: Order
  packageItems: Array<PackageItem>
  letter?: Maybe<Letter>
  deliveryNote?: Maybe<DeliveryNote>
  invoice?: Maybe<Invoice>
  entity: Entity
  transporteur?: Maybe<Scalars['String']>
  address?: Maybe<Address>
  state: Scalars['String']
  importance: Scalars['Int']
  packageMetaAttributes?: Maybe<Array<PackageMetaAttribute>>
  type: Scalars['String']
  stocksFile?: Maybe<StocksFile>
  department?: Maybe<Department>
  tam_validation_date?: Maybe<Scalars['DateTime']>
  tam_correction_date?: Maybe<Scalars['DateTime']>
  cm_32_4_codclient?: Maybe<Scalars['String']>
  d0278a_numfichea: Scalars['String']
  d028x_crtfich: Scalars['String']
  ret004_005?: Maybe<Scalars['DateTime']>
  seenByMe: Scalars['Boolean']
  seenByEmails: Array<Maybe<Scalars['String']>>
  pndSeenByEmails: Array<Maybe<Scalars['String']>>
  stateHistory?: Maybe<Array<StateHistory>>
  package_number: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  badgeCount: Scalars['Int']
  ret003?: Maybe<Scalars['String']>
  flow?: Maybe<Scalars['String']>
  gecotransTrackings?: Maybe<Array<Maybe<GecotransTracking>>>
  teliaeTrackings?: Maybe<Array<Maybe<TeliaeTracking>>>
  perso_import_date?: Maybe<Scalars['DateTime']>
  bypassedRealAddressValidation: Scalars['Boolean']
  atlandes_client?: Maybe<Scalars['String']>
  date_first_expedition?: Maybe<Scalars['DateTime']>
  date_back_warehouse?: Maybe<Scalars['DateTime']>
  pnd_reason?: Maybe<Scalars['String']>
  new_tracking?: Maybe<Scalars['String']>
  original_tracking?: Maybe<Scalars['String']>
  pnd_counter: Scalars['Int']
  address_correction_required: Scalars['Boolean']
  pnd_status?: Maybe<PndStatus>
  delay_days?: Maybe<Scalars['Int']>
  pnd_resend_additional_information?: Maybe<Scalars['String']>
};

export type HgvPackageItem = PackageItemInterface & {
  __typename?: 'HgvPackageItem'
  id: Scalars['ID']
  package: HgvPackage
  ret_cm_24?: Maybe<Scalars['String']>
  packageItemApplications: Array<PackageItemApplication>
  state: Scalars['String']
  product: Product
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  type: Scalars['String']
  serial_number?: Maybe<Scalars['String']>
  cm_16_4_road_traffic_indicator?: Maybe<Scalars['String']>
  d0155_libniestam?: Maybe<Scalars['String']>
  stockItem?: Maybe<StockItem>
  additional_notice?: Maybe<Scalars['String']>
  pan?: Maybe<Scalars['String']>
  fidu?: Maybe<Scalars['String']>
};

export enum HgvPackageItemState {
  Initial = 'INITIAL',
  AvailableForPersonalization = 'AVAILABLE_FOR_PERSONALIZATION',
  PersonalizationInProgress = 'PERSONALIZATION_IN_PROGRESS',
  AwaitingChecks = 'AWAITING_CHECKS',
  BadgeLabelChecked = 'BADGE_LABEL_CHECKED',
  LosangeLabelChecked = 'LOSANGE_LABEL_CHECKED',
  TransitiqueLabelChecked = 'TRANSITIQUE_LABEL_CHECKED',
  GeneratingLosangeLabel = 'GENERATING_LOSANGE_LABEL',
  LosangeLabelGenerated = 'LOSANGE_LABEL_GENERATED',
  GeneratingTransitiqueLabel = 'GENERATING_TRANSITIQUE_LABEL',
  TransitiqueLabelGenerated = 'TRANSITIQUE_LABEL_GENERATED',
  GeneratingTrashStocksFile = 'GENERATING_TRASH_STOCKS_FILE',
  TrashStocksFileGenerated = 'TRASH_STOCKS_FILE_GENERATED',
  Personalized = 'PERSONALIZED',
  Rejected = 'REJECTED',
  Trash = 'TRASH'
}

export enum HgvPackageState {
  Initial = 'INITIAL',
  Setup = 'SETUP',
  AddressValidationInProgress = 'ADDRESS_VALIDATION_IN_PROGRESS',
  AwaitingAddressCorrection = 'AWAITING_ADDRESS_CORRECTION',
  AddressValid = 'ADDRESS_VALID',
  AddressBroken = 'ADDRESS_BROKEN',
  Processing = 'PROCESSING',
  AwaitingDocsGeneration = 'AWAITING_DOCS_GENERATION',
  GeneratingTransportLabels = 'GENERATING_TRANSPORT_LABELS',
  TransportLabelsGenerated = 'TRANSPORT_LABELS_GENERATED',
  GeneratingLetter = 'GENERATING_LETTER',
  LetterGenerated = 'LETTER_GENERATED',
  GeneratingInvoice = 'GENERATING_INVOICE',
  InvoiceGenerated = 'INVOICE_GENERATED',
  GeneratingDeliveryNote = 'GENERATING_DELIVERY_NOTE',
  DeliveryNoteGenerated = 'DELIVERY_NOTE_GENERATED',
  GeneratingStocksFile = 'GENERATING_STOCKS_FILE',
  StocksFileGenerated = 'STOCKS_FILE_GENERATED',
  Complete = 'COMPLETE',
  Cancelled = 'CANCELLED',
  Returned = 'RETURNED',
  Recycled = 'RECYCLED',
  Error = 'ERROR'
}

export type ImportFile = {
  __typename?: 'ImportFile'
  id: Scalars['ID']
  file?: Maybe<File>
  d0278a_numfichea: Scalars['String']
  d0276_typfichier: Scalars['String']
  d028x_crtfich: Scalars['DateTime']
  packagesCount: Scalars['Int']
  packageItemsCount: Scalars['Int']
  flows: Array<Flow>
  entities: Array<Scalars['String']>
  packageItemsDistribution: Array<Maybe<PackageItemsPerDepartmentDistribution>>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  packages: Array<Package>
};

export enum ImportFileColumn {
  Id = 'ID',
  FileNumber = 'FILE_NUMBER',
  CreatedAt = 'CREATED_AT',
  D028XCrtfich = 'D028X_CRTFICH',
  Flow = 'FLOW',
  Name = 'NAME'
}

/** A paginated list of ImportFile items. */
export type ImportFilePaginator = {
  __typename?: 'ImportFilePaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of ImportFile items. */
  data: Array<ImportFile>
};

export type Invoice = {
  __typename?: 'Invoice'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  package: Package
};

export type Issue = {
  __typename?: 'Issue'
  id: Scalars['ID']
  title: Scalars['String']
  author_name: Scalars['String']
  web_url: Scalars['String']
};

export type IssuesResponse = {
  __typename?: 'IssuesResponse'
  nodes: Array<Issue>
  paginatorInfo: PaginatorInfo
};

export type Letter = {
  __typename?: 'Letter'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  package: Package
};

export type LibertPackage = PackageInterface & {
  __typename?: 'LibertPackage'
  id: Scalars['ID']
  address_validated: Scalars['Int']
  order: Order
  packageItems: Array<PackageItem>
  letter?: Maybe<Letter>
  deliveryNote?: Maybe<DeliveryNote>
  invoice?: Maybe<Invoice>
  entity: Entity
  transporteur?: Maybe<Scalars['String']>
  address?: Maybe<Address>
  state: Scalars['String']
  importance: Scalars['Int']
  packageMetaAttributes?: Maybe<Array<PackageMetaAttribute>>
  type: Scalars['String']
  stocksFile?: Maybe<StocksFile>
  department?: Maybe<Department>
  tam_validation_date?: Maybe<Scalars['DateTime']>
  tam_correction_date?: Maybe<Scalars['DateTime']>
  cm_32_4_codclient?: Maybe<Scalars['String']>
  d0278a_numfichea: Scalars['String']
  d028x_crtfich: Scalars['String']
  ret004_005?: Maybe<Scalars['DateTime']>
  seenByMe: Scalars['Boolean']
  seenByEmails: Array<Maybe<Scalars['String']>>
  pndSeenByEmails: Array<Maybe<Scalars['String']>>
  stateHistory?: Maybe<Array<StateHistory>>
  package_number: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  badgeCount: Scalars['Int']
  ret003?: Maybe<Scalars['String']>
  flow?: Maybe<Scalars['String']>
  gecotransTrackings?: Maybe<Array<Maybe<GecotransTracking>>>
  teliaeTrackings?: Maybe<Array<Maybe<TeliaeTracking>>>
  perso_import_date?: Maybe<Scalars['DateTime']>
  bypassedRealAddressValidation: Scalars['Boolean']
  atlandes_client?: Maybe<Scalars['String']>
  date_first_expedition?: Maybe<Scalars['DateTime']>
  date_back_warehouse?: Maybe<Scalars['DateTime']>
  pnd_reason?: Maybe<Scalars['String']>
  new_tracking?: Maybe<Scalars['String']>
  original_tracking?: Maybe<Scalars['String']>
  pnd_counter: Scalars['Int']
  address_correction_required: Scalars['Boolean']
  pnd_status?: Maybe<PndStatus>
  delay_days?: Maybe<Scalars['Int']>
  pnd_resend_additional_information?: Maybe<Scalars['String']>
};

export type LibertPackageItem = PackageItemInterface & {
  __typename?: 'LibertPackageItem'
  id: Scalars['ID']
  package: LibertPackage
  ret_cm_24?: Maybe<Scalars['String']>
  packageItemApplications: Array<PackageItemApplication>
  state: Scalars['String']
  product: Product
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  type: Scalars['String']
  serial_number?: Maybe<Scalars['String']>
  cm_16_4_road_traffic_indicator?: Maybe<Scalars['String']>
  d0155_libniestam?: Maybe<Scalars['String']>
  stockItem?: Maybe<StockItem>
  additional_notice?: Maybe<Scalars['String']>
  pan?: Maybe<Scalars['String']>
  fidu?: Maybe<Scalars['String']>
};

export enum LibertPackageItemState {
  Initial = 'INITIAL',
  AvailableForPersonalization = 'AVAILABLE_FOR_PERSONALIZATION',
  PersonalizationInProgress = 'PERSONALIZATION_IN_PROGRESS',
  AwaitingChecks = 'AWAITING_CHECKS',
  BadgeLabelChecked = 'BADGE_LABEL_CHECKED',
  AtlandesLabelChecked = 'ATLANDES_LABEL_CHECKED',
  TransitiqueLabelChecked = 'TRANSITIQUE_LABEL_CHECKED',
  GeneratingAtlandesLabel = 'GENERATING_ATLANDES_LABEL',
  AtlandesLabelGenerated = 'ATLANDES_LABEL_GENERATED',
  GeneratingTransitiqueLabel = 'GENERATING_TRANSITIQUE_LABEL',
  TransitiqueLabelGenerated = 'TRANSITIQUE_LABEL_GENERATED',
  GeneratingTrashStocksFile = 'GENERATING_TRASH_STOCKS_FILE',
  TrashStocksFileGenerated = 'TRASH_STOCKS_FILE_GENERATED',
  Personalized = 'PERSONALIZED',
  Rejected = 'REJECTED',
  Trash = 'TRASH'
}

export enum LibertPackageState {
  Initial = 'INITIAL',
  Setup = 'SETUP',
  AddressValidationInProgress = 'ADDRESS_VALIDATION_IN_PROGRESS',
  AwaitingAddressCorrection = 'AWAITING_ADDRESS_CORRECTION',
  AddressValid = 'ADDRESS_VALID',
  AddressBroken = 'ADDRESS_BROKEN',
  Processing = 'PROCESSING',
  AwaitingDocsGeneration = 'AWAITING_DOCS_GENERATION',
  GeneratingTransportLabels = 'GENERATING_TRANSPORT_LABELS',
  TransportLabelsGenerated = 'TRANSPORT_LABELS_GENERATED',
  GeneratingDeliveryNote = 'GENERATING_DELIVERY_NOTE',
  DeliveryNoteGenerated = 'DELIVERY_NOTE_GENERATED',
  GeneratingStocksFile = 'GENERATING_STOCKS_FILE',
  StocksFileGenerated = 'STOCKS_FILE_GENERATED',
  Complete = 'COMPLETE',
  Cancelled = 'CANCELLED',
  Returned = 'RETURNED',
  Recycled = 'RECYCLED',
  Error = 'ERROR'
}

export enum Locale {
  En = 'EN',
  Fr = 'FR'
}

export type LoginInput = {
  username: Scalars['String']
  password: Scalars['String']
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse'
  status: Scalars['String']
  message?: Maybe<Scalars['String']>
};

export type LosangeLabel = {
  __typename?: 'LosangeLabel'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  packageItem: PackageItem
};

export type Mutation = {
  __typename?: 'Mutation'
  createAddressValidationCountry: AddressValidationCountry
  updateAddressValidationCountry: AddressValidationCountry
  deleteAddressValidationCountry?: Maybe<Scalars['Boolean']>
  correctPackageAddress: AddressValidationResponse
  updatePackageImportance: Scalars['Boolean']
  sendPndRequest: Scalars['Boolean']
  sendPndResendRequest: Scalars['Boolean']
  sendPndRecycleRequest: Scalars['Boolean']
  createSupportTicket?: Maybe<Scalars['String']>
  updateTicketStatus: Scalars['Boolean']
  updateTicketTags: Scalars['Boolean']
  createComment: Scalars['Boolean']
  upsertSupportTicketTag: SupportTicketTag
  deleteSupportTicketTag?: Maybe<SupportTicketTag>
  createRepresentant: Scalars['Boolean']
  updateRepresentant?: Maybe<Scalars['Boolean']>
  deleteRepresentant: Scalars['Boolean']
  createUser: User
  setUserLocale: Scalars['Boolean']
  updateUser?: Maybe<User>
  deleteUser?: Maybe<User>
  setMyDepartmentsContext: Scalars['Boolean']
  removeMyDepartmentContext: Scalars['Boolean']
  createDocTemplate: Scalars['Boolean']
  updateDocTemplate: Scalars['Boolean']
  deleteDocTemplate: Scalars['Boolean']
  exportPackages: Scalars['Boolean']
  exportPndPackages: Scalars['Boolean']
  exportOrdersImportFiles: Scalars['Boolean']
  exportDashboardData: Scalars['Boolean']
  exportPackageItems: Scalars['Boolean']
  manageAlert: Scalars['Boolean']
  login: AuthPayload
  refreshToken: RefreshTokenPayload
  verifyEmail: AuthPayload
  sendForgotPasswordOtpCode: Scalars['Boolean']
  updateForgottenPassword: Scalars['Boolean']
  updatePassword: UpdatePasswordResponse
  logout: LogoutResponse
};

export type MutationCreateAddressValidationCountryArgs = {
  name: Scalars['String']
  alpha_two: Scalars['String']
  alpha_three: Scalars['String']
  code: Scalars['Int']
  unshippable: Scalars['Boolean']
};

export type MutationUpdateAddressValidationCountryArgs = {
  id: Scalars['ID']
  name: Scalars['String']
  alpha_two: Scalars['String']
  alpha_three: Scalars['String']
  code: Scalars['Int']
  unshippable: Scalars['Boolean']
};

export type MutationDeleteAddressValidationCountryArgs = {
  id: Scalars['ID']
};

export type MutationCorrectPackageAddressArgs = {
  package_id: Scalars['String']
  zipcode: Scalars['String']
  city: Scalars['String']
  country_iso_a2_code: Scalars['String']
  street_and_number: Scalars['String']
  secondary_street?: Maybe<Scalars['String']>
  company_name: Scalars['String']
  client_name: Scalars['String']
  phone: Scalars['String']
  should_bypass_address_validation: Scalars['Boolean']
};

export type MutationUpdatePackageImportanceArgs = {
  id: Scalars['ID']
  importance: Scalars['Int']
};

export type MutationSendPndRequestArgs = {
  package_id: Scalars['ID']
  reason: Scalars['String']
};

export type MutationSendPndResendRequestArgs = {
  package_id: Scalars['ID']
  new_address: PndNewAddressInput
  additional_information?: Maybe<Scalars['String']>
};

export type MutationSendPndRecycleRequestArgs = {
  package_id: Scalars['ID']
  badges_to_recycle: Array<Scalars['String']>
};

export type MutationCreateSupportTicketArgs = {
  subject: Scalars['String']
  description: Scalars['String']
  tags?: Maybe<Array<Scalars['String']>>
  type?: Maybe<SupportTicketType>
  ref?: Maybe<Scalars['ID']>
  attachments?: Maybe<Array<Scalars['Upload']>>
};

export type MutationUpdateTicketStatusArgs = {
  ticketId: Scalars['ID']
  status: SupportTicketStatus
};

export type MutationUpdateTicketTagsArgs = {
  ticketId: Scalars['ID']
  tags?: Maybe<Array<Scalars['String']>>
};

export type MutationCreateCommentArgs = {
  ticketId: Scalars['ID']
  comment: Scalars['String']
  attachments?: Maybe<Array<Scalars['Upload']>>
};

export type MutationUpsertSupportTicketTagArgs = {
  payload: UpsertSupportTicketTagPayload
};

export type MutationDeleteSupportTicketTagArgs = {
  id: Scalars['ID']
};

export type MutationCreateRepresentantArgs = {
  email: Scalars['String']
  departmentIds?: Maybe<Array<Scalars['String']>>
};

export type MutationUpdateRepresentantArgs = {
  email: Scalars['String']
  departmentIds?: Maybe<Array<Scalars['String']>>
};

export type MutationDeleteRepresentantArgs = {
  email: Scalars['String']
};

export type MutationCreateUserArgs = {
  name: Scalars['String']
  email: Scalars['String']
  password: Scalars['String']
  roles?: Maybe<UserRoleCreate>
};

export type MutationSetUserLocaleArgs = {
  locale?: Maybe<Locale>
};

export type MutationUpdateUserArgs = {
  id: Scalars['Int']
  name: Scalars['String']
  email: Scalars['String']
  department_ids?: Maybe<Scalars['String']>
  context_department_ids?: Maybe<Scalars['String']>
  roles?: Maybe<UserRoleUpdate>
};

export type MutationDeleteUserArgs = {
  id: Scalars['Int']
};

export type MutationSetMyDepartmentsContextArgs = {
  departmentIds: Array<Scalars['Int']>
};

export type MutationCreateDocTemplateArgs = {
  for_languages?: Maybe<Array<Scalars['String']>>
  department_id: Scalars['ID']
  doc_type: DocType
  doc_flows: Array<Flow>
  doc_name: Scalars['String']
  description: Scalars['String']
  html: Scalars['String']
  default_for_department: Scalars['Boolean']
};

export type MutationUpdateDocTemplateArgs = {
  id: Scalars['ID']
  html: Scalars['String']
  description: Scalars['String']
  doc_flows: Array<Flow>
  default_for_department: Scalars['Boolean']
};

export type MutationDeleteDocTemplateArgs = {
  id: Scalars['ID']
};

export type MutationExportPackagesArgs = {
  orderBy?: Maybe<Array<MutationExportPackagesOrderByOrderByClause>>
  where?: Maybe<MutationExportPackagesWhereWhereConditions>
  whereEntity?: Maybe<MutationExportPackagesWhereEntityWhereHasConditions>
  whereAddress?: Maybe<MutationExportPackagesWhereAddressWhereHasConditions>
  wherePackageItems?: Maybe<MutationExportPackagesWherePackageItemsWhereHasConditions>
};

export type MutationExportPndPackagesArgs = {
  orderBy?: Maybe<Array<MutationExportPndPackagesOrderByOrderByClause>>
  where?: Maybe<MutationExportPndPackagesWhereWhereConditions>
  pndFilter?: Maybe<PndFilterInput>
  whereEntity?: Maybe<MutationExportPndPackagesWhereEntityWhereHasConditions>
  whereAddress?: Maybe<MutationExportPndPackagesWhereAddressWhereHasConditions>
  wherePackageItems?: Maybe<MutationExportPndPackagesWherePackageItemsWhereHasConditions>
};

export type MutationExportOrdersImportFilesArgs = {
  orderBy?: Maybe<Array<MutationExportOrdersImportFilesOrderByOrderByClause>>
  where?: Maybe<MutationExportOrdersImportFilesWhereWhereConditions>
};

export type MutationExportDashboardDataArgs = {
  startDate: Scalars['String']
  endDate: Scalars['String']
  packageType: Scalars['String']
  packageEntity: Scalars['String']
};

export type MutationExportPackageItemsArgs = {
  package_id: Scalars['ID']
};

export type MutationManageAlertArgs = {
  alert: Scalars['String']
  action: AlertReceiverAction
};

export type MutationLoginArgs = {
  input?: Maybe<LoginInput>
};

export type MutationRefreshTokenArgs = {
  input?: Maybe<RefreshTokenInput>
};

export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput
};

export type MutationSendForgotPasswordOtpCodeArgs = {
  email: Scalars['String']
};

export type MutationUpdateForgottenPasswordArgs = {
  input: UpdateForgottenPasswordInput
};

export type MutationUpdatePasswordArgs = {
  input: UpdatePassword
};

/** Order by clause for Mutation.exportOrdersImportFiles.orderBy. */
export type MutationExportOrdersImportFilesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: ImportFileColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `exportOrdersImportFiles`. */
export type MutationExportOrdersImportFilesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<ImportFileColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportOrdersImportFilesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportOrdersImportFilesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportOrdersImportFilesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `exportOrdersImportFiles`. */
export type MutationExportOrdersImportFilesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportOrdersImportFilesWhereWhereConditions>
};

/** Order by clause for Mutation.exportPackages.orderBy. */
export type MutationExportPackagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: PackageOrderByColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `whereAddress` argument of the query `exportPackages`. */
export type MutationExportPackagesWhereAddressWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<AddressColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportPackagesWhereAddressWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportPackagesWhereAddressWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportPackagesWhereAddressWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereAddress` argument of the query `exportPackages`. */
export type MutationExportPackagesWhereAddressWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportPackagesWhereAddressWhereHasConditions>
};

/** Dynamic WHERE conditions for the `whereEntity` argument of the query `exportPackages`. */
export type MutationExportPackagesWhereEntityWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<EntityColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportPackagesWhereEntityWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportPackagesWhereEntityWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportPackagesWhereEntityWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereEntity` argument of the query `exportPackages`. */
export type MutationExportPackagesWhereEntityWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportPackagesWhereEntityWhereHasConditions>
};

/** Dynamic WHERE conditions for the `wherePackageItems` argument of the query `exportPackages`. */
export type MutationExportPackagesWherePackageItemsWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageItemsColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportPackagesWherePackageItemsWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportPackagesWherePackageItemsWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportPackagesWherePackageItemsWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `wherePackageItems` argument of the query `exportPackages`. */
export type MutationExportPackagesWherePackageItemsWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportPackagesWherePackageItemsWhereHasConditions>
};

/** Dynamic WHERE conditions for the `where` argument of the query `exportPackages`. */
export type MutationExportPackagesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportPackagesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportPackagesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportPackagesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `exportPackages`. */
export type MutationExportPackagesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportPackagesWhereWhereConditions>
};

/** Order by clause for Mutation.exportPndPackages.orderBy. */
export type MutationExportPndPackagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: PackageOrderByColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `whereAddress` argument of the query `exportPndPackages`. */
export type MutationExportPndPackagesWhereAddressWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<AddressColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportPndPackagesWhereAddressWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportPndPackagesWhereAddressWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportPndPackagesWhereAddressWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereAddress` argument of the query `exportPndPackages`. */
export type MutationExportPndPackagesWhereAddressWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportPndPackagesWhereAddressWhereHasConditions>
};

/** Dynamic WHERE conditions for the `whereEntity` argument of the query `exportPndPackages`. */
export type MutationExportPndPackagesWhereEntityWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<EntityColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportPndPackagesWhereEntityWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportPndPackagesWhereEntityWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportPndPackagesWhereEntityWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereEntity` argument of the query `exportPndPackages`. */
export type MutationExportPndPackagesWhereEntityWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportPndPackagesWhereEntityWhereHasConditions>
};

/** Dynamic WHERE conditions for the `wherePackageItems` argument of the query `exportPndPackages`. */
export type MutationExportPndPackagesWherePackageItemsWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageItemsColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportPndPackagesWherePackageItemsWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportPndPackagesWherePackageItemsWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportPndPackagesWherePackageItemsWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `wherePackageItems` argument of the query `exportPndPackages`. */
export type MutationExportPndPackagesWherePackageItemsWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportPndPackagesWherePackageItemsWhereHasConditions>
};

/** Dynamic WHERE conditions for the `where` argument of the query `exportPndPackages`. */
export type MutationExportPndPackagesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<MutationExportPndPackagesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<MutationExportPndPackagesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<MutationExportPndPackagesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `exportPndPackages`. */
export type MutationExportPndPackagesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<MutationExportPndPackagesWhereWhereConditions>
};

export type Order = {
  __typename?: 'Order'
  id: Scalars['ID']
  cm_32_4_codclient: Scalars['String']
  d0033s_nomgestsd: Scalars['String']
  importFile: ImportFile
  address: Address
  packages: Array<Package>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  orderMetaAttributes?: Maybe<Array<OrderMetaAttribute>>
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Minimum. */
  Min = 'MIN',
  /** Maximum. */
  Max = 'MAX',
  /** Sum. */
  Sum = 'SUM',
  /** Amount of items. */
  Count = 'COUNT'
}

export enum OrderColumn {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export enum OrderImportance {
  VeryLow = 'very_low',
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  VeryHigh = 'very_high'
}

export type OrderMetaAttribute = {
  __typename?: 'OrderMetaAttribute'
  key: Scalars['String']
  value: Scalars['String']
};

/** A paginated list of Order items. */
export type OrderPaginator = {
  __typename?: 'OrderPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of Order items. */
  data: Array<Order>
};

export type OrdersFile = {
  __typename?: 'OrdersFile'
  id: Scalars['ID']
  filename: Scalars['String']
  path?: Maybe<Scalars['String']>
  downloadUrl?: Maybe<Scalars['String']>
  fileable: Fileable
  fileable_type: Scalars['String']
  expires_at?: Maybe<Scalars['DateTime']>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export enum OrdersFileColumn {
  Id = 'ID',
  Filename = 'FILENAME',
  Path = 'PATH',
  FileableType = 'FILEABLE_TYPE',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

/** A paginated list of OrdersFile items. */
export type OrdersFilePaginator = {
  __typename?: 'OrdersFilePaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of OrdersFile items. */
  data: Array<OrdersFile>
};

export type Package = HgvPackage | LibertPackage | SiemensPackage;

export enum PackageAddressStatus {
  Validated = 'validated',
  Unvalidated = 'unvalidated',
  Corrected = 'corrected',
  PendingCorrection = 'pending_correction'
}

export type PackageAverageProcessingTimeStatistics = {
  __typename?: 'PackageAverageProcessingTimeStatistics'
  kapsch_packages_processing_average_time?: Maybe<Scalars['Float']>
  hgv_packages_processing_average_time?: Maybe<Scalars['Float']>
  libert_packages_processing_average_time?: Maybe<Scalars['Float']>
  siemens_packages_processing_average_time?: Maybe<Scalars['Float']>
};

export type PackageByPackageNumberAddressCountryData = {
  __typename?: 'PackageByPackageNumberAddressCountryData'
  name: Scalars['String']
};

export type PackageByPackageNumberAddressData = {
  __typename?: 'PackageByPackageNumberAddressData'
  name: Scalars['String']
  company: Scalars['String']
  street_1: Scalars['String']
  street_2?: Maybe<Scalars['String']>
  street_3?: Maybe<Scalars['String']>
  zipcode: Scalars['String']
  city: Scalars['String']
  country: PackageByPackageNumberAddressCountryData
};

export type PackageByPackageNumberData = {
  __typename?: 'PackageByPackageNumberData'
  id: Scalars['ID']
  package_type: Scalars['String']
  package_number: Scalars['String']
  cm_32_4_codclient: Scalars['String']
  atlandes_client_code?: Maybe<Scalars['String']>
  address: PackageByPackageNumberAddressData
  department: PackageByPackageNumberDepartmentData
  flow: Scalars['String']
  fidu?: Maybe<Array<Maybe<Scalars['String']>>>
  pan?: Maybe<Array<Maybe<Scalars['String']>>>
  shipped_at?: Maybe<Scalars['String']>
  package_items_count: Scalars['Int']
};

export type PackageByPackageNumberDepartmentData = {
  __typename?: 'PackageByPackageNumberDepartmentData'
  code: Scalars['String']
  label?: Maybe<Scalars['String']>
};

export enum PackageColumn {
  AddressValidated = 'ADDRESS_VALIDATED',
  Cm_32_4Codclient = 'CM_32_4_CODCLIENT',
  CreatedAt = 'CREATED_AT',
  D028XCrtfich = 'D028X_CRTFICH',
  D0278ANumfichea = 'D0278A_NUMFICHEA',
  Id = 'ID',
  Importance = 'IMPORTANCE',
  PackageNumber = 'PACKAGE_NUMBER',
  Seenbyme = 'SEENBYME',
  Seenbyemails = 'SEENBYEMAILS',
  State = 'STATE',
  TamCorrectionDate = 'TAM_CORRECTION_DATE',
  Transporteur = 'TRANSPORTEUR',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  CountryName = 'COUNTRY_NAME',
  DepartmentCode = 'DEPARTMENT_CODE',
  DepartmentLabel = 'DEPARTMENT_LABEL',
  Ret003 = 'RET003',
  Flow = 'FLOW',
  ImportFileType = 'IMPORT_FILE_TYPE',
  AtlandesClient = 'ATLANDES_CLIENT',
  DateFirstExpedition = 'DATE_FIRST_EXPEDITION',
  DateBackWarehouse = 'DATE_BACK_WAREHOUSE',
  PndReason = 'PND_REASON',
  DelayDays = 'DELAY_DAYS',
  NewTracking = 'NEW_TRACKING',
  PndCounter = 'PND_COUNTER',
  AddressCorrectionRequired = 'ADDRESS_CORRECTION_REQUIRED',
  PndStatus = 'PND_STATUS'
}

export enum PackageEntity {
  As24 = 'AS24',
  Total = 'TOTAL',
  Circlek = 'CIRCLEK'
}

export type PackageInterface = {
  id: Scalars['ID']
  address_validated: Scalars['Int']
  order: Order
  packageItems: Array<PackageItem>
  letter?: Maybe<Letter>
  deliveryNote?: Maybe<DeliveryNote>
  invoice?: Maybe<Invoice>
  entity: Entity
  transporteur?: Maybe<Scalars['String']>
  address?: Maybe<Address>
  state: Scalars['String']
  importance: Scalars['Int']
  packageMetaAttributes?: Maybe<Array<PackageMetaAttribute>>
  type: Scalars['String']
  stocksFile?: Maybe<StocksFile>
  department?: Maybe<Department>
  tam_validation_date?: Maybe<Scalars['DateTime']>
  tam_correction_date?: Maybe<Scalars['DateTime']>
  cm_32_4_codclient?: Maybe<Scalars['String']>
  d0278a_numfichea: Scalars['String']
  d028x_crtfich: Scalars['String']
  ret004_005?: Maybe<Scalars['DateTime']>
  seenByMe: Scalars['Boolean']
  seenByEmails: Array<Maybe<Scalars['String']>>
  pndSeenByEmails: Array<Maybe<Scalars['String']>>
  stateHistory?: Maybe<Array<StateHistory>>
  package_number: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  badgeCount: Scalars['Int']
  gecotransTrackings?: Maybe<Array<Maybe<GecotransTracking>>>
  teliaeTrackings?: Maybe<Array<Maybe<TeliaeTracking>>>
  ret003?: Maybe<Scalars['String']>
  flow?: Maybe<Scalars['String']>
  perso_import_date?: Maybe<Scalars['DateTime']>
  bypassedRealAddressValidation: Scalars['Boolean']
  atlandes_client?: Maybe<Scalars['String']>
  date_first_expedition?: Maybe<Scalars['DateTime']>
  date_back_warehouse?: Maybe<Scalars['DateTime']>
  pnd_reason?: Maybe<Scalars['String']>
  new_tracking?: Maybe<Scalars['String']>
  original_tracking?: Maybe<Scalars['String']>
  pnd_counter: Scalars['Int']
  address_correction_required: Scalars['Boolean']
  pnd_status?: Maybe<PndStatus>
  delay_days?: Maybe<Scalars['Int']>
  pnd_resend_additional_information?: Maybe<Scalars['String']>
};

export type PackageItem = LibertPackageItem | HgvPackageItem | SiemensPackageItem;

export type PackageItemApplication = {
  __typename?: 'PackageItemApplication'
  id: Scalars['ID']
  application: Application
  packageItem: PackageItem
  packageItemApplicationMetaAttributes?: Maybe<Array<PackageItemApplicationMetaAttribute>>
  d0005_codsupptb?: Maybe<Scalars['String']>
  cm_00?: Maybe<Scalars['String']>
  cm_04?: Maybe<Scalars['String']>
  cm_16?: Maybe<Scalars['String']>
  cm_17?: Maybe<Scalars['String']>
  cm_18?: Maybe<Scalars['String']>
  cm_19?: Maybe<Scalars['String']>
  cm_20?: Maybe<Scalars['String']>
  cm_22?: Maybe<Scalars['String']>
  cm_23?: Maybe<Scalars['String']>
  cm_32?: Maybe<Scalars['String']>
  keyacc?: Maybe<Scalars['String']>
  keyiss?: Maybe<Scalars['String']>
  keyope?: Maybe<Scalars['String']>
  cm0005_drivername?: Maybe<Scalars['String']>
  d0852pr_clapr?: Maybe<Scalars['String']>
  d0001_usersi_2?: Maybe<Scalars['String']>
  d0002_maj_2?: Maybe<Scalars['String']>
  d0492_numtb?: Maybe<Scalars['String']>
  d0493_rangtb?: Maybe<Scalars['String']>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export type PackageItemApplicationMetaAttribute = {
  __typename?: 'PackageItemApplicationMetaAttribute'
  key: Scalars['String']
  value: Scalars['String']
};

export enum PackageItemColumn {
  Id = 'ID',
  State = 'STATE',
  PackageId = 'PACKAGE_ID',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  SerialNumber = 'SERIAL_NUMBER'
}

export type PackageItemInterface = {
  id: Scalars['ID']
  package: Package
  ret_cm_24?: Maybe<Scalars['String']>
  packageItemApplications: Array<PackageItemApplication>
  product: Product
  created_at: Scalars['DateTime']
  state: Scalars['String']
  updated_at: Scalars['DateTime']
  type: Scalars['String']
  serial_number?: Maybe<Scalars['String']>
  cm_16_4_road_traffic_indicator?: Maybe<Scalars['String']>
  d0155_libniestam?: Maybe<Scalars['String']>
  stockItem?: Maybe<StockItem>
  additional_notice?: Maybe<Scalars['String']>
  pan?: Maybe<Scalars['String']>
  fidu?: Maybe<Scalars['String']>
};

/** A paginated list of PackageItem items. */
export type PackageItemPaginator = {
  __typename?: 'PackageItemPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of PackageItem items. */
  data: Array<PackageItem>
};

export type PackageItemsAvailableToPrepareStatistics = {
  __typename?: 'PackageItemsAvailableToPrepareStatistics'
  hgv_package_items?: Maybe<Array<PackageItemsStatisticsData>>
  libert_package_items?: Maybe<Array<PackageItemsStatisticsData>>
  siemens_package_items?: Maybe<Array<PackageItemsStatisticsData>>
};

export enum PackageItemsColumn {
  Id = 'ID',
  RetCm_24 = 'RET_CM_24',
  Ret006_007 = 'RET006_007',
  State = 'STATE',
  CreatedAt = 'CREATED_AT'
}

export type PackageItemsCountPerCountriesStatistics = {
  __typename?: 'PackageItemsCountPerCountriesStatistics'
  destination_code: Scalars['String']
  destination: Scalars['String']
  hgv_package_items_count?: Maybe<Scalars['Int']>
  libert_package_items_count?: Maybe<Scalars['Int']>
  siemens_package_items_count?: Maybe<Scalars['Int']>
};

export type PackageItemsDailyProcessingAveragesStatistics = {
  __typename?: 'PackageItemsDailyProcessingAveragesStatistics'
  daily_processing_averages_siemens?: Maybe<Array<PackageItemsDailyProcessingAveragesStatisticsData>>
  daily_processing_averages_kapsch?: Maybe<Array<PackageItemsDailyProcessingAveragesStatisticsData>>
};

export type PackageItemsDailyProcessingAveragesStatisticsData = {
  __typename?: 'PackageItemsDailyProcessingAveragesStatisticsData'
  date: Scalars['Date']
  package_items_processing_average_for_total: Scalars['Float']
  package_items_processing_average_for_as24: Scalars['Float']
};

export type PackageItemsDailyProgressionStatistics = {
  __typename?: 'PackageItemsDailyProgressionStatistics'
  hgv_daily_progression?: Maybe<Array<PackageItemsDailyProgressionStatisticsData>>
  libert_daily_progression?: Maybe<Array<PackageItemsDailyProgressionStatisticsData>>
  siemens_daily_progression?: Maybe<Array<PackageItemsDailyProgressionStatisticsData>>
};

export type PackageItemsDailyProgressionStatisticsData = {
  __typename?: 'PackageItemsDailyProgressionStatisticsData'
  date: Scalars['Date']
  package_items_count: Scalars['Int']
};

export type PackageItemsLiveIndicatorStatistics = {
  __typename?: 'PackageItemsLiveIndicatorStatistics'
  hgv_package_items_count: Scalars['Int']
  libert_package_items_count: Scalars['Int']
  siemens_package_items_count: Scalars['Int']
};

export type PackageItemsPerDepartmentDistribution = {
  __typename?: 'PackageItemsPerDepartmentDistribution'
  departmentCode: Scalars['String']
  packageItemsCount: Scalars['Int']
};

export type PackageItemsPersonalizedStatistics = {
  __typename?: 'PackageItemsPersonalizedStatistics'
  hgv_package_items?: Maybe<Array<PackageItemsStatisticsData>>
  libert_package_items?: Maybe<Array<PackageItemsStatisticsData>>
  siemens_package_items?: Maybe<Array<PackageItemsStatisticsData>>
};

export type PackageItemsReceivedStatistics = {
  __typename?: 'PackageItemsReceivedStatistics'
  hgv_package_items?: Maybe<Array<PackageItemsStatisticsData>>
  libert_package_items?: Maybe<Array<PackageItemsStatisticsData>>
  siemens_package_items?: Maybe<Array<PackageItemsStatisticsData>>
};

export type PackageItemsShippedDailyPerCountryList = {
  __typename?: 'PackageItemsShippedDailyPerCountryList'
  entity: Scalars['String']
  destination: Scalars['String']
  date: Scalars['Date']
  package_items_count: Scalars['Int']
};

export type PackageItemsShippedDailyPerCountryStatistics = {
  __typename?: 'PackageItemsShippedDailyPerCountryStatistics'
  package_items_count_for_total?: Maybe<Array<PackageItemsShippedDailyPerCountryList>>
  package_items_count_for_as24?: Maybe<Array<PackageItemsShippedDailyPerCountryList>>
};

export type PackageItemsShippedInCountry = {
  __typename?: 'PackageItemsShippedInCountry'
  destination_code: Scalars['String']
  destination_name: Scalars['String']
  hgv_package_items: PackageItemsShippedPerEntity
  libert_package_items: PackageItemsShippedPerEntity
  siemens_package_items: PackageItemsShippedPerEntity
};

export type PackageItemsShippedPerCountryStatistics = {
  __typename?: 'PackageItemsShippedPerCountryStatistics'
  package_items_shipped_per_country: Array<PackageItemsShippedInCountry>
};

export type PackageItemsShippedPerEntity = {
  __typename?: 'PackageItemsShippedPerEntity'
  package_items_count_for_total: Scalars['Int']
  package_items_count_for_as24: Scalars['Int']
};

export type PackageItemsShippedStatistics = {
  __typename?: 'PackageItemsShippedStatistics'
  hgv_package_items?: Maybe<Array<PackageItemsStatisticsData>>
  libert_package_items?: Maybe<Array<PackageItemsStatisticsData>>
  siemens_package_items?: Maybe<Array<PackageItemsStatisticsData>>
};

export type PackageItemsShippedTodayCountStatistics = {
  __typename?: 'PackageItemsShippedTodayCountStatistics'
  hgv_package_items?: Maybe<PackageItemsShippedTodayCountStatisticsData>
  libert_package_items?: Maybe<PackageItemsShippedTodayCountStatisticsData>
  siemens_package_items?: Maybe<PackageItemsShippedTodayCountStatisticsData>
};

export type PackageItemsShippedTodayCountStatisticsData = {
  __typename?: 'PackageItemsShippedTodayCountStatisticsData'
  as24_count?: Maybe<Scalars['Int']>
  te_count?: Maybe<Scalars['Int']>
  all_count?: Maybe<Scalars['Int']>
};

export type PackageItemsStatisticsData = {
  __typename?: 'PackageItemsStatisticsData'
  date: Scalars['String']
  package_items_count_for_total_energies: Scalars['Int']
  package_items_count_for_as24: Scalars['Int']
  package_items_count_for_circlek: Scalars['Int']
};

export type PackageMetaAttribute = {
  __typename?: 'PackageMetaAttribute'
  key: Scalars['String']
  value: Scalars['String']
};

export enum PackageOrderByColumn {
  Id = 'ID',
  PackageNumber = 'PACKAGE_NUMBER',
  D0278ANumfichea = 'D0278A_NUMFICHEA',
  D028XCrtfich = 'D028X_CRTFICH',
  Cm_32_4Codclient = 'CM_32_4_CODCLIENT',
  Name = 'NAME',
  Company = 'COMPANY',
  CountryName = 'COUNTRY_NAME',
  City = 'CITY',
  Street_1 = 'STREET_1',
  Street_2 = 'STREET_2',
  Street_3 = 'STREET_3',
  Zipcode = 'ZIPCODE',
  DepartmentCode = 'DEPARTMENT_CODE',
  DepartmentLabel = 'DEPARTMENT_LABEL',
  Phone = 'PHONE',
  Seenbyme = 'SEENBYME',
  TamCorrectionDate = 'TAM_CORRECTION_DATE',
  State = 'STATE',
  Transporteur = 'TRANSPORTEUR',
  Entity = 'ENTITY',
  Ret003 = 'RET003',
  Type = 'TYPE',
  Flow = 'FLOW',
  Importance = 'IMPORTANCE',
  CreatedAt = 'CREATED_AT',
  AtlandesClient = 'ATLANDES_CLIENT',
  DateFirstExpedition = 'DATE_FIRST_EXPEDITION',
  DateBackWarehouse = 'DATE_BACK_WAREHOUSE',
  PndReason = 'PND_REASON',
  DelayDays = 'DELAY_DAYS',
  NewTracking = 'NEW_TRACKING',
  PndCounter = 'PND_COUNTER',
  AddressCorrectionRequired = 'ADDRESS_CORRECTION_REQUIRED',
  PndStatus = 'PND_STATUS'
}

/** A paginated list of Package items. */
export type PackagePaginator = {
  __typename?: 'PackagePaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of Package items. */
  data: Array<Package>
};

export type PackagePndResult = {
  __typename?: 'PackagePndResult'
  id: Scalars['ID']
  success: Scalars['Boolean']
  errorMessage?: Maybe<Scalars['String']>
  event: PackagePndResultEvent
  package: Package
};

export enum PackagePndResultEvent {
  SignalPackageReturned = 'SIGNAL_PACKAGE_RETURNED',
  ResendRequest = 'RESEND_REQUEST',
  RecycleRequest = 'RECYCLE_REQUEST'
}

export type PackageTimeline = {
  __typename?: 'PackageTimeline'
  received_at: Scalars['DateTime']
  address_validated_at?: Maybe<Scalars['DateTime']>
  address_corrected_at?: Maybe<Scalars['DateTime']>
  personalized_at?: Maybe<Scalars['DateTime']>
  in_transit_at?: Maybe<Scalars['DateTime']>
  delivered_at?: Maybe<Scalars['DateTime']>
  delivery_error_at?: Maybe<Scalars['DateTime']>
  pnd_history: Array<Maybe<PndHistoryData>>
};

export type PackageTimelineData = {
  __typename?: 'PackageTimelineData'
  id: Scalars['ID']
  entity_name: Scalars['String']
  package_number: Scalars['String']
  state: Scalars['String']
  tracking_number?: Maybe<Scalars['String']>
  tracking_url?: Maybe<Scalars['String']>
  trackings: Array<TrackingEntry>
  bypassed_real_address_validation: Scalars['Boolean']
  timeline: PackageTimeline
};

export enum PackageType {
  Kapsch = 'KAPSCH',
  Libert = 'LIBERT',
  Hgv = 'HGV',
  Siemens = 'SIEMENS'
}

export type PackagesAvailableToPrepareStatistics = {
  __typename?: 'PackagesAvailableToPrepareStatistics'
  hgv_packages?: Maybe<Array<PackagesStatisticsData>>
  libert_packages?: Maybe<Array<PackagesStatisticsData>>
  siemens_packages?: Maybe<Array<PackagesStatisticsData>>
};

export type PackagesCompletedStatistics = {
  __typename?: 'PackagesCompletedStatistics'
  hgv_packages?: Maybe<Array<PackagesStatisticsData>>
  libert_packages?: Maybe<Array<PackagesStatisticsData>>
  siemens_packages?: Maybe<Array<PackagesStatisticsData>>
};

export type PackagesCountByAddressesStatistics = {
  __typename?: 'PackagesCountByAddressesStatistics'
  count: Scalars['Int']
};

export type PackagesCountPerCountriesStatistics = {
  __typename?: 'PackagesCountPerCountriesStatistics'
  destination_code: Scalars['String']
  destination: Scalars['String']
  hgv_packages_count?: Maybe<Scalars['Int']>
  libert_packages_count?: Maybe<Scalars['Int']>
  siemens_packages_count?: Maybe<Scalars['Int']>
};

export type PackagesDailyAverageProcessingTimeStatistics = {
  __typename?: 'PackagesDailyAverageProcessingTimeStatistics'
  daily_average_processing_time_hgv?: Maybe<Array<PackagesDailyAverageProcessingTimeStatisticsData>>
  daily_average_processing_time_libert?: Maybe<Array<PackagesDailyAverageProcessingTimeStatisticsData>>
  daily_average_processing_time_siemens?: Maybe<Array<PackagesDailyAverageProcessingTimeStatisticsData>>
};

export type PackagesDailyAverageProcessingTimeStatisticsData = {
  __typename?: 'PackagesDailyAverageProcessingTimeStatisticsData'
  date: Scalars['Date']
  average_processing_time: Scalars['Float']
};

export type PackagesDailyProgressionStatistics = {
  __typename?: 'PackagesDailyProgressionStatistics'
  hgv_daily_progression?: Maybe<Array<PackagesDailyProgressionStatisticsData>>
  libert_daily_progression?: Maybe<Array<PackagesDailyProgressionStatisticsData>>
  siemens_daily_progression?: Maybe<Array<PackagesDailyProgressionStatisticsData>>
};

export type PackagesDailyProgressionStatisticsData = {
  __typename?: 'PackagesDailyProgressionStatisticsData'
  date: Scalars['Date']
  packages_count: Scalars['Int']
};

export type PackagesDailyShippedReceivedStatistics = {
  __typename?: 'PackagesDailyShippedReceivedStatistics'
  date: Scalars['String']
  package_daily_shipped_statistics: PackagesDailyShippedReceivedStatisticsData
  package_daily_received_statistics: PackagesDailyShippedReceivedStatisticsData
};

export type PackagesDailyShippedReceivedStatisticsData = {
  __typename?: 'PackagesDailyShippedReceivedStatisticsData'
  AS24: Scalars['Int']
  TOTAL: Scalars['Int']
};

export type PackagesLiveIndicatorStatistics = {
  __typename?: 'PackagesLiveIndicatorStatistics'
  hgv_packages_count: Scalars['Int']
  libert_packages_count: Scalars['Int']
  siemens_packages_count: Scalars['Int']
};

export type PackagesReceivedStatistics = {
  __typename?: 'PackagesReceivedStatistics'
  hgv_packages?: Maybe<Array<PackagesStatisticsData>>
  libert_packages?: Maybe<Array<PackagesStatisticsData>>
  siemens_packages?: Maybe<Array<PackagesStatisticsData>>
};

export type PackagesReceivedTodayCountStatistics = {
  __typename?: 'PackagesReceivedTodayCountStatistics'
  hgv_packages?: Maybe<PackagesReceivedTodayCountStatisticsData>
  hgv_package_items?: Maybe<PackagesReceivedTodayCountStatisticsData>
  libert_packages?: Maybe<PackagesReceivedTodayCountStatisticsData>
  libert_package_items?: Maybe<PackagesReceivedTodayCountStatisticsData>
  siemens_packages?: Maybe<PackagesReceivedTodayCountStatisticsData>
  siemens_package_items?: Maybe<PackagesReceivedTodayCountStatisticsData>
  kapsch_packages?: Maybe<PackagesReceivedTodayCountStatisticsData>
  kapsch_package_items?: Maybe<PackagesReceivedTodayCountStatisticsData>
};

export type PackagesReceivedTodayCountStatisticsData = {
  __typename?: 'PackagesReceivedTodayCountStatisticsData'
  total_count?: Maybe<Scalars['Int']>
  as24_count?: Maybe<Scalars['Int']>
  all_count?: Maybe<Scalars['Int']>
};

export type PackagesShippedStatistics = {
  __typename?: 'PackagesShippedStatistics'
  hgv_packages?: Maybe<Array<PackagesStatisticsData>>
  libert_packages?: Maybe<Array<PackagesStatisticsData>>
  siemens_packages?: Maybe<Array<PackagesStatisticsData>>
};

export type PackagesShippedTodayCountStatistics = {
  __typename?: 'PackagesShippedTodayCountStatistics'
  hgv_packages?: Maybe<PackagesShippedTodayCountStatisticsData>
  libert_packages?: Maybe<PackagesShippedTodayCountStatisticsData>
  siemens_packages?: Maybe<PackagesShippedTodayCountStatisticsData>
};

export type PackagesShippedTodayCountStatisticsData = {
  __typename?: 'PackagesShippedTodayCountStatisticsData'
  as24_count?: Maybe<Scalars['Int']>
  te_count?: Maybe<Scalars['Int']>
  all_count?: Maybe<Scalars['Int']>
};

export type PackagesStatisticsData = {
  __typename?: 'PackagesStatisticsData'
  date: Scalars['String']
  packages_count_for_total_energies: Scalars['Int']
  packages_count_for_as24: Scalars['Int']
  packages_count_for_circlek: Scalars['Int']
};

export type PackagesTilePackageCategory = {
  __typename?: 'PackagesTilePackageCategory'
  hgv: PackagesTilePackageInfo
  libert: PackagesTilePackageInfo
  obu: PackagesTilePackageInfo
};

export type PackagesTilePackageInfo = {
  __typename?: 'PackagesTilePackageInfo'
  completed: Scalars['Int']
  all: Scalars['Int']
};

export type PackagesTilePackageItemStatistics = {
  __typename?: 'PackagesTilePackageItemStatistics'
  hgv: Scalars['Int']
  libert: Scalars['Int']
  obu: Scalars['Int']
};

export type PackagesTilePackageStatistics = {
  __typename?: 'PackagesTilePackageStatistics'
  as24: PackagesTilePackageCategory
  total_energies: PackagesTilePackageCategory
  circle_k: PackagesTilePackageCategory
};

export type PackagesTileStatistics = {
  __typename?: 'PackagesTileStatistics'
  packageStatistics: PackagesTilePackageStatistics
  packageItemStatistics: PackagesTilePackageItemStatistics
};

export type PaginatorInfo = {
  __typename?: 'PaginatorInfo'
  count: Scalars['Int']
  currentPage: Scalars['Int']
  hasMorePages: Scalars['Boolean']
  firstItem?: Maybe<Scalars['Int']>
  lastItem?: Maybe<Scalars['Int']>
  lastPage: Scalars['Int']
  perPage: Scalars['Int']
  total: Scalars['Int']
};

export type PersonalizationInFile = {
  __typename?: 'PersonalizationInFile'
  id: Scalars['ID']
  file?: Maybe<File>
  packageItem: PackageItem
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export type PersonalizationOutFile = {
  __typename?: 'PersonalizationOutFile'
  id: Scalars['ID']
  file?: Maybe<File>
  packageItem: PackageItem
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export type Pivot = {
  __typename?: 'Pivot'
  taggable_id?: Maybe<Scalars['ID']>
  tag_id?: Maybe<Scalars['ID']>
  taggable_type?: Maybe<Scalars['String']>
};

export type PndDateRangeFilter = {
  from?: Maybe<Scalars['DateTime']>
  to?: Maybe<Scalars['DateTime']>
};

export type PndFilterInput = {
  date_first_expedition?: Maybe<PndDateRangeFilter>
  date_back_warehouse?: Maybe<PndDateRangeFilter>
  pnd_reason?: Maybe<Scalars['String']>
  delay_days?: Maybe<Scalars['String']>
  new_tracking?: Maybe<Scalars['String']>
  pnd_counter?: Maybe<Scalars['String']>
  address_correction_required?: Maybe<Scalars['String']>
  pnd_status?: Maybe<Scalars['String']>
};

export type PndHistoryData = {
  __typename?: 'PndHistoryData'
  id: Scalars['ID']
  old_state: PndHistoryState
  new_state: PndHistoryState
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export enum PndHistoryState {
  Returned = 'RETURNED',
  Recycled = 'RECYCLED',
  Complete = 'COMPLETE'
}

export type PndNewAddressInput = {
  company?: Maybe<Scalars['String']>
  name: Scalars['String']
  street_1: Scalars['String']
  street_2?: Maybe<Scalars['String']>
  street_3?: Maybe<Scalars['String']>
  zipcode: Scalars['String']
  city: Scalars['String']
  phone?: Maybe<Scalars['String']>
  country_iso_a2: Scalars['String']
};

export enum PndStatus {
  Returned = 'RETURNED',
  Reshipped = 'RESHIPPED',
  Recycled = 'RECYCLED'
}

export type PndTileInfo = {
  __typename?: 'PndTileInfo'
  today: Scalars['Int']
  recent: Scalars['Int']
  older: Scalars['Int']
};

export type PndTileStatistics = {
  __typename?: 'PndTileStatistics'
  hgv: PndTileInfo
  libert: PndTileInfo
  obu: PndTileInfo
};

export type Product = {
  __typename?: 'Product'
  id: Scalars['ID']
  product_ref: Scalars['String']
  description: Scalars['String']
  flow: Flow
  productMetaAttributes: Array<ProductMetaAttribute>
  cm_32_4_codclient?: Maybe<Scalars['String']>
  applications: Array<Application>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  items: StockItemPaginator
};

export type ProductItemsArgs = {
  first?: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export enum ProductColumn {
  Id = 'ID',
  ProductRef = 'PRODUCT_REF',
  Description = 'DESCRIPTION',
  Flow = 'FLOW',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductMetaAttribute = {
  __typename?: 'ProductMetaAttribute'
  key: Scalars['String']
  value: Scalars['String']
};

/** A paginated list of Product items. */
export type ProductPaginator = {
  __typename?: 'ProductPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of Product items. */
  data: Array<Product>
};

export type ProjectTag = {
  __typename?: 'ProjectTag'
  id: Scalars['ID']
  name: Scalars['String']
  createdAt: Scalars['DateTime']
};

export type ProjectTagsResponse = {
  __typename?: 'ProjectTagsResponse'
  nodes: Array<ProjectTag>
  paginatorInfo: PaginatorInfo
};

export type Query = {
  __typename?: 'Query'
  getAddressValidationCities?: Maybe<Array<Scalars['String']>>
  getAddressValidationZipcodes: ZipcodesResponse
  getAddressValidationCountries?: Maybe<Array<AddressValidationCountry>>
  getAllAddressValidationCountries?: Maybe<Array<AddressValidationCountry>>
  validateAddress: AddressValidationResponse
  allDepartments: Array<Department>
  order?: Maybe<Order>
  packageById?: Maybe<Package>
  packageByPackageNumber?: Maybe<PackageByPackageNumberData>
  packagesCount: Scalars['Int']
  emailsWhoHaveSeenPackage?: Maybe<Array<Scalars['String']>>
  packagesCarriers: Array<Scalars['String']>
  packageTimeline: PackageTimelineData
  product?: Maybe<Product>
  stockItemsById?: Maybe<StockItem>
  workstation: Workstation
  getSupportTickets: SupportTicketPaginator
  viewTicket: SupportTicket
  getTicketToken: Scalars['String']
  getTicketAttachmentURL: Scalars['String']
  getTicketsCount: Scalars['Int']
  searchTicketOrderRefs: Array<Maybe<Scalars['String']>>
  getAvailableTicketsTags: Array<AvailableSupportTicketTag>
  getSupportTicketsTags: Array<SupportTicketTag>
  getSupportTicketTagById: SupportTicketTag
  getRepresentants: Array<AddressValidationRepresentant>
  getRepresentantById?: Maybe<AddressValidationRepresentant>
  ticketsStatistics: TicketStatistics
  stocksStatistics?: Maybe<Array<StocksStatistics>>
  countryTrendsStatistics?: Maybe<Array<CountryTrendsStatistics>>
  packagesCountByAddressesStatistics: PackagesCountByAddressesStatistics
  packageAverageProcessingTimeStatistics: PackageAverageProcessingTimeStatistics
  packageAverageCorrectionTimeStatistics: Scalars['Float']
  packageAddressesCorrectedPercentageStatistics: Scalars['String']
  packagesCountPerCountriesStatistics?: Maybe<Array<PackagesCountPerCountriesStatistics>>
  packageItemsCountPerCountriesStatistics?: Maybe<Array<PackageItemsCountPerCountriesStatistics>>
  packagesDailyProgressionStatistics: PackagesDailyProgressionStatistics
  packagesReceivedTodayCountStatistics: PackagesReceivedTodayCountStatistics
  packageItemsShippedStatistics: PackageItemsShippedStatistics
  packagesShippedStatistics: PackagesShippedStatistics
  packageItemsShippedPerCountryStatistics: PackageItemsShippedPerCountryStatistics
  packageItemsShippedDailyPerCountryStatistics: PackageItemsShippedDailyPerCountryStatistics
  packageItemsDailyProgressionStatistics: PackageItemsDailyProgressionStatistics
  packageItemsShippedTodayCountStatistics: PackageItemsShippedTodayCountStatistics
  packageItemsDailyProcessingAverageStatistics: PackageItemsDailyProcessingAveragesStatistics
  packagesDailyAverageProcessingTimeStatistics: PackagesDailyAverageProcessingTimeStatistics
  packagesDailyShippedReceivedStatistics: Array<PackagesDailyShippedReceivedStatistics>
  packagesShippedTodayCountStatistics: PackagesShippedTodayCountStatistics
  packageItemsReceivedStatistics: PackageItemsReceivedStatistics
  packagesReceivedStatistics: PackagesReceivedStatistics
  packagesAvailableToPrepareStatistics: PackagesAvailableToPrepareStatistics
  packageItemsAvailableToPrepareStatistics: PackageItemsAvailableToPrepareStatistics
  packagesCompletedStatistics: PackagesCompletedStatistics
  packageItemsPersonalizedStatistics: PackageItemsPersonalizedStatistics
  packageItemsRemainingStatistics: PackageItemsLiveIndicatorStatistics
  packagesRemainingStatistics: PackagesLiveIndicatorStatistics
  packagesAwaitingAddressCorrectionStatistics: PackagesLiveIndicatorStatistics
  packageItemsAwaitingAddressCorrectionStatistics: PackageItemsLiveIndicatorStatistics
  packagesAvailableToPrepareTodayStatistics: PackagesLiveIndicatorStatistics
  packageItemsAvailableToPrepareTodayStatistics: PackageItemsLiveIndicatorStatistics
  packagesShippedTodayStatistics: PackagesLiveIndicatorStatistics
  packageItemsShippedTodayStatistics: PackageItemsLiveIndicatorStatistics
  packagesReceivedTodayStatistics: PackagesLiveIndicatorStatistics
  packageItemsReceivedTodayStatistics: PackageItemsLiveIndicatorStatistics
  packagesCompletedTodayStatistics: PackagesLiveIndicatorStatistics
  packageItemsPersonalizedTodayStatistics: PackageItemsLiveIndicatorStatistics
  packagesTileStatistics: PackagesTileStatistics
  addressCorrectionTileStatistics: AddressCorrectionTileStatistics
  pndTileStatistics: PndTileStatistics
  me: User
  user?: Maybe<User>
  userRoles: Array<UserRoles>
  docTemplate?: Maybe<DocTemplate>
  projectTags: ProjectTagsResponse
  issues: IssuesResponse
  packageItems: PackageItemPaginator
  ordersFiles: OrdersFilePaginator
  importFiles: ImportFilePaginator
  files: FilePaginator
  orders: OrderPaginator
  packages: PackagePaginator
  pndPackages: PackagePaginator
  products: ProductPaginator
  stockItems: StockItemPaginator
  workstations: WorkstationPaginator
  users: UserPaginator
  docTemplates: DocTemplatePaginator
};

export type QueryGetAddressValidationCitiesArgs = {
  country_iso_a2_code: Scalars['String']
  city?: Maybe<Scalars['String']>
  take?: Maybe<Scalars['Int']>
  skip?: Maybe<Scalars['Int']>
};

export type QueryGetAddressValidationZipcodesArgs = {
  country_iso_a2_code: Scalars['String']
  city: Scalars['String']
  take?: Maybe<Scalars['Int']>
  skip?: Maybe<Scalars['Int']>
};

export type QueryGetAddressValidationCountriesArgs = {
  take?: Maybe<Scalars['Int']>
  skip?: Maybe<Scalars['Int']>
};

export type QueryGetAllAddressValidationCountriesArgs = {
  take?: Maybe<Scalars['Int']>
  skip?: Maybe<Scalars['Int']>
};

export type QueryValidateAddressArgs = {
  zipcode: Scalars['String']
  city: Scalars['String']
  country_iso_a2_code: Scalars['String']
};

export type QueryOrderArgs = {
  id: Scalars['ID']
};

export type QueryPackageByIdArgs = {
  id: Scalars['ID']
  viewScope?: Maybe<SeePackageScope>
};

export type QueryPackageByPackageNumberArgs = {
  package_number: Scalars['String']
};

export type QueryPackagesCountArgs = {
  where?: Maybe<QueryPackagesCountWhereWhereConditions>
};

export type QueryEmailsWhoHaveSeenPackageArgs = {
  id: Scalars['ID']
};

export type QueryPackageTimelineArgs = {
  package_hash: Scalars['String']
};

export type QueryProductArgs = {
  id: Scalars['ID']
};

export type QueryStockItemsByIdArgs = {
  id: Scalars['ID']
};

export type QueryWorkstationArgs = {
  id: Scalars['ID']
};

export type QueryGetSupportTicketsArgs = {
  first: Scalars['Int']
  page: Scalars['Int']
  status?: Maybe<SupportTicketStatus>
  search?: Maybe<Scalars['String']>
  orderColumn?: Maybe<SupportTicketOrderColumn>
  orderType?: Maybe<SupportTicketOrderType>
  hideClosed?: Maybe<Scalars['Boolean']>
  tags?: Maybe<Array<Scalars['String']>>
  forCurrentUser?: Maybe<Scalars['Boolean']>
};

export type QueryViewTicketArgs = {
  id: Scalars['ID']
};

export type QueryGetTicketTokenArgs = {
  id: Scalars['ID']
};

export type QueryGetTicketAttachmentUrlArgs = {
  attachmentID: Scalars['ID']
  fileName: Scalars['String']
};

export type QueryGetTicketsCountArgs = {
  status: SupportTicketStatus
  forCurrentUser: Scalars['Boolean']
};

export type QuerySearchTicketOrderRefsArgs = {
  type: SupportTicketType
  search: Scalars['String']
};

export type QueryGetAvailableTicketsTagsArgs = {
  search?: Maybe<Scalars['String']>
};

export type QueryGetSupportTicketTagByIdArgs = {
  id: Scalars['ID']
};

export type QueryGetRepresentantByIdArgs = {
  id: Scalars['ID']
};

export type QueryCountryTrendsStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackagesCountByAddressesStatisticsArgs = {
  status: PackageAddressStatus
  date: Scalars['String']
};

export type QueryPackageAverageProcessingTimeStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackageAverageCorrectionTimeStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackageAddressesCorrectedPercentageStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackagesCountPerCountriesStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackageItemsCountPerCountriesStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackagesDailyProgressionStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
  monthsBefore?: Maybe<Scalars['Int']>
};

export type QueryPackagesReceivedTodayCountStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackageItemsShippedStatisticsArgs = {
  daysBefore?: Maybe<Scalars['Int']>
  includeToday?: Maybe<Scalars['Boolean']>
};

export type QueryPackagesShippedStatisticsArgs = {
  daysBefore?: Maybe<Scalars['Int']>
  includeToday?: Maybe<Scalars['Boolean']>
};

export type QueryPackageItemsShippedPerCountryStatisticsArgs = {
  year: Scalars['String']
  month?: Maybe<Scalars['String']>
};

export type QueryPackageItemsShippedDailyPerCountryStatisticsArgs = {
  year: Scalars['String']
  month?: Maybe<Scalars['String']>
};

export type QueryPackageItemsDailyProgressionStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
  monthsBefore?: Maybe<Scalars['Int']>
};

export type QueryPackageItemsShippedTodayCountStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackageItemsDailyProcessingAverageStatisticsArgs = {
  year: Scalars['String']
  month: Scalars['String']
};

export type QueryPackagesDailyAverageProcessingTimeStatisticsArgs = {
  year: Scalars['String']
  month: Scalars['String']
};

export type QueryPackagesDailyShippedReceivedStatisticsArgs = {
  year: Scalars['String']
  month: Scalars['String']
  entity?: Maybe<PackageEntity>
  type: PackageType
};

export type QueryPackagesShippedTodayCountStatisticsArgs = {
  type?: Maybe<PackageType>
  entity?: Maybe<PackageEntity>
};

export type QueryPackageItemsReceivedStatisticsArgs = {
  daysBefore?: Maybe<Scalars['Int']>
  includeToday?: Maybe<Scalars['Boolean']>
};

export type QueryPackagesReceivedStatisticsArgs = {
  daysBefore?: Maybe<Scalars['Int']>
  includeToday?: Maybe<Scalars['Boolean']>
};

export type QueryPackagesAvailableToPrepareStatisticsArgs = {
  daysBefore?: Maybe<Scalars['Int']>
  includeToday?: Maybe<Scalars['Boolean']>
};

export type QueryPackageItemsAvailableToPrepareStatisticsArgs = {
  daysBefore?: Maybe<Scalars['Int']>
  includeToday?: Maybe<Scalars['Boolean']>
};

export type QueryPackagesCompletedStatisticsArgs = {
  daysBefore?: Maybe<Scalars['Int']>
  includeToday?: Maybe<Scalars['Boolean']>
};

export type QueryPackageItemsPersonalizedStatisticsArgs = {
  daysBefore?: Maybe<Scalars['Int']>
  includeToday?: Maybe<Scalars['Boolean']>
};

export type QueryUserArgs = {
  id: Scalars['Int']
};

export type QueryDocTemplateArgs = {
  id: Scalars['ID']
};

export type QueryProjectTagsArgs = {
  page?: Maybe<Scalars['Int']>
  perPage?: Maybe<Scalars['Int']>
};

export type QueryIssuesArgs = {
  tagName: Scalars['String']
  page?: Maybe<Scalars['Int']>
  perPage?: Maybe<Scalars['Int']>
};

export type QueryPackageItemsArgs = {
  orderBy?: Maybe<Array<QueryPackageItemsOrderByOrderByClause>>
  where?: Maybe<QueryPackageItemsWhereWhereConditions>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryOrdersFilesArgs = {
  where?: Maybe<QueryOrdersFilesWhereWhereConditions>
  orderBy?: Maybe<Array<QueryOrdersFilesOrderByOrderByClause>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryImportFilesArgs = {
  where?: Maybe<QueryImportFilesWhereWhereConditions>
  orderBy?: Maybe<Array<QueryImportFilesOrderByOrderByClause>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryFilesArgs = {
  where?: Maybe<QueryFilesWhereWhereConditions>
  orderBy?: Maybe<Array<QueryFilesOrderByOrderByClause>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryOrdersArgs = {
  orderBy?: Maybe<Array<QueryOrdersOrderByOrderByClause>>
  where?: Maybe<QueryOrdersWhereWhereConditions>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryPackagesArgs = {
  orderBy?: Maybe<Array<QueryPackagesOrderByOrderByClause>>
  where?: Maybe<QueryPackagesWhereWhereConditions>
  whereEntity?: Maybe<QueryPackagesWhereEntityWhereHasConditions>
  whereAddress?: Maybe<QueryPackagesWhereAddressWhereHasConditions>
  wherePackageItems?: Maybe<QueryPackagesWherePackageItemsWhereHasConditions>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryPndPackagesArgs = {
  orderBy?: Maybe<Array<QueryPndPackagesOrderByOrderByClause>>
  where?: Maybe<QueryPndPackagesWhereWhereConditions>
  pndFilter?: Maybe<PndFilterInput>
  whereEntity?: Maybe<QueryPndPackagesWhereEntityWhereHasConditions>
  whereAddress?: Maybe<QueryPndPackagesWhereAddressWhereHasConditions>
  wherePackageItems?: Maybe<QueryPndPackagesWherePackageItemsWhereHasConditions>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryProductsArgs = {
  where?: Maybe<QueryProductsWhereWhereConditions>
  orderBy?: Maybe<Array<QueryProductsOrderByOrderByClause>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryStockItemsArgs = {
  where?: Maybe<QueryStockItemsWhereWhereConditions>
  orderBy?: Maybe<Array<QueryStockItemsOrderByOrderByClause>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryWorkstationsArgs = {
  where?: Maybe<QueryWorkstationsWhereWhereConditions>
  orderBy?: Maybe<Array<QueryWorkstationsOrderByOrderByClause>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryUsersArgs = {
  where?: Maybe<QueryUsersWhereWhereConditions>
  whereRoles?: Maybe<QueryUsersWhereRolesWhereHasConditions>
  orderBy?: Maybe<Array<QueryUsersOrderByRelationOrderByClause>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

export type QueryDocTemplatesArgs = {
  where?: Maybe<QueryDocTemplatesWhereWhereConditions>
  orderBy?: Maybe<Array<QueryDocTemplatesOrderByRelationOrderByClause>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
};

/** Aggregate specification for Query.docTemplates.orderBy.department. */
export type QueryDocTemplatesOrderByDepartment = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction
  /** Name of the column to use. */
  column?: Maybe<QueryDocTemplatesOrderByDepartmentColumn>
};

/** Allowed column names for Query.docTemplates.orderBy. */
export enum QueryDocTemplatesOrderByDepartmentColumn {
  Code = 'CODE'
}

/** Order by clause for Query.docTemplates.orderBy. */
export type QueryDocTemplatesOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  column?: Maybe<DocTemplateColumn>
  /** The direction that is used for ordering. */
  order: SortOrder
  /** Aggregate specification. */
  department?: Maybe<QueryDocTemplatesOrderByDepartment>
};

/** Dynamic WHERE conditions for the `where` argument of the query `docTemplates`. */
export type QueryDocTemplatesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<DocTemplateColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryDocTemplatesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryDocTemplatesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryDocTemplatesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `docTemplates`. */
export type QueryDocTemplatesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryDocTemplatesWhereWhereConditions>
};

/** Order by clause for Query.files.orderBy. */
export type QueryFilesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: FileColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `files`. */
export type QueryFilesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<FileColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryFilesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryFilesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryFilesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `files`. */
export type QueryFilesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryFilesWhereWhereConditions>
};

/** Order by clause for Query.importFiles.orderBy. */
export type QueryImportFilesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: ImportFileColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `importFiles`. */
export type QueryImportFilesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<ImportFileColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryImportFilesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryImportFilesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryImportFilesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `importFiles`. */
export type QueryImportFilesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryImportFilesWhereWhereConditions>
};

/** Order by clause for Query.ordersFiles.orderBy. */
export type QueryOrdersFilesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: OrdersFileColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `ordersFiles`. */
export type QueryOrdersFilesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<OrdersFileColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryOrdersFilesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryOrdersFilesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryOrdersFilesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `ordersFiles`. */
export type QueryOrdersFilesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryOrdersFilesWhereWhereConditions>
};

/** Order by clause for Query.orders.orderBy. */
export type QueryOrdersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: OrderColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `orders`. */
export type QueryOrdersWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<OrderColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryOrdersWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryOrdersWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryOrdersWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `orders`. */
export type QueryOrdersWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryOrdersWhereWhereConditions>
};

/** Order by clause for Query.packageItems.orderBy. */
export type QueryPackageItemsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: PackageItemColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `packageItems`. */
export type QueryPackageItemsWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageItemColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPackageItemsWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPackageItemsWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPackageItemsWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `packageItems`. */
export type QueryPackageItemsWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPackageItemsWhereWhereConditions>
};

/** Dynamic WHERE conditions for the `where` argument of the query `packagesCount`. */
export type QueryPackagesCountWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPackagesCountWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPackagesCountWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPackagesCountWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `packagesCount`. */
export type QueryPackagesCountWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPackagesCountWhereWhereConditions>
};

/** Order by clause for Query.packages.orderBy. */
export type QueryPackagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: PackageOrderByColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `whereAddress` argument of the query `packages`. */
export type QueryPackagesWhereAddressWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<AddressColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPackagesWhereAddressWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPackagesWhereAddressWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPackagesWhereAddressWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereAddress` argument of the query `packages`. */
export type QueryPackagesWhereAddressWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPackagesWhereAddressWhereHasConditions>
};

/** Dynamic WHERE conditions for the `whereEntity` argument of the query `packages`. */
export type QueryPackagesWhereEntityWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<EntityColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPackagesWhereEntityWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPackagesWhereEntityWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPackagesWhereEntityWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereEntity` argument of the query `packages`. */
export type QueryPackagesWhereEntityWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPackagesWhereEntityWhereHasConditions>
};

/** Dynamic WHERE conditions for the `wherePackageItems` argument of the query `packages`. */
export type QueryPackagesWherePackageItemsWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageItemsColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPackagesWherePackageItemsWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPackagesWherePackageItemsWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPackagesWherePackageItemsWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `wherePackageItems` argument of the query `packages`. */
export type QueryPackagesWherePackageItemsWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPackagesWherePackageItemsWhereHasConditions>
};

/** Dynamic WHERE conditions for the `where` argument of the query `packages`. */
export type QueryPackagesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPackagesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPackagesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPackagesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `packages`. */
export type QueryPackagesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPackagesWhereWhereConditions>
};

/** Order by clause for Query.pndPackages.orderBy. */
export type QueryPndPackagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: PackageOrderByColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `whereAddress` argument of the query `pndPackages`. */
export type QueryPndPackagesWhereAddressWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<AddressColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPndPackagesWhereAddressWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPndPackagesWhereAddressWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPndPackagesWhereAddressWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereAddress` argument of the query `pndPackages`. */
export type QueryPndPackagesWhereAddressWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPndPackagesWhereAddressWhereHasConditions>
};

/** Dynamic WHERE conditions for the `whereEntity` argument of the query `pndPackages`. */
export type QueryPndPackagesWhereEntityWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<EntityColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPndPackagesWhereEntityWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPndPackagesWhereEntityWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPndPackagesWhereEntityWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereEntity` argument of the query `pndPackages`. */
export type QueryPndPackagesWhereEntityWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPndPackagesWhereEntityWhereHasConditions>
};

/** Dynamic WHERE conditions for the `wherePackageItems` argument of the query `pndPackages`. */
export type QueryPndPackagesWherePackageItemsWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageItemsColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPndPackagesWherePackageItemsWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPndPackagesWherePackageItemsWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPndPackagesWherePackageItemsWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `wherePackageItems` argument of the query `pndPackages`. */
export type QueryPndPackagesWherePackageItemsWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPndPackagesWherePackageItemsWhereHasConditions>
};

/** Dynamic WHERE conditions for the `where` argument of the query `pndPackages`. */
export type QueryPndPackagesWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<PackageColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryPndPackagesWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryPndPackagesWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryPndPackagesWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `pndPackages`. */
export type QueryPndPackagesWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryPndPackagesWhereWhereConditions>
};

/** Order by clause for Query.products.orderBy. */
export type QueryProductsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: ProductColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `products`. */
export type QueryProductsWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<ProductColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryProductsWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryProductsWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryProductsWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `products`. */
export type QueryProductsWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryProductsWhereWhereConditions>
};

/** Order by clause for Query.stockItems.orderBy. */
export type QueryStockItemsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: StockItemColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `stockItems`. */
export type QueryStockItemsWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<StockItemColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryStockItemsWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryStockItemsWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryStockItemsWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `stockItems`. */
export type QueryStockItemsWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryStockItemsWhereWhereConditions>
};

/** Order by clause for Query.users.orderBy. */
export type QueryUsersOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  column?: Maybe<UserColumn>
  /** The direction that is used for ordering. */
  order: SortOrder
  /** Aggregate specification. */
  roles?: Maybe<QueryUsersOrderByRoles>
};

/** Aggregate specification for Query.users.orderBy.roles. */
export type QueryUsersOrderByRoles = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction
  /** Name of the column to use. */
  column?: Maybe<QueryUsersOrderByRolesColumn>
};

/** Allowed column names for Query.users.orderBy. */
export enum QueryUsersOrderByRolesColumn {
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `whereRoles` argument of the query `users`. */
export type QueryUsersWhereRolesWhereHasConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<RoleColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryUsersWhereRolesWhereHasConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryUsersWhereRolesWhereHasConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryUsersWhereRolesWhereHasConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `whereRoles` argument of the query `users`. */
export type QueryUsersWhereRolesWhereHasConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryUsersWhereRolesWhereHasConditions>
};

/** Dynamic WHERE conditions for the `where` argument of the query `users`. */
export type QueryUsersWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<UserColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryUsersWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryUsersWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryUsersWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `users`. */
export type QueryUsersWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryUsersWhereWhereConditions>
};

/** Order by clause for Query.workstations.orderBy. */
export type QueryWorkstationsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: WorkstationColumn
  /** The direction that is used for ordering. */
  order: SortOrder
};

/** Dynamic WHERE conditions for the `where` argument of the query `workstations`. */
export type QueryWorkstationsWhereWhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<WorkstationColumn>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<QueryWorkstationsWhereWhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<QueryWorkstationsWhereWhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<QueryWorkstationsWhereWhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `workstations`. */
export type QueryWorkstationsWhereWhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<QueryWorkstationsWhereWhereConditions>
};

export type RefreshTokenInput = {
  refresh_token?: Maybe<Scalars['String']>
};

export type RefreshTokenPayload = {
  __typename?: 'RefreshTokenPayload'
  access_token: Scalars['String']
  refresh_token: Scalars['String']
  expires_in: Scalars['Int']
  token_type: Scalars['String']
};

export enum RoleColumn {
  Name = 'name'
}

/** The available SQL operators that are used to filter query results. */
export enum SqlOperator {
  /** Equal operator (`=`) */
  Eq = 'EQ',
  /** Not equal operator (`!=`) */
  Neq = 'NEQ',
  /** Greater than operator (`>`) */
  Gt = 'GT',
  /** Greater than or equal operator (`>=`) */
  Gte = 'GTE',
  /** Less than operator (`<`) */
  Lt = 'LT',
  /** Less than or equal operator (`<=`) */
  Lte = 'LTE',
  /** Simple pattern matching (`LIKE`) */
  Like = 'LIKE',
  /** Negation of simple pattern matching (`NOT LIKE`) */
  NotLike = 'NOT_LIKE',
  /** Whether a value is within a set of values (`IN`) */
  In = 'IN',
  /** Whether a value is not within a set of values (`NOT IN`) */
  NotIn = 'NOT_IN',
  /** Whether a value is within a range of values (`BETWEEN`) */
  Between = 'BETWEEN',
  /** Whether a value is not within a range of values (`NOT BETWEEN`) */
  NotBetween = 'NOT_BETWEEN',
  /** Whether a value is null (`IS NULL`) */
  IsNull = 'IS_NULL',
  /** Whether a value is not null (`IS NOT NULL`) */
  IsNotNull = 'IS_NOT_NULL'
}

export enum SeePackageScope {
  PackageView = 'PACKAGE_VIEW',
  PndView = 'PND_VIEW'
}

export type SiemensPackage = PackageInterface & {
  __typename?: 'SiemensPackage'
  id: Scalars['ID']
  address_validated: Scalars['Int']
  order: Order
  packageItems: Array<PackageItem>
  letter?: Maybe<Letter>
  deliveryNote?: Maybe<DeliveryNote>
  invoice?: Maybe<Invoice>
  entity: Entity
  transporteur?: Maybe<Scalars['String']>
  address?: Maybe<Address>
  state: Scalars['String']
  importance: Scalars['Int']
  packageMetaAttributes?: Maybe<Array<PackageMetaAttribute>>
  type: Scalars['String']
  stocksFile?: Maybe<StocksFile>
  department?: Maybe<Department>
  tam_validation_date?: Maybe<Scalars['DateTime']>
  tam_correction_date?: Maybe<Scalars['DateTime']>
  cm_32_4_codclient?: Maybe<Scalars['String']>
  d0278a_numfichea: Scalars['String']
  d028x_crtfich: Scalars['String']
  ret004_005?: Maybe<Scalars['DateTime']>
  seenByMe: Scalars['Boolean']
  seenByEmails: Array<Maybe<Scalars['String']>>
  pndSeenByEmails: Array<Maybe<Scalars['String']>>
  stateHistory?: Maybe<Array<StateHistory>>
  package_number: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  badgeCount: Scalars['Int']
  ret003?: Maybe<Scalars['String']>
  flow?: Maybe<Scalars['String']>
  gecotransTrackings?: Maybe<Array<Maybe<GecotransTracking>>>
  teliaeTrackings?: Maybe<Array<Maybe<TeliaeTracking>>>
  perso_import_date?: Maybe<Scalars['DateTime']>
  bypassedRealAddressValidation: Scalars['Boolean']
  atlandes_client?: Maybe<Scalars['String']>
  date_first_expedition?: Maybe<Scalars['DateTime']>
  date_back_warehouse?: Maybe<Scalars['DateTime']>
  pnd_reason?: Maybe<Scalars['String']>
  new_tracking?: Maybe<Scalars['String']>
  original_tracking?: Maybe<Scalars['String']>
  pnd_counter: Scalars['Int']
  address_correction_required: Scalars['Boolean']
  pnd_status?: Maybe<PndStatus>
  delay_days?: Maybe<Scalars['Int']>
  pnd_resend_additional_information?: Maybe<Scalars['String']>
};

export type SiemensPackageItem = PackageItemInterface & {
  __typename?: 'SiemensPackageItem'
  id: Scalars['ID']
  package: HgvPackage
  ret_cm_24?: Maybe<Scalars['String']>
  packageItemApplications: Array<PackageItemApplication>
  state: Scalars['String']
  product: Product
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  type: Scalars['String']
  serial_number?: Maybe<Scalars['String']>
  cm_16_4_road_traffic_indicator?: Maybe<Scalars['String']>
  d0155_libniestam?: Maybe<Scalars['String']>
  stockItem?: Maybe<StockItem>
  additional_notice?: Maybe<Scalars['String']>
  pan?: Maybe<Scalars['String']>
  fidu?: Maybe<Scalars['String']>
};

export enum SiemensPackageState {
  Initial = 'INITIAL',
  AddressValidationInProgress = 'ADDRESS_VALIDATION_IN_PROGRESS',
  AwaitingAddressCorrection = 'AWAITING_ADDRESS_CORRECTION',
  AddressValid = 'ADDRESS_VALID',
  AddressBroken = 'ADDRESS_BROKEN',
  AwaitingPackageItemsAssociation = 'AWAITING_PACKAGE_ITEMS_ASSOCIATION',
  PackageItemsAssociated = 'PACKAGE_ITEMS_ASSOCIATED',
  GeneratingInitialTransportLabels = 'GENERATING_INITIAL_TRANSPORT_LABELS',
  InitialTransportLabelsGenerated = 'INITIAL_TRANSPORT_LABELS_GENERATED',
  GeneratingLetter = 'GENERATING_LETTER',
  LetterGenerated = 'LETTER_GENERATED',
  GeneratingInitialInvoice = 'GENERATING_INITIAL_INVOICE',
  InitialInvoiceGenerated = 'INITIAL_INVOICE_GENERATED',
  GeneratingInitialDeliveryNote = 'GENERATING_INITIAL_DELIVERY_NOTE',
  InitialDeliveryNoteGenerated = 'INITIAL_DELIVERY_NOTE_GENERATED',
  GeneratingInitialStocksFile = 'GENERATING_INITIAL_STOCKS_FILE',
  InitialStocksFileGenerated = 'INITIAL_STOCKS_FILE_GENERATED',
  AwaitingPackageItemsPersonalization = 'AWAITING_PACKAGE_ITEMS_PERSONALIZATION',
  AwaitingDocsRegeneration = 'AWAITING_DOCS_REGENERATION',
  TransportLabelsRegenerated = 'TRANSPORT_LABELS_REGENERATED',
  InvoiceRegenerated = 'INVOICE_REGENERATED',
  DeliveryNoteRegenerated = 'DELIVERY_NOTE_REGENERATED',
  StocksFileRegenerated = 'STOCKS_FILE_REGENERATED',
  Complete = 'COMPLETE',
  Cancelled = 'CANCELLED',
  Returned = 'RETURNED',
  Recycled = 'RECYCLED',
  Error = 'ERROR'
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type StateHistory = {
  __typename?: 'StateHistory'
  event_key: StateHistoryEventKey
  transition: Scalars['String']
  from: Scalars['String']
  to: Scalars['String']
  statable_type: Scalars['String']
  statable_id: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export enum StateHistoryEventKey {
  TestTransition = 'TEST_TRANSITION',
  PreTransition = 'PRE_TRANSITION',
  PostTransition = 'POST_TRANSITION'
}

export type StockItem = {
  __typename?: 'StockItem'
  id: Scalars['ID']
  serial_number: Scalars['String']
  details: Array<StockItemDetail>
  product: Product
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export enum StockItemColumn {
  Id = 'ID',
  SerialNumber = 'SERIAL_NUMBER',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type StockItemDetail = {
  __typename?: 'StockItemDetail'
  id: Scalars['ID']
  attribute: Scalars['String']
  value: Scalars['String']
  stockItem: StockItem
};

export type StockItemHistory = {
  __typename?: 'StockItemHistory'
  id: Scalars['ID']
  stockItem: StockItem
  action_type: Scalars['String']
  action: Scalars['String']
  date: Scalars['DateTime']
};

/** A paginated list of StockItem items. */
export type StockItemPaginator = {
  __typename?: 'StockItemPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of StockItem items. */
  data: Array<StockItem>
};

export type StocksFile = {
  __typename?: 'StocksFile'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  package: Package
};

export type StocksStatistics = {
  __typename?: 'StocksStatistics'
  code_article: Scalars['String']
  physical_stock: Scalars['Int']
  reserved_stock: Scalars['Int']
  available_stock: Scalars['Int']
};

export type Subscription = {
  __typename?: 'Subscription'
  ticketCreated?: Maybe<Scalars['ID']>
  ticketUpdated?: Maybe<Scalars['ID']>
  docTemplateEvent?: Maybe<DocTemplateEvent>
  fileExportEvent?: Maybe<FileExportEvent>
  alertConfirmed?: Maybe<AlertConfirmedEvent>
  packagePndResult?: Maybe<PackagePndResult>
};

export type SupportTicket = {
  __typename?: 'SupportTicket'
  id: Scalars['ID']
  title: Scalars['String']
  body: Scalars['String']
  public_token?: Maybe<Scalars['String']>
  requester_id: Scalars['Int']
  team_id?: Maybe<Scalars['ID']>
  user_id?: Maybe<Scalars['ID']>
  status: SupportTicketStatus
  priority?: Maybe<Scalars['Int']>
  level?: Maybe<Scalars['Int']>
  rating?: Maybe<Scalars['Int']>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  deleted_at?: Maybe<Scalars['DateTime']>
  subject?: Maybe<Scalars['String']>
  summary?: Maybe<Scalars['String']>
  requester: TicketRequester
  comments: Array<TicketComment>
  tags: Array<TicketTag>
};

export enum SupportTicketOrderColumn {
  UpdatedAt = 'updated_at',
  CreatedAt = 'created_at',
  Title = 'title'
}

export enum SupportTicketOrderType {
  Asc = 'asc',
  Desc = 'desc'
}

export type SupportTicketPaginator = {
  __typename?: 'SupportTicketPaginator'
  data: Array<Maybe<SupportTicket>>
  paginatorInfo: PaginatorInfo
};

export enum SupportTicketSort {
  Active = 'active'
}

export enum SupportTicketStatus {
  New = 'new',
  Open = 'open',
  Pending = 'pending',
  Solved = 'solved',
  Closed = 'closed',
  GiveUp = 'give_up',
  Merged = 'merged',
  Spam = 'spam'
}

export type SupportTicketTag = {
  __typename?: 'SupportTicketTag'
  id: Scalars['ID']
  value: Scalars['String']
  label_en: Scalars['String']
  label_fr: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  supportTicketTagUserEmails?: Maybe<Array<SupportTicketTagUserEmail>>
};

export type SupportTicketTagUserEmail = {
  __typename?: 'SupportTicketTagUserEmail'
  id: Scalars['ID']
  support_ticket_tag_id: Scalars['ID']
  user_email: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export type SupportTicketTagUserEmailHasMany = {
  upsert?: Maybe<Array<UpsertSupportTicketTagUserEmailPayload>>
  delete?: Maybe<Array<Scalars['ID']>>
};

export enum SupportTicketType {
  HgvPackageItemTicket = 'HGV_PACKAGE_ITEM_TICKET',
  HgvPackageTicket = 'HGV_PACKAGE_TICKET',
  LibertPackageItemTicket = 'LIBERT_PACKAGE_ITEM_TICKET',
  LibertPackageTicket = 'LIBERT_PACKAGE_TICKET',
  SiemensPackageItemTicket = 'SIEMENS_PACKAGE_ITEM_TICKET',
  SiemensPackageTicket = 'SIEMENS_PACKAGE_TICKET'
}

export type TaskCompletedReport = {
  __typename?: 'TaskCompletedReport'
  id: Scalars['ID']
  file?: Maybe<File>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export type TeliaeTracking = {
  __typename?: 'TeliaeTracking'
  id: Scalars['ID']
  filename: Scalars['String']
  package_number: Scalars['String']
  issuer_code: Scalars['String']
  tracking_number: Scalars['String']
  tracking_url: Scalars['String']
  shipping_status?: Maybe<Scalars['String']>
  situation_code?: Maybe<Scalars['String']>
  justification_code?: Maybe<Scalars['String']>
  status_label?: Maybe<Scalars['String']>
  status_date?: Maybe<Scalars['String']>
  shipping_id: Scalars['String']
  carrier_code: Scalars['String']
  product_code: Scalars['String']
  shipping_date?: Maybe<Scalars['DateTime']>
  created_at?: Maybe<Scalars['DateTime']>
  updated_at?: Maybe<Scalars['DateTime']>
};

export type TicketAttachment = {
  __typename?: 'TicketAttachment'
  id: Scalars['ID']
  path: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export type TicketComment = {
  __typename?: 'TicketComment'
  id: Scalars['ID']
  attachments: Array<TicketAttachment>
  ticket_id: Scalars['ID']
  user_id?: Maybe<Scalars['Int']>
  new_status: TicketCommentStatus
  private?: Maybe<Scalars['Boolean']>
  body: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  author: Author
};

export enum TicketCommentStatus {
  New = 'new',
  Open = 'open',
  Pending = 'pending',
  Solved = 'solved',
  Closed = 'closed',
  Merged = 'merged',
  Spam = 'spam'
}

export type TicketRequester = {
  __typename?: 'TicketRequester'
  id: Scalars['ID']
  name: Scalars['String']
  email: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  no_reply?: Maybe<Scalars['Int']>
};

export type TicketStatistics = {
  __typename?: 'TicketStatistics'
  average_lifespan_tickets: Scalars['Int']
  top_tagged_tickets: Scalars['String']
  top_creator_tickets?: Maybe<Scalars['String']>
  tag_counts: Array<Maybe<TicketTagCount>>
  progression_days: Array<Maybe<TicketsProgressionPerDay>>
  status_counts: TicketsPerStatusesCount
};

export type TicketTag = {
  __typename?: 'TicketTag'
  id: Scalars['ID']
  name: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  pivot?: Maybe<Pivot>
};

export type TicketTagCount = {
  __typename?: 'TicketTagCount'
  tag_name_tickets: Scalars['String']
  tag_count_tickets: Scalars['Int']
};

export type TicketsPerStatusesCount = {
  __typename?: 'TicketsPerStatusesCount'
  open_tickets: Scalars['Int']
  pending_tickets: Scalars['Int']
  closed_tickets: Scalars['Int']
  total_tickets: Scalars['Int']
};

export type TicketsProgressionPerDay = {
  __typename?: 'TicketsProgressionPerDay'
  date_tickets: Scalars['String']
  no_tickets: Scalars['Int']
};

export type TrackingEntry = {
  __typename?: 'TrackingEntry'
  tracking_number: Scalars['String']
  tracking_url?: Maybe<Scalars['String']>
};

export type TransitiqueLabel = {
  __typename?: 'TransitiqueLabel'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  packageItem: PackageItem
};

export type TransportLabel = {
  __typename?: 'TransportLabel'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  package: Package
};

export type TrashStocksFile = {
  __typename?: 'TrashStocksFile'
  id: Scalars['ID']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  file?: Maybe<File>
  packageItem: PackageItem
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UpdateForgottenPasswordInput = {
  otpCode: Scalars['String']
  email: Scalars['String']
  password: Scalars['String']
};

export type UpdatePassword = {
  old_password: Scalars['String']
  password: Scalars['String']
  password_confirmation: Scalars['String']
};

export type UpdatePasswordResponse = {
  __typename?: 'UpdatePasswordResponse'
  status: Scalars['String']
  message?: Maybe<Scalars['String']>
};

export type UpsertSupportTicketTagPayload = {
  id?: Maybe<Scalars['ID']>
  value: Scalars['String']
  label_en: Scalars['String']
  label_fr: Scalars['String']
  supportTicketTagUserEmails?: Maybe<SupportTicketTagUserEmailHasMany>
};

export type UpsertSupportTicketTagUserEmailPayload = {
  id?: Maybe<Scalars['ID']>
  user_email: Scalars['String']
};

export type User = {
  __typename?: 'User'
  id: Scalars['ID']
  name: Scalars['String']
  email: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  locale: Scalars['String']
  departments?: Maybe<Array<Maybe<Department>>>
  contextDepartments?: Maybe<Array<Maybe<Department>>>
  roles: Array<Maybe<UserRoles>>
  enabledAlerts: Array<Maybe<AlertReceiver>>
};

export enum UserColumn {
  Id = 'id',
  Name = 'name',
  Email = 'email',
  Locale = 'locale',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of User items. */
  data: Array<User>
};

export enum UserRole {
  Admin = 'admin',
  Representant = 'representant'
}

export type UserRoleCreate = {
  connect: Array<Scalars['ID']>
};

export type UserRoleUpdate = {
  sync: Array<Scalars['ID']>
};

export type UserRoles = {
  __typename?: 'UserRoles'
  id: Scalars['ID']
  name: UserRole
};

export type VerifyEmailInput = {
  token: Scalars['String']
};

/** Dynamic WHERE conditions for queries. */
export type WhereConditions = {
  /** The column that is used for the condition. */
  column?: Maybe<Scalars['String']>
  /** The operator that is used for the condition. */
  operator?: Maybe<SqlOperator>
  /** The value that is used for the condition. */
  value?: Maybe<Scalars['Mixed']>
  /** A set of conditions that requires all conditions to match. */
  AND?: Maybe<Array<WhereConditions>>
  /** A set of conditions that requires at least one condition to match. */
  OR?: Maybe<Array<WhereConditions>>
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: Maybe<WhereConditionsRelation>
};

/** Dynamic HAS conditions for WHERE condition queries. */
export type WhereConditionsRelation = {
  /** The relation that is checked. */
  relation: Scalars['String']
  /** The comparison operator to test against the amount. */
  operator?: Maybe<SqlOperator>
  /** The amount to test. */
  amount?: Maybe<Scalars['Int']>
  /** Additional condition logic. */
  condition?: Maybe<WhereConditions>
};

export type Workstation = {
  __typename?: 'Workstation'
  id: Scalars['ID']
  number: Scalars['String']
  description: Scalars['String']
  available: Scalars['Boolean']
  type: WorkstationType
  operator?: Maybe<User>
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
};

export enum WorkstationColumn {
  Id = 'ID',
  Number = 'NUMBER',
  Description = 'DESCRIPTION',
  Available = 'AVAILABLE',
  Type = 'type',
  CreatedAt = 'CREATED_AT'
}

/** A paginated list of Workstation items. */
export type WorkstationPaginator = {
  __typename?: 'WorkstationPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of Workstation items. */
  data: Array<Workstation>
};

export type WorkstationParam = {
  __typename?: 'WorkstationParam'
  id: Scalars['ID']
  name: Scalars['String']
  value: Scalars['String']
  created_at: Scalars['DateTime']
  updated_at: Scalars['DateTime']
  workstation: Workstation
};

export enum WorkstationType {
  Libert = 'Libert',
  Hgv = 'Hgv',
  Obu = 'Obu'
}

export type ZipcodesResponse = {
  __typename?: 'ZipcodesResponse'
  data: Array<AvailableZipcode>
  paginatorInfo: PaginatorInfo
};

export type ChangeTicketStatusMutationVariables = Exact<{
  ticketId: Scalars['ID']
  status: SupportTicketStatus
}>;

export type ChangeTicketStatusMutation = { __typename?: 'Mutation', updateTicketStatus: boolean };

export type CorrectPackageAddressMutationVariables = Exact<{
  package_id: Scalars['String']
  zipcode: Scalars['String']
  city: Scalars['String']
  country_iso_a2_code: Scalars['String']
  street_and_number: Scalars['String']
  secondary_street?: InputMaybe<Scalars['String']>
  company_name: Scalars['String']
  client_name: Scalars['String']
  phone: Scalars['String']
  should_bypass_address_validation: Scalars['Boolean']
}>;

export type CorrectPackageAddressMutation = { __typename?: 'Mutation', correctPackageAddress: AddressValidationResponse };

export type CreateTicketCommentMutationVariables = Exact<{
  ticketId: Scalars['ID']
  comment: Scalars['String']
  attachments?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>
}>;

export type CreateTicketCommentMutation = { __typename?: 'Mutation', createComment: boolean };

export type CreateRepresentantMutationVariables = Exact<{
  departmentIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  email: Scalars['String']
}>;

export type CreateRepresentantMutation = { __typename?: 'Mutation', createRepresentant: boolean };

export type CreateSupportTicketMutationVariables = Exact<{
  subject: Scalars['String']
  description: Scalars['String']
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  type?: InputMaybe<SupportTicketType>
  ref?: InputMaybe<Scalars['ID']>
  attachments?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>
}>;

export type CreateSupportTicketMutation = { __typename?: 'Mutation', createSupportTicket?: string | null };

export type DeleteRepresentantMutationVariables = Exact<{
  email: Scalars['String']
}>;

export type DeleteRepresentantMutation = { __typename?: 'Mutation', deleteRepresentant: boolean };

export type DeleteSupportTicketTagMutationVariables = Exact<{
  id: Scalars['ID']
}>;

export type DeleteSupportTicketTagMutation = { __typename?: 'Mutation', deleteSupportTicketTag?: { __typename?: 'SupportTicketTag', id: string, value: string, label_en: string, label_fr: string } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['Int']
}>;

export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'User', id: string, name: string, email: string, created_at: any, updated_at: any } | null };

export type EmailsWhoHaveSeenPackageQueryVariables = Exact<{
  id: Scalars['ID']
}>;

export type EmailsWhoHaveSeenPackageQuery = { __typename?: 'Query', emailsWhoHaveSeenPackage?: Array<string> | null };

export type FetchMeQueryVariables = Exact<{ [key: string]: never }>;

export type FetchMeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, email: string, created_at: any, updated_at: any, locale: string, contextDepartments?: Array<{ __typename?: 'Department', id: string, code?: string | null, label?: string | null, entity: { __typename?: 'Entity', id: string, name: string } } | null> | null, departments?: Array<{ __typename?: 'Department', id: string, code?: string | null, label?: string | null, address?: { __typename?: 'Address', id: string, country?: { __typename?: 'Country', id: string, name: string, iso_a2: string } | null } | null, entity: { __typename?: 'Entity', id: string, name: string } } | null> | null } };

export type FetchOrdersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<QueryOrdersOrderByOrderByClause> | QueryOrdersOrderByOrderByClause>
  where?: InputMaybe<QueryOrdersWhereWhereConditions>
  first: Scalars['Int']
  page: Scalars['Int']
}>;

export type FetchOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrderPaginator', data: Array<{ __typename?: 'Order', id: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type FetchSupportTicketsQueryVariables = Exact<{
  first: Scalars['Int']
  page: Scalars['Int']
  status?: InputMaybe<SupportTicketStatus>
  search?: InputMaybe<Scalars['String']>
  orderColumn?: InputMaybe<SupportTicketOrderColumn>
  orderType?: InputMaybe<SupportTicketOrderType>
  hideClosed?: InputMaybe<Scalars['Boolean']>
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  forCurrentUser?: InputMaybe<Scalars['Boolean']>
}>;

export type FetchSupportTicketsQuery = { __typename?: 'Query', getSupportTickets: { __typename?: 'SupportTicketPaginator', data: Array<{ __typename?: 'SupportTicket', id: string, title: string, body: string, public_token?: string | null, requester_id: number, team_id?: string | null, user_id?: string | null, status: SupportTicketStatus, priority?: number | null, level?: number | null, rating?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, subject?: string | null, summary?: string | null, requester: { __typename?: 'TicketRequester', id: string, name: string, email: string, created_at: any, updated_at: any, no_reply?: number | null } } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type FetchTicketQueryVariables = Exact<{
  id: Scalars['ID']
}>;

export type FetchTicketQuery = { __typename?: 'Query', viewTicket: { __typename?: 'SupportTicket', id: string, title: string, body: string, public_token?: string | null, requester_id: number, team_id?: string | null, user_id?: string | null, status: SupportTicketStatus, priority?: number | null, level?: number | null, rating?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, subject?: string | null, summary?: string | null, requester: { __typename?: 'TicketRequester', id: string, name: string, email: string, created_at: any, updated_at: any, no_reply?: number | null }, comments: Array<{ __typename?: 'TicketComment', id: string, ticket_id: string, user_id?: number | null, new_status: TicketCommentStatus, private?: boolean | null, body: string, created_at: any, updated_at: any, attachments: Array<{ __typename?: 'TicketAttachment', id: string, path: string, created_at: any, updated_at: any }>, author: { __typename?: 'Author', name: string, email: string } }>, tags: Array<{ __typename?: 'TicketTag', id: string, name: string, created_at: any, updated_at: any, pivot?: { __typename?: 'Pivot', taggable_id?: string | null, tag_id?: string | null, taggable_type?: string | null } | null }> } };

export type GetAvailableTicketsTagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>
}>;

export type GetAvailableTicketsTagsQuery = { __typename?: 'Query', getAvailableTicketsTags: Array<{ __typename?: 'AvailableSupportTicketTag', value: string, label: string, isContact?: boolean | null }> };

export type GetRepresentantByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>;

export type GetRepresentantByIdQuery = { __typename?: 'Query', getRepresentantById?: { __typename?: 'AddressValidationRepresentant', id: string, email: string, created_at: any, updated_at: any, department?: { __typename?: 'Department', id: string, code?: string | null } | null } | null };

export type GetRepresentantsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRepresentantsQuery = { __typename?: 'Query', getRepresentants: Array<{ __typename?: 'AddressValidationRepresentant', id: string, email: string, created_at: any, updated_at: any, department?: { __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } } | null }> };

export type GetSupportTicketTagByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>;

export type GetSupportTicketTagByIdQuery = { __typename?: 'Query', getSupportTicketTagById: { __typename?: 'SupportTicketTag', id: string, value: string, label_en: string, label_fr: string, supportTicketTagUserEmails?: Array<{ __typename?: 'SupportTicketTagUserEmail', id: string, user_email: string }> | null } };

export type GetSupportTicketsTagsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSupportTicketsTagsQuery = { __typename?: 'Query', getSupportTicketsTags: Array<{ __typename?: 'SupportTicketTag', id: string, value: string, label_en: string, label_fr: string, supportTicketTagUserEmails?: Array<{ __typename?: 'SupportTicketTagUserEmail', id: string, user_email: string }> | null }> };

export type GetTicketAttachmentUrlQueryVariables = Exact<{
  attachmentID: Scalars['ID']
  fileName: Scalars['String']
}>;

export type GetTicketAttachmentUrlQuery = { __typename?: 'Query', getTicketAttachmentURL: string };

export type GetTicketTokenQueryVariables = Exact<{
  id: Scalars['ID']
}>;

export type GetTicketTokenQuery = { __typename?: 'Query', getTicketToken: string };

export type GetTicketsCountQueryVariables = Exact<{
  status: SupportTicketStatus
  forCurrentUser: Scalars['Boolean']
}>;

export type GetTicketsCountQuery = { __typename?: 'Query', getTicketsCount: number };

export type GetUsersEmailQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersEmailQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, email: string }> } };

export type LoginMutationVariables = Exact<{
  input: LoginInput
}>;

export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', access_token?: string | null, refresh_token?: string | null, expires_in?: number | null, token_type?: string | null, user?: { __typename?: 'User', email: string, name: string, roles: Array<{ __typename?: 'UserRoles', id: string, name: UserRole } | null> } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', status: string, message?: string | null } };

export type RefreshAccessTokenMutationVariables = Exact<{
  input: RefreshTokenInput
}>;

export type RefreshAccessTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'RefreshTokenPayload', access_token: string, refresh_token: string, expires_in: number, token_type: string } };

export type RemoveMyDepartmentContextMutationVariables = Exact<{ [key: string]: never }>;

export type RemoveMyDepartmentContextMutation = { __typename?: 'Mutation', removeMyDepartmentContext: boolean };

export type SearchTicketOrderRefsQueryVariables = Exact<{
  type: SupportTicketType
  search: Scalars['String']
}>;

export type SearchTicketOrderRefsQuery = { __typename?: 'Query', searchTicketOrderRefs: Array<string | null> };

export type SetMyDepartmentsContextMutationVariables = Exact<{
  departmentIds: Array<Scalars['Int']> | Scalars['Int']
}>;

export type SetMyDepartmentsContextMutation = { __typename?: 'Mutation', setMyDepartmentsContext: boolean };

export type SetUserLocaleMutationVariables = Exact<{
  locale: Locale
}>;

export type SetUserLocaleMutation = { __typename?: 'Mutation', setUserLocale: boolean };

export type UpdatePackageImportanceMutationVariables = Exact<{
  id: Scalars['ID']
  importance: Scalars['Int']
}>;

export type UpdatePackageImportanceMutation = { __typename?: 'Mutation', updatePackageImportance: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePassword
}>;

export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'UpdatePasswordResponse', status: string, message?: string | null } };

export type UpdateRepresentantMutationVariables = Exact<{
  departmentIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  email: Scalars['String']
}>;

export type UpdateRepresentantMutation = { __typename?: 'Mutation', updateRepresentant?: boolean | null };

export type UpdateTicketTagsMutationVariables = Exact<{
  ticketId: Scalars['ID']
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>;

export type UpdateTicketTagsMutation = { __typename?: 'Mutation', updateTicketTags: boolean };

export type UpsertSupportTicketTagMutationVariables = Exact<{
  payload: UpsertSupportTicketTagPayload
}>;

export type UpsertSupportTicketTagMutation = { __typename?: 'Mutation', upsertSupportTicketTag: { __typename?: 'SupportTicketTag', id: string, value: string, label_en: string, label_fr: string, supportTicketTagUserEmails?: Array<{ __typename?: 'SupportTicketTagUserEmail', id: string, user_email: string }> | null } };

export type ManageAlertMutationVariables = Exact<{
  alert: Scalars['String']
  action: AlertReceiverAction
}>;

export type ManageAlertMutation = { __typename?: 'Mutation', manageAlert: boolean };

export type CreateAddressValidationCountryMutationVariables = Exact<{
  name: Scalars['String']
  alpha_two: Scalars['String']
  alpha_three: Scalars['String']
  code: Scalars['Int']
  unshippable: Scalars['Boolean']
}>;

export type CreateAddressValidationCountryMutation = { __typename?: 'Mutation', createAddressValidationCountry: { __typename?: 'AddressValidationCountry', id: string, name: string, alpha_two: string, alpha_three: string, code: number, unshippable: boolean } };

export type DeleteAddressValidationCountryMutationVariables = Exact<{
  id: Scalars['ID']
}>;

export type DeleteAddressValidationCountryMutation = { __typename?: 'Mutation', deleteAddressValidationCountry?: boolean | null };

export type UpdateAddressValidationCountryMutationVariables = Exact<{
  id: Scalars['ID']
  name: Scalars['String']
  alpha_two: Scalars['String']
  alpha_three: Scalars['String']
  code: Scalars['Int']
  unshippable: Scalars['Boolean']
}>;

export type UpdateAddressValidationCountryMutation = { __typename?: 'Mutation', updateAddressValidationCountry: { __typename?: 'AddressValidationCountry', id: string, name: string, alpha_two: string, alpha_three: string, code: number, unshippable: boolean } };

export type CreateDocumentTemplateMutationVariables = Exact<{
  for_languages?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  department_id: Scalars['ID']
  doc_type: DocType
  doc_flows: Array<Flow> | Flow
  doc_name: Scalars['String']
  description: Scalars['String']
  html: Scalars['String']
  default_for_department: Scalars['Boolean']
}>;

export type CreateDocumentTemplateMutation = { __typename?: 'Mutation', createDocTemplate: boolean };

export type DeleteDocumentTemplateMutationVariables = Exact<{
  id: Scalars['ID']
}>;

export type DeleteDocumentTemplateMutation = { __typename?: 'Mutation', deleteDocTemplate: boolean };

export type UpdateDocumentTemplateMutationVariables = Exact<{
  id: Scalars['ID']
  html: Scalars['String']
  description: Scalars['String']
  doc_flows: Array<Flow> | Flow
  default_for_department: Scalars['Boolean']
}>;

export type UpdateDocumentTemplateMutation = { __typename?: 'Mutation', updateDocTemplate: boolean };

export type ExportOrdersImportFilesMutationVariables = Exact<{
  orderBy?: InputMaybe<Array<MutationExportOrdersImportFilesOrderByOrderByClause> | MutationExportOrdersImportFilesOrderByOrderByClause>
  where?: InputMaybe<MutationExportOrdersImportFilesWhereWhereConditions>
}>;

export type ExportOrdersImportFilesMutation = { __typename?: 'Mutation', exportOrdersImportFiles: boolean };

export type ExportPackageItemsMutationVariables = Exact<{
  package_id: Scalars['ID']
}>;

export type ExportPackageItemsMutation = { __typename?: 'Mutation', exportPackageItems: boolean };

export type ExportDashboardDataMutationVariables = Exact<{
  startDate: Scalars['String']
  endDate: Scalars['String']
  packageType: Scalars['String']
  packageEntity: Scalars['String']
}>;

export type ExportDashboardDataMutation = { __typename?: 'Mutation', exportDashboardData: boolean };

export type ExportPackagesMutationVariables = Exact<{
  orderBy?: InputMaybe<Array<MutationExportPackagesOrderByOrderByClause> | MutationExportPackagesOrderByOrderByClause>
  where?: InputMaybe<MutationExportPackagesWhereWhereConditions>
  whereEntity?: InputMaybe<MutationExportPackagesWhereEntityWhereHasConditions>
  whereAddress?: InputMaybe<MutationExportPackagesWhereAddressWhereHasConditions>
}>;

export type ExportPackagesMutation = { __typename?: 'Mutation', exportPackages: boolean };

export type ExportPndPackagesMutationVariables = Exact<{
  orderBy?: InputMaybe<Array<MutationExportPndPackagesOrderByOrderByClause> | MutationExportPndPackagesOrderByOrderByClause>
  where?: InputMaybe<MutationExportPndPackagesWhereWhereConditions>
  pndFilter?: InputMaybe<PndFilterInput>
  whereEntity?: InputMaybe<MutationExportPndPackagesWhereEntityWhereHasConditions>
  whereAddress?: InputMaybe<MutationExportPndPackagesWhereAddressWhereHasConditions>
}>;

export type ExportPndPackagesMutation = { __typename?: 'Mutation', exportPndPackages: boolean };

export type SendPndRecycleRequestMutationVariables = Exact<{
  package_id: Scalars['ID']
  badges_to_recycle: Array<Scalars['String']> | Scalars['String']
}>;

export type SendPndRecycleRequestMutation = { __typename?: 'Mutation', sendPndRecycleRequest: boolean };

export type SendPndRequestMutationVariables = Exact<{
  package_id: Scalars['ID']
  reason: Scalars['String']
}>;

export type SendPndRequestMutation = { __typename?: 'Mutation', sendPndRequest: boolean };

export type SendPndResendRequestMutationVariables = Exact<{
  package_id: Scalars['ID']
  new_address: PndNewAddressInput
  additional_information?: InputMaybe<Scalars['String']>
}>;

export type SendPndResendRequestMutation = { __typename?: 'Mutation', sendPndResendRequest: boolean };

export type SendForgotPasswordOtpCodeMutationVariables = Exact<{
  email: Scalars['String']
}>;

export type SendForgotPasswordOtpCodeMutation = { __typename?: 'Mutation', sendForgotPasswordOtpCode: boolean };

export type UpdateForgottenPasswordMutationVariables = Exact<{
  input: UpdateForgottenPasswordInput
}>;

export type UpdateForgottenPasswordMutation = { __typename?: 'Mutation', updateForgottenPassword: boolean };

export type CreateUserMutationVariables = Exact<{
  name: Scalars['String']
  email: Scalars['String']
  password: Scalars['String']
  roles?: InputMaybe<UserRoleCreate>
}>;

export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, name: string, email: string, created_at: any, updated_at: any } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['Int']
  name: Scalars['String']
  email: Scalars['String']
  department_ids?: InputMaybe<Scalars['String']>
  context_department_ids?: InputMaybe<Scalars['String']>
  roles?: InputMaybe<UserRoleUpdate>
}>;

export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, name: string, email: string, created_at: any, updated_at: any, roles: Array<{ __typename?: 'UserRoles', id: string, name: UserRole } | null> } | null };

export type MyAlertsQueryVariables = Exact<{ [key: string]: never }>;

export type MyAlertsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRoles', id: string, name: UserRole } | null>, enabledAlerts: Array<{ __typename?: 'AlertReceiver', id: string, alert: string } | null> } };

export type GetAddressValidationCitiesQueryVariables = Exact<{
  country_iso_a2_code: Scalars['String']
  city: Scalars['String']
  take?: InputMaybe<Scalars['Int']>
  skip?: InputMaybe<Scalars['Int']>
}>;

export type GetAddressValidationCitiesQuery = { __typename?: 'Query', getAddressValidationCities?: Array<string> | null };

export type GetAddressValidationCountriesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>
  skip?: InputMaybe<Scalars['Int']>
}>;

export type GetAddressValidationCountriesQuery = { __typename?: 'Query', getAddressValidationCountries?: Array<{ __typename?: 'AddressValidationCountry', id: string, name: string, alpha_two: string, alpha_three: string, code: number, unshippable: boolean }> | null };

export type GetAddressValidationZipcodesQueryVariables = Exact<{
  country_iso_a2_code: Scalars['String']
  city: Scalars['String']
  take?: InputMaybe<Scalars['Int']>
  skip?: InputMaybe<Scalars['Int']>
}>;

export type GetAddressValidationZipcodesQuery = { __typename?: 'Query', getAddressValidationZipcodes: { __typename?: 'ZipcodesResponse', data: Array<{ __typename?: 'AvailableZipcode', zipcode_from: string, zipcode_to: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, hasMorePages: boolean, lastPage: number, perPage: number, total: number } } };

export type GetAllAddressValidationCountriesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>
  skip?: InputMaybe<Scalars['Int']>
}>;

export type GetAllAddressValidationCountriesQuery = { __typename?: 'Query', getAllAddressValidationCountries?: Array<{ __typename?: 'AddressValidationCountry', id: string, name: string, alpha_two: string, alpha_three: string, code: number, unshippable: boolean }> | null };

export type ValidateAddressQueryVariables = Exact<{
  zipcode: Scalars['String']
  city: Scalars['String']
  country_iso_a2_code: Scalars['String']
}>;

export type ValidateAddressQuery = { __typename?: 'Query', validateAddress: AddressValidationResponse };

export type IssuesQueryVariables = Exact<{
  tagName: Scalars['String']
  page?: InputMaybe<Scalars['Int']>
  perPage?: InputMaybe<Scalars['Int']>
}>;

export type IssuesQuery = { __typename?: 'Query', issues: { __typename?: 'IssuesResponse', nodes: Array<{ __typename?: 'Issue', id: string, title: string, author_name: string, web_url: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, hasMorePages: boolean, firstItem?: number | null, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ProjectTagsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>
  perPage?: InputMaybe<Scalars['Int']>
}>;

export type ProjectTagsQuery = { __typename?: 'Query', projectTags: { __typename?: 'ProjectTagsResponse', nodes: Array<{ __typename?: 'ProjectTag', id: string, name: string, createdAt: any }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, hasMorePages: boolean, firstItem?: number | null, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AllDepartmentsQueryVariables = Exact<{ [key: string]: never }>;

export type AllDepartmentsQuery = { __typename?: 'Query', allDepartments: Array<{ __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } }> };

export type DocumentTemplatesForDepartmentQueryVariables = Exact<{
  first: Scalars['Int']
  departmentId: Scalars['Mixed']
  documentType: Scalars['Mixed']
}>;

export type DocumentTemplatesForDepartmentQuery = { __typename?: 'Query', docTemplates: { __typename?: 'DocTemplatePaginator', data: Array<{ __typename?: 'DocTemplate', id: string, for_languages?: Array<string> | null }> } };

export type GetDocumentTemplateByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>;

export type GetDocumentTemplateByIdQuery = { __typename?: 'Query', docTemplate?: { __typename?: 'DocTemplate', id: string, for_languages?: Array<string> | null, flows: Array<Flow>, html: string, doc_type: DocType, doc_name: string, description: string, default_for_department: boolean, created_at: any, updated_at: any, department: { __typename?: 'Department', id: string, code?: string | null } } | null };

export type GetDocumentTemplatesListQueryVariables = Exact<{
  first: Scalars['Int']
  page?: InputMaybe<Scalars['Int']>
  where?: InputMaybe<QueryDocTemplatesWhereWhereConditions>
  orderBy?: InputMaybe<Array<QueryDocTemplatesOrderByRelationOrderByClause> | QueryDocTemplatesOrderByRelationOrderByClause>
}>;

export type GetDocumentTemplatesListQuery = { __typename?: 'Query', docTemplates: { __typename?: 'DocTemplatePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'DocTemplate', id: string, for_languages?: Array<string> | null, flows: Array<Flow>, doc_type: DocType, doc_name: string, description: string, created_at: any, updated_at: any, default_for_department: boolean, department: { __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } } }> } };

export type ExtraFileInfoQueryVariables = Exact<{
  page: Scalars['Int']
  first: Scalars['Int']
  where?: InputMaybe<QueryImportFilesWhereWhereConditions>
  orderBy?: InputMaybe<Array<QueryImportFilesOrderByOrderByClause> | QueryImportFilesOrderByOrderByClause>
}>;

export type ExtraFileInfoQuery = { __typename?: 'Query', importFiles: { __typename?: 'ImportFilePaginator', data: Array<{ __typename?: 'ImportFile', id: string, packagesCount: number, packageItemsCount: number, created_at: any, file?: { __typename?: 'File', id: string, filename: string } | null, packageItemsDistribution: Array<{ __typename?: 'PackageItemsPerDepartmentDistribution', departmentCode: string, packageItemsCount: number } | null> }> } };

export type FetchImportFilesQueryVariables = Exact<{
  page: Scalars['Int']
  first: Scalars['Int']
  where?: InputMaybe<QueryImportFilesWhereWhereConditions>
  orderBy?: InputMaybe<Array<QueryImportFilesOrderByOrderByClause> | QueryImportFilesOrderByOrderByClause>
}>;

export type FetchImportFilesQuery = { __typename?: 'Query', importFiles: { __typename?: 'ImportFilePaginator', data: Array<{ __typename?: 'ImportFile', id: string, d0278a_numfichea: string, d028x_crtfich: any, packagesCount: number, packageItemsCount: number, flows: Array<Flow>, entities: Array<string>, file?: { __typename?: 'File', id: string, filename: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

type ImportFilesTilePackagesFragmentHgvPackageFragment = { __typename?: 'HgvPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string } | { __typename?: 'HgvPackageItem', id: string } | { __typename?: 'SiemensPackageItem', id: string }> };

type ImportFilesTilePackagesFragmentLibertPackageFragment = { __typename?: 'LibertPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string } | { __typename?: 'HgvPackageItem', id: string } | { __typename?: 'SiemensPackageItem', id: string }> };

type ImportFilesTilePackagesFragmentSiemensPackageFragment = { __typename?: 'SiemensPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string } | { __typename?: 'HgvPackageItem', id: string } | { __typename?: 'SiemensPackageItem', id: string }> };

export type ImportFilesTilePackagesFragmentFragment = ImportFilesTilePackagesFragmentHgvPackageFragment | ImportFilesTilePackagesFragmentLibertPackageFragment | ImportFilesTilePackagesFragmentSiemensPackageFragment;

export type ImportFilesTilePreviewDataQueryVariables = Exact<{
  first: Scalars['Int']
  page?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<QueryImportFilesOrderByOrderByClause> | QueryImportFilesOrderByOrderByClause>
}>;

export type ImportFilesTilePreviewDataQuery = { __typename?: 'Query', importFiles: { __typename?: 'ImportFilePaginator', data: Array<{ __typename?: 'ImportFile', id: string, created_at: any, file?: { __typename?: 'File', id: string, filename: string } | null, packages: Array<{ __typename?: 'HgvPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem' } | { __typename?: 'HgvPackageItem', id: string } | { __typename?: 'SiemensPackageItem' }> } | { __typename?: 'LibertPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string } | { __typename?: 'HgvPackageItem' } | { __typename?: 'SiemensPackageItem' }> } | { __typename?: 'SiemensPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem' } | { __typename?: 'HgvPackageItem' } | { __typename?: 'SiemensPackageItem', id: string }> }> }> } };

type PackageWithPackageItemsBadgesFragmentHgvPackageItemFragment = { __typename?: 'HgvPackageItem', id: string, serial_number?: string | null, state: string, cm_16_4_road_traffic_indicator?: string | null, d0155_libniestam?: string | null, additional_notice?: string | null, pan?: string | null, packageItemApplications: Array<{ __typename?: 'PackageItemApplication', id: string, d0492_numtb?: string | null, d0493_rangtb?: string | null, cm_32?: string | null, packageItemApplicationMetaAttributes?: Array<{ __typename?: 'PackageItemApplicationMetaAttribute', key: string, value: string }> | null, application: { __typename?: 'Application', id: string, label?: string | null } }>, product: { __typename?: 'Product', id: string, cm_32_4_codclient?: string | null, productMetaAttributes: Array<{ __typename?: 'ProductMetaAttribute', key: string, value: string }> }, stockItem?: { __typename?: 'StockItem', id: string, details: Array<{ __typename?: 'StockItemDetail', id: string, attribute: string, value: string }> } | null };

type PackageWithPackageItemsBadgesFragmentLibertPackageItemFragment = { __typename?: 'LibertPackageItem', id: string, serial_number?: string | null, state: string, cm_16_4_road_traffic_indicator?: string | null, d0155_libniestam?: string | null, additional_notice?: string | null, pan?: string | null, packageItemApplications: Array<{ __typename?: 'PackageItemApplication', id: string, d0492_numtb?: string | null, d0493_rangtb?: string | null, cm_32?: string | null, packageItemApplicationMetaAttributes?: Array<{ __typename?: 'PackageItemApplicationMetaAttribute', key: string, value: string }> | null, application: { __typename?: 'Application', id: string, label?: string | null } }>, product: { __typename?: 'Product', id: string, cm_32_4_codclient?: string | null, productMetaAttributes: Array<{ __typename?: 'ProductMetaAttribute', key: string, value: string }> }, stockItem?: { __typename?: 'StockItem', id: string, details: Array<{ __typename?: 'StockItemDetail', id: string, attribute: string, value: string }> } | null };

type PackageWithPackageItemsBadgesFragmentSiemensPackageItemFragment = { __typename?: 'SiemensPackageItem', id: string, serial_number?: string | null, state: string, cm_16_4_road_traffic_indicator?: string | null, d0155_libniestam?: string | null, additional_notice?: string | null, pan?: string | null, packageItemApplications: Array<{ __typename?: 'PackageItemApplication', id: string, d0492_numtb?: string | null, d0493_rangtb?: string | null, cm_32?: string | null, packageItemApplicationMetaAttributes?: Array<{ __typename?: 'PackageItemApplicationMetaAttribute', key: string, value: string }> | null, application: { __typename?: 'Application', id: string, label?: string | null } }>, product: { __typename?: 'Product', id: string, cm_32_4_codclient?: string | null, productMetaAttributes: Array<{ __typename?: 'ProductMetaAttribute', key: string, value: string }> }, stockItem?: { __typename?: 'StockItem', id: string, details: Array<{ __typename?: 'StockItemDetail', id: string, attribute: string, value: string }> } | null };

export type PackageWithPackageItemsBadgesFragmentFragment = PackageWithPackageItemsBadgesFragmentHgvPackageItemFragment | PackageWithPackageItemsBadgesFragmentLibertPackageItemFragment | PackageWithPackageItemsBadgesFragmentSiemensPackageItemFragment;

export type PackageItemsListQueryVariables = Exact<{
  first: Scalars['Int']
  page?: InputMaybe<Scalars['Int']>
  where?: InputMaybe<QueryPackageItemsWhereWhereConditions>
}>;

export type PackageItemsListQuery = { __typename?: 'Query', packageItems: { __typename?: 'PackageItemPaginator', data: Array<{ __typename?: 'LibertPackageItem', id: string, serial_number?: string | null, state: string, cm_16_4_road_traffic_indicator?: string | null, d0155_libniestam?: string | null, additional_notice?: string | null, pan?: string | null, packageItemApplications: Array<{ __typename?: 'PackageItemApplication', id: string, d0492_numtb?: string | null, d0493_rangtb?: string | null, cm_32?: string | null, packageItemApplicationMetaAttributes?: Array<{ __typename?: 'PackageItemApplicationMetaAttribute', key: string, value: string }> | null, application: { __typename?: 'Application', id: string, label?: string | null } }>, product: { __typename?: 'Product', id: string, cm_32_4_codclient?: string | null, productMetaAttributes: Array<{ __typename?: 'ProductMetaAttribute', key: string, value: string }> }, stockItem?: { __typename?: 'StockItem', id: string, details: Array<{ __typename?: 'StockItemDetail', id: string, attribute: string, value: string }> } | null } | { __typename?: 'HgvPackageItem', id: string, serial_number?: string | null, state: string, cm_16_4_road_traffic_indicator?: string | null, d0155_libniestam?: string | null, additional_notice?: string | null, pan?: string | null, packageItemApplications: Array<{ __typename?: 'PackageItemApplication', id: string, d0492_numtb?: string | null, d0493_rangtb?: string | null, cm_32?: string | null, packageItemApplicationMetaAttributes?: Array<{ __typename?: 'PackageItemApplicationMetaAttribute', key: string, value: string }> | null, application: { __typename?: 'Application', id: string, label?: string | null } }>, product: { __typename?: 'Product', id: string, cm_32_4_codclient?: string | null, productMetaAttributes: Array<{ __typename?: 'ProductMetaAttribute', key: string, value: string }> }, stockItem?: { __typename?: 'StockItem', id: string, details: Array<{ __typename?: 'StockItemDetail', id: string, attribute: string, value: string }> } | null } | { __typename?: 'SiemensPackageItem', id: string, serial_number?: string | null, state: string, cm_16_4_road_traffic_indicator?: string | null, d0155_libniestam?: string | null, additional_notice?: string | null, pan?: string | null, packageItemApplications: Array<{ __typename?: 'PackageItemApplication', id: string, d0492_numtb?: string | null, d0493_rangtb?: string | null, cm_32?: string | null, packageItemApplicationMetaAttributes?: Array<{ __typename?: 'PackageItemApplicationMetaAttribute', key: string, value: string }> | null, application: { __typename?: 'Application', id: string, label?: string | null } }>, product: { __typename?: 'Product', id: string, cm_32_4_codclient?: string | null, productMetaAttributes: Array<{ __typename?: 'ProductMetaAttribute', key: string, value: string }> }, stockItem?: { __typename?: 'StockItem', id: string, details: Array<{ __typename?: 'StockItemDetail', id: string, attribute: string, value: string }> } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean } } };

export type PackageWithPackageItemsIdsQueryVariables = Exact<{
  first: Scalars['Int']
  wherePackageItems?: InputMaybe<QueryPackagesWherePackageItemsWhereHasConditions>
  where?: InputMaybe<QueryPackagesWhereWhereConditions>
}>;

export type PackageWithPackageItemsIdsQuery = { __typename?: 'Query', packages: { __typename?: 'PackagePaginator', data: Array<{ __typename?: 'HgvPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem' } | { __typename?: 'HgvPackageItem', id: string } | { __typename?: 'SiemensPackageItem' }> } | { __typename?: 'LibertPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string } | { __typename?: 'HgvPackageItem' } | { __typename?: 'SiemensPackageItem' }> } | { __typename?: 'SiemensPackage', id: string, packageItems: Array<{ __typename?: 'LibertPackageItem' } | { __typename?: 'HgvPackageItem' } | { __typename?: 'SiemensPackageItem', id: string }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number } } };

type PackageFragmentHgvPackageFragment = { __typename?: 'HgvPackage', id: string, importance: number, type: string, flow?: string | null, tam_correction_date?: any | null, cm_32_4_codclient?: string | null, d028x_crtfich: string, package_number: string, seenByEmails: Array<string | null>, state: string, transporteur?: string | null, d0278a_numfichea: string, ret003?: string | null, atlandes_client?: string | null, badgeCount: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } };

type PackageFragmentLibertPackageFragment = { __typename?: 'LibertPackage', id: string, importance: number, type: string, flow?: string | null, tam_correction_date?: any | null, cm_32_4_codclient?: string | null, d028x_crtfich: string, package_number: string, seenByEmails: Array<string | null>, state: string, transporteur?: string | null, d0278a_numfichea: string, ret003?: string | null, atlandes_client?: string | null, badgeCount: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } };

type PackageFragmentSiemensPackageFragment = { __typename?: 'SiemensPackage', id: string, importance: number, type: string, flow?: string | null, tam_correction_date?: any | null, cm_32_4_codclient?: string | null, d028x_crtfich: string, package_number: string, seenByEmails: Array<string | null>, state: string, transporteur?: string | null, d0278a_numfichea: string, ret003?: string | null, atlandes_client?: string | null, badgeCount: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } };

export type PackageFragmentFragment = PackageFragmentHgvPackageFragment | PackageFragmentLibertPackageFragment | PackageFragmentSiemensPackageFragment;

export type FetchPackagesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<QueryPackagesOrderByOrderByClause> | QueryPackagesOrderByOrderByClause>
  where?: InputMaybe<QueryPackagesWhereWhereConditions>
  whereEntity?: InputMaybe<QueryPackagesWhereEntityWhereHasConditions>
  whereAddress?: InputMaybe<QueryPackagesWhereAddressWhereHasConditions>
  first: Scalars['Int']
  page?: InputMaybe<Scalars['Int']>
}>;

export type FetchPackagesQuery = { __typename?: 'Query', packages: { __typename?: 'PackagePaginator', data: Array<{ __typename?: 'HgvPackage', id: string, importance: number, type: string, flow?: string | null, tam_correction_date?: any | null, cm_32_4_codclient?: string | null, d028x_crtfich: string, package_number: string, seenByEmails: Array<string | null>, state: string, transporteur?: string | null, d0278a_numfichea: string, ret003?: string | null, atlandes_client?: string | null, badgeCount: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } } | { __typename?: 'LibertPackage', id: string, importance: number, type: string, flow?: string | null, tam_correction_date?: any | null, cm_32_4_codclient?: string | null, d028x_crtfich: string, package_number: string, seenByEmails: Array<string | null>, state: string, transporteur?: string | null, d0278a_numfichea: string, ret003?: string | null, atlandes_client?: string | null, badgeCount: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } } | { __typename?: 'SiemensPackage', id: string, importance: number, type: string, flow?: string | null, tam_correction_date?: any | null, cm_32_4_codclient?: string | null, d028x_crtfich: string, package_number: string, seenByEmails: Array<string | null>, state: string, transporteur?: string | null, d0278a_numfichea: string, ret003?: string | null, atlandes_client?: string | null, badgeCount: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

type PndPackageFragmentHgvPackageFragment = { __typename?: 'HgvPackage', id: string, package_number: string, cm_32_4_codclient?: string | null, atlandes_client?: string | null, badgeCount: number, flow?: string | null, ret003?: string | null, state: string, pndSeenByEmails: Array<string | null>, date_first_expedition?: any | null, date_back_warehouse?: any | null, pnd_reason?: string | null, delay_days?: number | null, new_tracking?: string | null, original_tracking?: string | null, pnd_counter: number, address_correction_required: boolean, pnd_status?: PndStatus | null, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } };

type PndPackageFragmentLibertPackageFragment = { __typename?: 'LibertPackage', id: string, package_number: string, cm_32_4_codclient?: string | null, atlandes_client?: string | null, badgeCount: number, flow?: string | null, ret003?: string | null, state: string, pndSeenByEmails: Array<string | null>, date_first_expedition?: any | null, date_back_warehouse?: any | null, pnd_reason?: string | null, delay_days?: number | null, new_tracking?: string | null, original_tracking?: string | null, pnd_counter: number, address_correction_required: boolean, pnd_status?: PndStatus | null, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } };

type PndPackageFragmentSiemensPackageFragment = { __typename?: 'SiemensPackage', id: string, package_number: string, cm_32_4_codclient?: string | null, atlandes_client?: string | null, badgeCount: number, flow?: string | null, ret003?: string | null, state: string, pndSeenByEmails: Array<string | null>, date_first_expedition?: any | null, date_back_warehouse?: any | null, pnd_reason?: string | null, delay_days?: number | null, new_tracking?: string | null, original_tracking?: string | null, pnd_counter: number, address_correction_required: boolean, pnd_status?: PndStatus | null, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } };

export type PndPackageFragmentFragment = PndPackageFragmentHgvPackageFragment | PndPackageFragmentLibertPackageFragment | PndPackageFragmentSiemensPackageFragment;

export type FetchPndPackagesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<QueryPndPackagesOrderByOrderByClause> | QueryPndPackagesOrderByOrderByClause>
  where?: InputMaybe<QueryPndPackagesWhereWhereConditions>
  pndFilter?: InputMaybe<PndFilterInput>
  whereEntity?: InputMaybe<QueryPndPackagesWhereEntityWhereHasConditions>
  whereAddress?: InputMaybe<QueryPndPackagesWhereAddressWhereHasConditions>
  first: Scalars['Int']
  page?: InputMaybe<Scalars['Int']>
}>;

export type FetchPndPackagesQuery = { __typename?: 'Query', pndPackages: { __typename?: 'PackagePaginator', data: Array<{ __typename?: 'HgvPackage', id: string, package_number: string, cm_32_4_codclient?: string | null, atlandes_client?: string | null, badgeCount: number, flow?: string | null, ret003?: string | null, state: string, pndSeenByEmails: Array<string | null>, date_first_expedition?: any | null, date_back_warehouse?: any | null, pnd_reason?: string | null, delay_days?: number | null, new_tracking?: string | null, original_tracking?: string | null, pnd_counter: number, address_correction_required: boolean, pnd_status?: PndStatus | null, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } } | { __typename?: 'LibertPackage', id: string, package_number: string, cm_32_4_codclient?: string | null, atlandes_client?: string | null, badgeCount: number, flow?: string | null, ret003?: string | null, state: string, pndSeenByEmails: Array<string | null>, date_first_expedition?: any | null, date_back_warehouse?: any | null, pnd_reason?: string | null, delay_days?: number | null, new_tracking?: string | null, original_tracking?: string | null, pnd_counter: number, address_correction_required: boolean, pnd_status?: PndStatus | null, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } } | { __typename?: 'SiemensPackage', id: string, package_number: string, cm_32_4_codclient?: string | null, atlandes_client?: string | null, badgeCount: number, flow?: string | null, ret003?: string | null, state: string, pndSeenByEmails: Array<string | null>, date_first_expedition?: any | null, date_back_warehouse?: any | null, pnd_reason?: string | null, delay_days?: number | null, new_tracking?: string | null, original_tracking?: string | null, pnd_counter: number, address_correction_required: boolean, pnd_status?: PndStatus | null, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

type PackageByIdPackageItemsHgvPackageItemFragment = { __typename?: 'HgvPackageItem', id: string, pan?: string | null, fidu?: string | null };

type PackageByIdPackageItemsLibertPackageItemFragment = { __typename?: 'LibertPackageItem', id: string, pan?: string | null, fidu?: string | null };

type PackageByIdPackageItemsSiemensPackageItemFragment = { __typename?: 'SiemensPackageItem', id: string, pan?: string | null, fidu?: string | null };

export type PackageByIdPackageItemsFragment = PackageByIdPackageItemsHgvPackageItemFragment | PackageByIdPackageItemsLibertPackageItemFragment | PackageByIdPackageItemsSiemensPackageItemFragment;

type PackageByIdFragmentHgvPackageFragment = { __typename?: 'HgvPackage', id: string, importance: number, type: string, flow?: string | null, cm_32_4_codclient?: string | null, package_number: string, state: string, transporteur?: string | null, d0278a_numfichea: string, pnd_counter: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'HgvPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'SiemensPackageItem', id: string, pan?: string | null, fidu?: string | null }>, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, validation_response?: AddressValidationResponse | null, country?: { __typename?: 'Country', id: string, name: string, iso_a2: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string }, packageMetaAttributes?: Array<{ __typename?: 'PackageMetaAttribute', key: string, value: string }> | null };

type PackageByIdFragmentLibertPackageFragment = { __typename?: 'LibertPackage', id: string, importance: number, type: string, flow?: string | null, cm_32_4_codclient?: string | null, package_number: string, state: string, transporteur?: string | null, d0278a_numfichea: string, pnd_counter: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'HgvPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'SiemensPackageItem', id: string, pan?: string | null, fidu?: string | null }>, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, validation_response?: AddressValidationResponse | null, country?: { __typename?: 'Country', id: string, name: string, iso_a2: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string }, packageMetaAttributes?: Array<{ __typename?: 'PackageMetaAttribute', key: string, value: string }> | null };

type PackageByIdFragmentSiemensPackageFragment = { __typename?: 'SiemensPackage', id: string, importance: number, type: string, flow?: string | null, cm_32_4_codclient?: string | null, package_number: string, state: string, transporteur?: string | null, d0278a_numfichea: string, pnd_counter: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'HgvPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'SiemensPackageItem', id: string, pan?: string | null, fidu?: string | null }>, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, validation_response?: AddressValidationResponse | null, country?: { __typename?: 'Country', id: string, name: string, iso_a2: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string }, packageMetaAttributes?: Array<{ __typename?: 'PackageMetaAttribute', key: string, value: string }> | null };

export type PackageByIdFragmentFragment = PackageByIdFragmentHgvPackageFragment | PackageByIdFragmentLibertPackageFragment | PackageByIdFragmentSiemensPackageFragment;

export type PackageByIdQueryVariables = Exact<{
  id: Scalars['ID']
  viewScope?: InputMaybe<SeePackageScope>
}>;

export type PackageByIdQuery = { __typename?: 'Query', packageById?: { __typename?: 'HgvPackage', id: string, importance: number, type: string, flow?: string | null, cm_32_4_codclient?: string | null, package_number: string, state: string, transporteur?: string | null, d0278a_numfichea: string, pnd_counter: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'HgvPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'SiemensPackageItem', id: string, pan?: string | null, fidu?: string | null }>, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, validation_response?: AddressValidationResponse | null, country?: { __typename?: 'Country', id: string, name: string, iso_a2: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string }, packageMetaAttributes?: Array<{ __typename?: 'PackageMetaAttribute', key: string, value: string }> | null } | { __typename?: 'LibertPackage', id: string, importance: number, type: string, flow?: string | null, cm_32_4_codclient?: string | null, package_number: string, state: string, transporteur?: string | null, d0278a_numfichea: string, pnd_counter: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'HgvPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'SiemensPackageItem', id: string, pan?: string | null, fidu?: string | null }>, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, validation_response?: AddressValidationResponse | null, country?: { __typename?: 'Country', id: string, name: string, iso_a2: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string }, packageMetaAttributes?: Array<{ __typename?: 'PackageMetaAttribute', key: string, value: string }> | null } | { __typename?: 'SiemensPackage', id: string, importance: number, type: string, flow?: string | null, cm_32_4_codclient?: string | null, package_number: string, state: string, transporteur?: string | null, d0278a_numfichea: string, pnd_counter: number, department?: { __typename?: 'Department', id: string, code?: string | null, label?: string | null } | null, packageItems: Array<{ __typename?: 'LibertPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'HgvPackageItem', id: string, pan?: string | null, fidu?: string | null } | { __typename?: 'SiemensPackageItem', id: string, pan?: string | null, fidu?: string | null }>, address?: { __typename?: 'Address', id: string, company?: string | null, name?: string | null, street_1?: string | null, street_2?: string | null, street_3?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, validation_response?: AddressValidationResponse | null, country?: { __typename?: 'Country', id: string, name: string, iso_a2: string } | null } | null, entity: { __typename?: 'Entity', id: string, slug: string }, packageMetaAttributes?: Array<{ __typename?: 'PackageMetaAttribute', key: string, value: string }> | null } | null };

export type PackageByPackageNumberQueryVariables = Exact<{
  package_number: Scalars['String']
}>;

export type PackageByPackageNumberQuery = { __typename?: 'Query', packageByPackageNumber?: { __typename?: 'PackageByPackageNumberData', id: string, package_type: string, package_number: string, cm_32_4_codclient: string, atlandes_client_code?: string | null, flow: string, fidu?: Array<string | null> | null, pan?: Array<string | null> | null, shipped_at?: string | null, package_items_count: number, address: { __typename?: 'PackageByPackageNumberAddressData', name: string, company: string, street_1: string, street_2?: string | null, street_3?: string | null, zipcode: string, city: string, country: { __typename?: 'PackageByPackageNumberAddressCountryData', name: string } }, department: { __typename?: 'PackageByPackageNumberDepartmentData', code: string, label?: string | null } } | null };

export type PackagePndAdditionalInformationQueryVariables = Exact<{
  id: Scalars['ID']
}>;

export type PackagePndAdditionalInformationQuery = { __typename?: 'Query', packageById?: { __typename?: 'HgvPackage', id: string, pnd_resend_additional_information?: string | null } | { __typename?: 'LibertPackage', id: string, pnd_resend_additional_information?: string | null } | { __typename?: 'SiemensPackage', id: string, pnd_resend_additional_information?: string | null } | null };

export type PackageTimelineQueryVariables = Exact<{
  package_hash: Scalars['String']
}>;

export type PackageTimelineQuery = { __typename?: 'Query', packageTimeline: { __typename?: 'PackageTimelineData', id: string, entity_name: string, package_number: string, state: string, tracking_number?: string | null, tracking_url?: string | null, bypassed_real_address_validation: boolean, trackings: Array<{ __typename?: 'TrackingEntry', tracking_number: string, tracking_url?: string | null }>, timeline: { __typename?: 'PackageTimeline', received_at: any, address_validated_at?: any | null, address_corrected_at?: any | null, personalized_at?: any | null, in_transit_at?: any | null, delivered_at?: any | null, delivery_error_at?: any | null, pnd_history: Array<{ __typename?: 'PndHistoryData', id: string, old_state: PndHistoryState, new_state: PndHistoryState, created_at: any } | null> } } };

export type PackagesCarriersQueryVariables = Exact<{ [key: string]: never }>;

export type PackagesCarriersQuery = { __typename?: 'Query', packagesCarriers: Array<string> };

export type PackagesCountQueryVariables = Exact<{
  where?: InputMaybe<QueryPackagesWhereWhereConditions>
  whereEntity?: InputMaybe<QueryPackagesWhereEntityWhereHasConditions>
  whereAddress?: InputMaybe<QueryPackagesWhereAddressWhereHasConditions>
}>;

export type PackagesCountQuery = { __typename?: 'Query', packages: { __typename?: 'PackagePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, total: number } } };

export type AddressCorrectionTileStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type AddressCorrectionTileStatisticsQuery = { __typename?: 'Query', addressCorrectionTileStatistics: { __typename?: 'AddressCorrectionTileStatistics', as24: { __typename?: 'AddressCorrectionTileCategory', hgv: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number }, libert: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number }, obu: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number } }, total_energies: { __typename?: 'AddressCorrectionTileCategory', hgv: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number }, libert: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number }, obu: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number } }, circle_k: { __typename?: 'AddressCorrectionTileCategory', hgv: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number }, libert: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number }, obu: { __typename?: 'AddressCorrectionTileInfo', today: number, recent: number, older: number } } } };

export type CountryTrendsStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
}>;

export type CountryTrendsStatisticsQuery = { __typename?: 'Query', countryTrendsStatistics?: Array<{ __typename?: 'CountryTrendsStatistics', destination: string, percentage: string }> | null };

export type PackageAverageCorrectionTimeStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
}>;

export type PackageAverageCorrectionTimeStatisticsQuery = { __typename?: 'Query', packageAverageCorrectionTimeStatistics: number };

export type PackageAverageProcessingTimeStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
}>;

export type PackageAverageProcessingTimeStatisticsQuery = { __typename?: 'Query', packageAverageProcessingTimeStatistics: { __typename?: 'PackageAverageProcessingTimeStatistics', kapsch_packages_processing_average_time?: number | null, hgv_packages_processing_average_time?: number | null, libert_packages_processing_average_time?: number | null, siemens_packages_processing_average_time?: number | null } };

export type PackageItemsAvailableToPrepareStatisticsQueryVariables = Exact<{
  daysBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackageItemsAvailableToPrepareStatisticsQuery = { __typename?: 'Query', packageItemsAvailableToPrepareStatistics: { __typename?: 'PackageItemsAvailableToPrepareStatistics', hgv_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null, libert_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null, siemens_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null } };

export type PackageItemsAvailableToPrepareTodayStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackageItemsAvailableToPrepareTodayStatisticsQuery = { __typename?: 'Query', packageItemsAvailableToPrepareTodayStatistics: { __typename?: 'PackageItemsLiveIndicatorStatistics', hgv_package_items_count: number, libert_package_items_count: number, siemens_package_items_count: number } };

export type PackageItemsAwaitingAddressCorrectionStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackageItemsAwaitingAddressCorrectionStatisticsQuery = { __typename?: 'Query', packageItemsAwaitingAddressCorrectionStatistics: { __typename?: 'PackageItemsLiveIndicatorStatistics', hgv_package_items_count: number, libert_package_items_count: number, siemens_package_items_count: number } };

export type PackageItemsCountPerCountriesStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
}>;

export type PackageItemsCountPerCountriesStatisticsQuery = { __typename?: 'Query', packageItemsCountPerCountriesStatistics?: Array<{ __typename?: 'PackageItemsCountPerCountriesStatistics', destination_code: string, destination: string, hgv_package_items_count?: number | null, libert_package_items_count?: number | null, siemens_package_items_count?: number | null }> | null };

export type PackageItemsDailyProgressionStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
  monthsBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackageItemsDailyProgressionStatisticsQuery = { __typename?: 'Query', packageItemsDailyProgressionStatistics: { __typename?: 'PackageItemsDailyProgressionStatistics', hgv_daily_progression?: Array<{ __typename?: 'PackageItemsDailyProgressionStatisticsData', date: any, package_items_count: number }> | null, libert_daily_progression?: Array<{ __typename?: 'PackageItemsDailyProgressionStatisticsData', date: any, package_items_count: number }> | null, siemens_daily_progression?: Array<{ __typename?: 'PackageItemsDailyProgressionStatisticsData', date: any, package_items_count: number }> | null } };

export type PackageItemsPersonalizedStatisticsQueryVariables = Exact<{
  daysBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackageItemsPersonalizedStatisticsQuery = { __typename?: 'Query', packageItemsPersonalizedStatistics: { __typename?: 'PackageItemsPersonalizedStatistics', hgv_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null, libert_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null, siemens_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null } };

export type PackageItemsPersonalizedTodayStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackageItemsPersonalizedTodayStatisticsQuery = { __typename?: 'Query', packageItemsPersonalizedTodayStatistics: { __typename?: 'PackageItemsLiveIndicatorStatistics', hgv_package_items_count: number, libert_package_items_count: number, siemens_package_items_count: number } };

export type PackageItemsReceivedStatisticsQueryVariables = Exact<{
  daysBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackageItemsReceivedStatisticsQuery = { __typename?: 'Query', packageItemsReceivedStatistics: { __typename?: 'PackageItemsReceivedStatistics', hgv_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null, libert_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null, siemens_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null } };

export type PackageItemsReceivedTodayStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackageItemsReceivedTodayStatisticsQuery = { __typename?: 'Query', packageItemsReceivedTodayStatistics: { __typename?: 'PackageItemsLiveIndicatorStatistics', hgv_package_items_count: number, libert_package_items_count: number, siemens_package_items_count: number } };

export type PackageItemsRemainingStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackageItemsRemainingStatisticsQuery = { __typename?: 'Query', packageItemsRemainingStatistics: { __typename?: 'PackageItemsLiveIndicatorStatistics', hgv_package_items_count: number, libert_package_items_count: number, siemens_package_items_count: number } };

export type PackageItemsShippedPerCountryStatisticsQueryVariables = Exact<{
  year: Scalars['String']
  month?: InputMaybe<Scalars['String']>
}>;

export type PackageItemsShippedPerCountryStatisticsQuery = { __typename?: 'Query', packageItemsShippedPerCountryStatistics: { __typename?: 'PackageItemsShippedPerCountryStatistics', package_items_shipped_per_country: Array<{ __typename?: 'PackageItemsShippedInCountry', destination_code: string, destination_name: string, hgv_package_items: { __typename?: 'PackageItemsShippedPerEntity', package_items_count_for_total: number, package_items_count_for_as24: number }, libert_package_items: { __typename?: 'PackageItemsShippedPerEntity', package_items_count_for_total: number, package_items_count_for_as24: number }, siemens_package_items: { __typename?: 'PackageItemsShippedPerEntity', package_items_count_for_total: number, package_items_count_for_as24: number } }> } };

export type PackageItemsShippedStatisticsQueryVariables = Exact<{
  daysBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackageItemsShippedStatisticsQuery = { __typename?: 'Query', packageItemsShippedStatistics: { __typename?: 'PackageItemsShippedStatistics', hgv_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null, libert_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null, siemens_package_items?: Array<{ __typename?: 'PackageItemsStatisticsData', date: string, package_items_count_for_total_energies: number, package_items_count_for_as24: number, package_items_count_for_circlek: number }> | null } };

export type PackageItemsShippedTodayCountStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
}>;

export type PackageItemsShippedTodayCountStatisticsQuery = { __typename?: 'Query', packageItemsShippedTodayCountStatistics: { __typename?: 'PackageItemsShippedTodayCountStatistics', hgv_package_items?: { __typename?: 'PackageItemsShippedTodayCountStatisticsData', as24_count?: number | null, te_count?: number | null, all_count?: number | null } | null, libert_package_items?: { __typename?: 'PackageItemsShippedTodayCountStatisticsData', as24_count?: number | null, te_count?: number | null, all_count?: number | null } | null, siemens_package_items?: { __typename?: 'PackageItemsShippedTodayCountStatisticsData', as24_count?: number | null, te_count?: number | null, all_count?: number | null } | null } };

export type PackageItemsShippedTodayStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackageItemsShippedTodayStatisticsQuery = { __typename?: 'Query', packageItemsShippedTodayStatistics: { __typename?: 'PackageItemsLiveIndicatorStatistics', hgv_package_items_count: number, libert_package_items_count: number, siemens_package_items_count: number } };

export type PackagesAvailableToPrepareStatisticsQueryVariables = Exact<{
  daysBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackagesAvailableToPrepareStatisticsQuery = { __typename?: 'Query', packagesAvailableToPrepareStatistics: { __typename?: 'PackagesAvailableToPrepareStatistics', hgv_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null, libert_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null, siemens_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null } };

export type PackagesAvailableToPrepareTodayStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackagesAvailableToPrepareTodayStatisticsQuery = { __typename?: 'Query', packagesAvailableToPrepareTodayStatistics: { __typename?: 'PackagesLiveIndicatorStatistics', hgv_packages_count: number, libert_packages_count: number, siemens_packages_count: number } };

export type PackagesAwaitingAddressCorrectionStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackagesAwaitingAddressCorrectionStatisticsQuery = { __typename?: 'Query', packagesAwaitingAddressCorrectionStatistics: { __typename?: 'PackagesLiveIndicatorStatistics', hgv_packages_count: number, libert_packages_count: number, siemens_packages_count: number } };

export type PackagesCompletedStatisticsQueryVariables = Exact<{
  daysBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackagesCompletedStatisticsQuery = { __typename?: 'Query', packagesCompletedStatistics: { __typename?: 'PackagesCompletedStatistics', hgv_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null, libert_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null, siemens_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null } };

export type PackagesCompletedTodayStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackagesCompletedTodayStatisticsQuery = { __typename?: 'Query', packagesCompletedTodayStatistics: { __typename?: 'PackagesLiveIndicatorStatistics', hgv_packages_count: number, libert_packages_count: number, siemens_packages_count: number } };

export type PackagesCountPerCountriesStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
}>;

export type PackagesCountPerCountriesStatisticsQuery = { __typename?: 'Query', packagesCountPerCountriesStatistics?: Array<{ __typename?: 'PackagesCountPerCountriesStatistics', destination_code: string, destination: string, hgv_packages_count?: number | null, libert_packages_count?: number | null, siemens_packages_count?: number | null }> | null };

export type PackagesDailyAverageProcessingTimeStatisticsQueryVariables = Exact<{
  year: Scalars['String']
  month: Scalars['String']
}>;

export type PackagesDailyAverageProcessingTimeStatisticsQuery = { __typename?: 'Query', packagesDailyAverageProcessingTimeStatistics: { __typename?: 'PackagesDailyAverageProcessingTimeStatistics', daily_average_processing_time_hgv?: Array<{ __typename?: 'PackagesDailyAverageProcessingTimeStatisticsData', date: any, average_processing_time: number }> | null, daily_average_processing_time_libert?: Array<{ __typename?: 'PackagesDailyAverageProcessingTimeStatisticsData', date: any, average_processing_time: number }> | null, daily_average_processing_time_siemens?: Array<{ __typename?: 'PackagesDailyAverageProcessingTimeStatisticsData', date: any, average_processing_time: number }> | null } };

export type PackagesDailyProgressionStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
  monthsBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackagesDailyProgressionStatisticsQuery = { __typename?: 'Query', packagesDailyProgressionStatistics: { __typename?: 'PackagesDailyProgressionStatistics', hgv_daily_progression?: Array<{ __typename?: 'PackagesDailyProgressionStatisticsData', date: any, packages_count: number }> | null, libert_daily_progression?: Array<{ __typename?: 'PackagesDailyProgressionStatisticsData', date: any, packages_count: number }> | null, siemens_daily_progression?: Array<{ __typename?: 'PackagesDailyProgressionStatisticsData', date: any, packages_count: number }> | null } };

export type PackagesDailyShippedReceivedStatisticsQueryVariables = Exact<{
  year: Scalars['String']
  month: Scalars['String']
  entity?: InputMaybe<PackageEntity>
  type: PackageType
}>;

export type PackagesDailyShippedReceivedStatisticsQuery = { __typename?: 'Query', packagesDailyShippedReceivedStatistics: Array<{ __typename?: 'PackagesDailyShippedReceivedStatistics', date: string, package_daily_shipped_statistics: { __typename?: 'PackagesDailyShippedReceivedStatisticsData', AS24: number, TOTAL: number }, package_daily_received_statistics: { __typename?: 'PackagesDailyShippedReceivedStatisticsData', AS24: number, TOTAL: number } }> };

export type PackagesReceivedStatisticsQueryVariables = Exact<{
  daysBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackagesReceivedStatisticsQuery = { __typename?: 'Query', packagesReceivedStatistics: { __typename?: 'PackagesReceivedStatistics', hgv_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null, libert_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null, siemens_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null } };

export type PackagesReceivedTodayCountStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
}>;

export type PackagesReceivedTodayCountStatisticsQuery = { __typename?: 'Query', packagesReceivedTodayCountStatistics: { __typename?: 'PackagesReceivedTodayCountStatistics', hgv_packages?: { __typename?: 'PackagesReceivedTodayCountStatisticsData', total_count?: number | null, as24_count?: number | null, all_count?: number | null } | null, hgv_package_items?: { __typename?: 'PackagesReceivedTodayCountStatisticsData', total_count?: number | null, as24_count?: number | null, all_count?: number | null } | null, libert_packages?: { __typename?: 'PackagesReceivedTodayCountStatisticsData', total_count?: number | null, as24_count?: number | null, all_count?: number | null } | null, libert_package_items?: { __typename?: 'PackagesReceivedTodayCountStatisticsData', total_count?: number | null, as24_count?: number | null, all_count?: number | null } | null, siemens_packages?: { __typename?: 'PackagesReceivedTodayCountStatisticsData', total_count?: number | null, as24_count?: number | null, all_count?: number | null } | null, siemens_package_items?: { __typename?: 'PackagesReceivedTodayCountStatisticsData', total_count?: number | null, as24_count?: number | null, all_count?: number | null } | null, kapsch_packages?: { __typename?: 'PackagesReceivedTodayCountStatisticsData', total_count?: number | null, as24_count?: number | null, all_count?: number | null } | null, kapsch_package_items?: { __typename?: 'PackagesReceivedTodayCountStatisticsData', total_count?: number | null, as24_count?: number | null, all_count?: number | null } | null } };

export type PackagesReceivedTodayStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackagesReceivedTodayStatisticsQuery = { __typename?: 'Query', packagesReceivedTodayStatistics: { __typename?: 'PackagesLiveIndicatorStatistics', hgv_packages_count: number, libert_packages_count: number, siemens_packages_count: number } };

export type PackagesRemainingStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackagesRemainingStatisticsQuery = { __typename?: 'Query', packagesRemainingStatistics: { __typename?: 'PackagesLiveIndicatorStatistics', hgv_packages_count: number, libert_packages_count: number, siemens_packages_count: number } };

export type PackagesShippedStatisticsQueryVariables = Exact<{
  daysBefore?: InputMaybe<Scalars['Int']>
}>;

export type PackagesShippedStatisticsQuery = { __typename?: 'Query', packagesShippedStatistics: { __typename?: 'PackagesShippedStatistics', hgv_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null, libert_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null, siemens_packages?: Array<{ __typename?: 'PackagesStatisticsData', date: string, packages_count_for_total_energies: number, packages_count_for_as24: number, packages_count_for_circlek: number }> | null } };

export type PackagesShippedTodayCountStatisticsQueryVariables = Exact<{
  type?: InputMaybe<PackageType>
  entity?: InputMaybe<PackageEntity>
}>;

export type PackagesShippedTodayCountStatisticsQuery = { __typename?: 'Query', packagesShippedTodayCountStatistics: { __typename?: 'PackagesShippedTodayCountStatistics', hgv_packages?: { __typename?: 'PackagesShippedTodayCountStatisticsData', as24_count?: number | null, te_count?: number | null, all_count?: number | null } | null, libert_packages?: { __typename?: 'PackagesShippedTodayCountStatisticsData', as24_count?: number | null, te_count?: number | null, all_count?: number | null } | null, siemens_packages?: { __typename?: 'PackagesShippedTodayCountStatisticsData', as24_count?: number | null, te_count?: number | null, all_count?: number | null } | null } };

export type PackagesShippedTodayStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackagesShippedTodayStatisticsQuery = { __typename?: 'Query', packagesShippedTodayStatistics: { __typename?: 'PackagesLiveIndicatorStatistics', hgv_packages_count: number, libert_packages_count: number, siemens_packages_count: number } };

export type PackagesTileStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PackagesTileStatisticsQuery = { __typename?: 'Query', packagesTileStatistics: { __typename?: 'PackagesTileStatistics', packageStatistics: { __typename?: 'PackagesTilePackageStatistics', as24: { __typename?: 'PackagesTilePackageCategory', hgv: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number }, libert: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number }, obu: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number } }, total_energies: { __typename?: 'PackagesTilePackageCategory', hgv: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number }, libert: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number }, obu: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number } }, circle_k: { __typename?: 'PackagesTilePackageCategory', hgv: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number }, libert: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number }, obu: { __typename?: 'PackagesTilePackageInfo', completed: number, all: number } } }, packageItemStatistics: { __typename?: 'PackagesTilePackageItemStatistics', hgv: number, libert: number, obu: number } } };

export type PndTileStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type PndTileStatisticsQuery = { __typename?: 'Query', pndTileStatistics: { __typename?: 'PndTileStatistics', hgv: { __typename?: 'PndTileInfo', older: number, recent: number, today: number }, libert: { __typename?: 'PndTileInfo', older: number, recent: number, today: number }, obu: { __typename?: 'PndTileInfo', older: number, recent: number, today: number } } };

export type StocksStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type StocksStatisticsQuery = { __typename?: 'Query', stocksStatistics?: Array<{ __typename?: 'StocksStatistics', code_article: string, physical_stock: number, reserved_stock: number, available_stock: number }> | null };

export type TicketsStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type TicketsStatisticsQuery = { __typename?: 'Query', ticketsStatistics: { __typename?: 'TicketStatistics', average_lifespan_tickets: number, top_tagged_tickets: string, top_creator_tickets?: string | null, tag_counts: Array<{ __typename?: 'TicketTagCount', tag_name_tickets: string, tag_count_tickets: number } | null>, status_counts: { __typename?: 'TicketsPerStatusesCount', open_tickets: number, pending_tickets: number, closed_tickets: number, total_tickets: number }, progression_days: Array<{ __typename?: 'TicketsProgressionPerDay', date_tickets: string, no_tickets: number } | null> } };

export type CheckIfUserIsAuthenticatedQueryVariables = Exact<{ [key: string]: never }>;

export type CheckIfUserIsAuthenticatedQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string } };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['Int']
}>;

export type GetUserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, email: string, created_at: any, updated_at: any, roles: Array<{ __typename?: 'UserRoles', id: string, name: UserRole } | null> } | null };

export type GetUsersQueryVariables = Exact<{
  first: Scalars['Int']
  page?: InputMaybe<Scalars['Int']>
  where?: InputMaybe<QueryUsersWhereWhereConditions>
  whereRoles?: InputMaybe<QueryUsersWhereRolesWhereHasConditions>
  orderBy?: InputMaybe<Array<QueryUsersOrderByRelationOrderByClause> | QueryUsersOrderByRelationOrderByClause>
}>;

export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'User', id: string, name: string, email: string, locale: string, created_at: any, updated_at: any, roles: Array<{ __typename?: 'UserRoles', id: string, name: UserRole } | null> }> } };

export type MyRolesQueryVariables = Exact<{ [key: string]: never }>;

export type MyRolesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRoles', id: string, name: UserRole } | null> } };

export type RepresentantUserByIdDepartmentFragment = { __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } };

export type RepresentantUserByIdQueryVariables = Exact<{
  id: Scalars['Int']
}>;

export type RepresentantUserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, email: string, departments?: Array<{ __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } } | null> | null, contextDepartments?: Array<{ __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } } | null> | null } | null };

export type RepresentantUsersListDepartmentFragment = { __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } };

export type RepresentantUsersListQueryVariables = Exact<{
  first: Scalars['Int']
  page?: InputMaybe<Scalars['Int']>
  where?: InputMaybe<QueryUsersWhereWhereConditions>
  orderBy?: InputMaybe<Array<QueryUsersOrderByRelationOrderByClause> | QueryUsersOrderByRelationOrderByClause>
}>;

export type RepresentantUsersListQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'User', id: string, name: string, email: string, locale: string, departments?: Array<{ __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } } | null> | null, contextDepartments?: Array<{ __typename?: 'Department', id: string, code?: string | null, entity: { __typename?: 'Entity', id: string, name: string } } | null> | null }> } };

export type UserRolesQueryVariables = Exact<{ [key: string]: never }>;

export type UserRolesQuery = { __typename?: 'Query', userRoles: Array<{ __typename?: 'UserRoles', id: string, name: UserRole }> };

export type DocTemplateEventSubscriptionVariables = Exact<{ [key: string]: never }>;

export type DocTemplateEventSubscription = { __typename?: 'Subscription', docTemplateEvent?: { __typename?: 'DocTemplateEvent', id: string, event: DocTemplateEventKind, data?: { __typename?: 'DocTemplate', id: string, for_languages?: Array<string> | null, flows: Array<Flow>, doc_type: DocType, doc_name: string, description: string, default_for_department: boolean, created_at: any, updated_at: any, department: { __typename?: 'Department', id: string, code?: string | null } } | null } | null };

export type FileExportEventSubscriptionVariables = Exact<{ [key: string]: never }>;

export type FileExportEventSubscription = { __typename?: 'Subscription', fileExportEvent?: { __typename?: 'FileExportEvent', event: FileExportEventKind, url?: string | null } | null };

export type TicketCreatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TicketCreatedSubscription = { __typename?: 'Subscription', ticketCreated?: string | null };

export type TicketUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TicketUpdatedSubscription = { __typename?: 'Subscription', ticketUpdated?: string | null };

export type AlertConfirmedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type AlertConfirmedSubscription = { __typename?: 'Subscription', alertConfirmed?: { __typename?: 'AlertConfirmedEvent', id: string, action: AlertReceiverAction, alert: { __typename?: 'AlertReceiverSnapshot', alert: string } } | null };

export type PackagePndResultSubscriptionVariables = Exact<{ [key: string]: never }>;

export type PackagePndResultSubscription = { __typename?: 'Subscription', packagePndResult?: { __typename?: 'PackagePndResult', id: string, success: boolean, errorMessage?: string | null, event: PackagePndResultEvent, package: { __typename?: 'HgvPackage', id: string, package_number: string } | { __typename?: 'LibertPackage', id: string, package_number: string } | { __typename?: 'SiemensPackage', id: string, package_number: string } } | null };

export const ImportFilesTilePackagesFragment = gql`
    fragment ImportFilesTilePackagesFragment on PackageInterface {
  id
  packageItems {
    ... on LibertPackageItem {
      id
    }
    ... on HgvPackageItem {
      id
    }
    ... on SiemensPackageItem {
      id
    }
  }
}
    `
export const PackageWithPackageItemsBadgesFragment = gql`
    fragment PackageWithPackageItemsBadgesFragment on PackageItemInterface {
  id
  serial_number
  state
  cm_16_4_road_traffic_indicator
  d0155_libniestam
  additional_notice
  pan
  packageItemApplications {
    id
    d0492_numtb
    d0493_rangtb
    cm_32
    packageItemApplicationMetaAttributes {
      key
      value
    }
    application {
      id
      label
    }
  }
  product {
    id
    cm_32_4_codclient
    productMetaAttributes {
      key
      value
    }
  }
  stockItem {
    id
    details {
      id
      attribute
      value
    }
  }
}
    `
export const PackageFragment = gql`
    fragment PackageFragment on PackageInterface {
  id
  importance
  type
  flow
  department {
    id
    code
    label
  }
  tam_correction_date
  cm_32_4_codclient
  d028x_crtfich
  package_number
  seenByEmails
  address {
    id
    company
    name
    street_1
    street_2
    street_3
    zipcode
    city
    phone
    country {
      id
      name
    }
  }
  entity {
    id
    slug
  }
  state
  transporteur
  d0278a_numfichea
  ret003
  atlandes_client
  badgeCount
}
    `
export const PndPackageFragment = gql`
    fragment PndPackageFragment on PackageInterface {
  id
  package_number
  cm_32_4_codclient
  atlandes_client
  badgeCount
  flow
  department {
    id
    code
    label
  }
  ret003
  state
  pndSeenByEmails
  date_first_expedition
  date_back_warehouse
  pnd_reason
  delay_days
  new_tracking
  original_tracking
  pnd_counter
  address_correction_required
  pnd_status
  address {
    id
    company
    name
    street_1
    street_2
    street_3
    zipcode
    city
    phone
    country {
      id
      name
    }
  }
  entity {
    id
    slug
  }
}
    `
export const PackageByIdPackageItems = gql`
    fragment PackageByIdPackageItems on PackageItemInterface {
  id
  pan
  fidu
}
    `
export const PackageByIdFragment = gql`
    fragment PackageByIdFragment on PackageInterface {
  id
  importance
  type
  flow
  department {
    id
    code
    label
  }
  packageItems {
    ... on HgvPackageItem {
      ...PackageByIdPackageItems
    }
    ... on LibertPackageItem {
      ...PackageByIdPackageItems
    }
    ... on SiemensPackageItem {
      ...PackageByIdPackageItems
    }
  }
  cm_32_4_codclient
  package_number
  address {
    id
    company
    name
    street_1
    street_2
    street_3
    zipcode
    city
    phone
    validation_response
    country {
      id
      name
      iso_a2
    }
  }
  entity {
    id
    slug
  }
  state
  transporteur
  d0278a_numfichea
  pnd_counter
  packageMetaAttributes {
    key
    value
  }
}
    ${PackageByIdPackageItems}`
export const RepresentantUserByIdDepartment = gql`
    fragment RepresentantUserByIdDepartment on Department {
  id
  code
  entity {
    id
    name
  }
}
    `
export const RepresentantUsersListDepartment = gql`
    fragment RepresentantUsersListDepartment on Department {
  id
  code
  entity {
    id
    name
  }
}
    `
export const ChangeTicketStatusQuery = gql`
    mutation ChangeTicketStatus($ticketId: ID!, $status: SupportTicketStatus!) {
  updateTicketStatus(ticketId: $ticketId, status: $status)
}
    `
export const CorrectPackageAddressQuery = gql`
    mutation CorrectPackageAddress($package_id: String!, $zipcode: String!, $city: String!, $country_iso_a2_code: String!, $street_and_number: String!, $secondary_street: String, $company_name: String!, $client_name: String!, $phone: String!, $should_bypass_address_validation: Boolean!) {
  correctPackageAddress(
    package_id: $package_id
    zipcode: $zipcode
    city: $city
    country_iso_a2_code: $country_iso_a2_code
    street_and_number: $street_and_number
    secondary_street: $secondary_street
    company_name: $company_name
    client_name: $client_name
    phone: $phone
    should_bypass_address_validation: $should_bypass_address_validation
  )
}
    `
export const CreateTicketCommentQuery = gql`
    mutation createTicketComment($ticketId: ID!, $comment: String!, $attachments: [Upload!]) {
  createComment(ticketId: $ticketId, comment: $comment, attachments: $attachments)
}
    `
export const CreateRepresentantQuery = gql`
    mutation CreateRepresentant($departmentIds: [String!], $email: String!) {
  createRepresentant(email: $email, departmentIds: $departmentIds)
}
    `
export const CreateSupportTicketQuery = gql`
    mutation createSupportTicket($subject: String!, $description: String!, $tags: [String!], $type: SupportTicketType, $ref: ID, $attachments: [Upload!]) {
  createSupportTicket(
    subject: $subject
    description: $description
    tags: $tags
    type: $type
    ref: $ref
    attachments: $attachments
  )
}
    `
export const DeleteRepresentantQuery = gql`
    mutation DeleteRepresentant($email: String!) {
  deleteRepresentant(email: $email)
}
    `
export const DeleteSupportTicketTagQuery = gql`
    mutation deleteSupportTicketTag($id: ID!) {
  deleteSupportTicketTag(id: $id) {
    id
    value
    label_en
    label_fr
  }
}
    `
export const DeleteUserQuery = gql`
    mutation DeleteUser($id: Int!) {
  deleteUser(id: $id) {
    id
    name
    email
    created_at
    updated_at
  }
}
    `
export const EmailsWhoHaveSeenPackageQuery = gql`
    query EmailsWhoHaveSeenPackage($id: ID!) {
  emailsWhoHaveSeenPackage(id: $id)
}
    `
export const FetchMeQuery = gql`
    query FetchMe {
  me {
    id
    name
    email
    created_at
    updated_at
    locale
    contextDepartments {
      id
      code
      label
      entity {
        id
        name
      }
    }
    departments {
      id
      code
      label
      address {
        id
        country {
          id
          name
          iso_a2
        }
      }
      entity {
        id
        name
      }
    }
  }
}
    `
export const FetchOrdersQuery = gql`
    query FetchOrders($orderBy: [QueryOrdersOrderByOrderByClause!], $where: QueryOrdersWhereWhereConditions, $first: Int!, $page: Int!) {
  orders(orderBy: $orderBy, where: $where, page: $page, first: $first) {
    data {
      id
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `
export const FetchSupportTicketsQuery = gql`
    query FetchSupportTickets($first: Int!, $page: Int!, $status: SupportTicketStatus, $search: String, $orderColumn: SupportTicketOrderColumn, $orderType: SupportTicketOrderType, $hideClosed: Boolean, $tags: [String!], $forCurrentUser: Boolean) {
  getSupportTickets(
    status: $status
    search: $search
    first: $first
    page: $page
    orderColumn: $orderColumn
    orderType: $orderType
    hideClosed: $hideClosed
    tags: $tags
    forCurrentUser: $forCurrentUser
  ) {
    data {
      id
      title
      body
      public_token
      requester_id
      team_id
      user_id
      status
      priority
      level
      rating
      created_at
      updated_at
      deleted_at
      subject
      summary
      requester {
        id
        name
        email
        created_at
        updated_at
        no_reply
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `
export const FetchTicketQuery = gql`
    query FetchTicket($id: ID!) {
  viewTicket(id: $id) {
    id
    title
    body
    public_token
    requester_id
    team_id
    user_id
    status
    priority
    level
    rating
    created_at
    updated_at
    deleted_at
    subject
    summary
    requester {
      id
      name
      email
      created_at
      updated_at
      no_reply
    }
    comments {
      id
      attachments {
        id
        path
        created_at
        updated_at
      }
      ticket_id
      user_id
      new_status
      private
      body
      created_at
      updated_at
      author {
        name
        email
      }
      attachments {
        id
        path
        created_at
      }
    }
    tags {
      id
      name
      created_at
      updated_at
      pivot {
        taggable_id
        tag_id
        taggable_type
      }
    }
  }
}
    `
export const GetAvailableTicketsTagsQuery = gql`
    query GetAvailableTicketsTags($search: String) {
  getAvailableTicketsTags(search: $search) {
    value
    label
    isContact
  }
}
    `
export const GetRepresentantByIdQuery = gql`
    query GetRepresentantById($id: ID!) {
  getRepresentantById(id: $id) {
    id
    email
    created_at
    updated_at
    department {
      id
      code
    }
  }
}
    `
export const GetRepresentantsQuery = gql`
    query GetRepresentants {
  getRepresentants {
    id
    email
    created_at
    updated_at
    department {
      id
      code
      entity {
        id
        name
      }
    }
  }
}
    `
export const GetSupportTicketTagByIdQuery = gql`
    query GetSupportTicketTagById($id: ID!) {
  getSupportTicketTagById(id: $id) {
    id
    value
    label_en
    label_fr
    supportTicketTagUserEmails {
      id
      user_email
    }
  }
}
    `
export const GetSupportTicketsTagsQuery = gql`
    query GetSupportTicketsTags {
  getSupportTicketsTags {
    id
    value
    label_en
    label_fr
    supportTicketTagUserEmails {
      id
      user_email
    }
  }
}
    `
export const GetTicketAttachmentUrlQuery = gql`
    query GetTicketAttachmentURL($attachmentID: ID!, $fileName: String!) {
  getTicketAttachmentURL(attachmentID: $attachmentID, fileName: $fileName)
}
    `
export const GetTicketTokenQuery = gql`
    query GetTicketToken($id: ID!) {
  getTicketToken(id: $id)
}
    `
export const GetTicketsCountQuery = gql`
    query GetTicketsCount($status: SupportTicketStatus!, $forCurrentUser: Boolean!) {
  getTicketsCount(status: $status, forCurrentUser: $forCurrentUser)
}
    `
export const GetUsersEmailQuery = gql`
    query GetUsersEmail {
  users(first: 100) {
    data {
      id
      email
    }
  }
}
    `
export const LoginQuery = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    access_token
    refresh_token
    expires_in
    token_type
    user {
      email
      name
      roles {
        id
        name
      }
    }
  }
}
    `
export const LogoutQuery = gql`
    mutation Logout {
  logout {
    status
    message
  }
}
    `
export const RefreshAccessTokenQuery = gql`
    mutation RefreshAccessToken($input: RefreshTokenInput!) {
  refreshToken(input: $input) {
    access_token
    refresh_token
    expires_in
    token_type
  }
}
    `
export const RemoveMyDepartmentContextQuery = gql`
    mutation RemoveMyDepartmentContext {
  removeMyDepartmentContext
}
    `
export const SearchTicketOrderRefsQuery = gql`
    query SearchTicketOrderRefs($type: SupportTicketType!, $search: String!) {
  searchTicketOrderRefs(type: $type, search: $search)
}
    `
export const SetMyDepartmentsContextQuery = gql`
    mutation SetMyDepartmentsContext($departmentIds: [Int!]!) {
  setMyDepartmentsContext(departmentIds: $departmentIds)
}
    `
export const SetUserLocaleQuery = gql`
    mutation setUserLocale($locale: Locale!) {
  setUserLocale(locale: $locale)
}
    `
export const UpdatePackageImportanceQuery = gql`
    mutation UpdatePackageImportance($id: ID!, $importance: Int!) {
  updatePackageImportance(id: $id, importance: $importance)
}
    `
export const UpdatePasswordQuery = gql`
    mutation UpdatePassword($input: UpdatePassword!) {
  updatePassword(input: $input) {
    status
    message
  }
}
    `
export const UpdateRepresentantQuery = gql`
    mutation UpdateRepresentant($departmentIds: [String!], $email: String!) {
  updateRepresentant(email: $email, departmentIds: $departmentIds)
}
    `
export const UpdateTicketTagsQuery = gql`
    mutation updateTicketTags($ticketId: ID!, $tags: [String!]) {
  updateTicketTags(ticketId: $ticketId, tags: $tags)
}
    `
export const UpsertSupportTicketTagQuery = gql`
    mutation UpsertSupportTicketTag($payload: UpsertSupportTicketTagPayload!) {
  upsertSupportTicketTag(payload: $payload) {
    id
    value
    label_en
    label_fr
    supportTicketTagUserEmails {
      id
      user_email
    }
  }
}
    `
export const ManageAlertQuery = gql`
    mutation manageAlert($alert: String!, $action: AlertReceiverAction!) {
  manageAlert(alert: $alert, action: $action)
}
    `
export const CreateAddressValidationCountryQuery = gql`
    mutation CreateAddressValidationCountry($name: String!, $alpha_two: String!, $alpha_three: String!, $code: Int!, $unshippable: Boolean!) {
  createAddressValidationCountry(
    name: $name
    alpha_two: $alpha_two
    alpha_three: $alpha_three
    code: $code
    unshippable: $unshippable
  ) {
    id
    name
    alpha_two
    alpha_three
    code
    unshippable
  }
}
    `
export const DeleteAddressValidationCountryQuery = gql`
    mutation DeleteAddressValidationCountry($id: ID!) {
  deleteAddressValidationCountry(id: $id)
}
    `
export const UpdateAddressValidationCountryQuery = gql`
    mutation UpdateAddressValidationCountry($id: ID!, $name: String!, $alpha_two: String!, $alpha_three: String!, $code: Int!, $unshippable: Boolean!) {
  updateAddressValidationCountry(
    id: $id
    name: $name
    alpha_two: $alpha_two
    alpha_three: $alpha_three
    code: $code
    unshippable: $unshippable
  ) {
    id
    name
    alpha_two
    alpha_three
    code
    unshippable
  }
}
    `
export const CreateDocumentTemplateQuery = gql`
    mutation CreateDocumentTemplate($for_languages: [String!], $department_id: ID!, $doc_type: DocType!, $doc_flows: [Flow!]!, $doc_name: String!, $description: String!, $html: String!, $default_for_department: Boolean!) {
  createDocTemplate(
    for_languages: $for_languages
    department_id: $department_id
    doc_type: $doc_type
    doc_flows: $doc_flows
    doc_name: $doc_name
    description: $description
    html: $html
    default_for_department: $default_for_department
  )
}
    `
export const DeleteDocumentTemplateQuery = gql`
    mutation DeleteDocumentTemplate($id: ID!) {
  deleteDocTemplate(id: $id)
}
    `
export const UpdateDocumentTemplateQuery = gql`
    mutation UpdateDocumentTemplate($id: ID!, $html: String!, $description: String!, $doc_flows: [Flow!]!, $default_for_department: Boolean!) {
  updateDocTemplate(
    id: $id
    html: $html
    description: $description
    doc_flows: $doc_flows
    default_for_department: $default_for_department
  )
}
    `
export const ExportOrdersImportFilesQuery = gql`
    mutation ExportOrdersImportFiles($orderBy: [MutationExportOrdersImportFilesOrderByOrderByClause!], $where: MutationExportOrdersImportFilesWhereWhereConditions) {
  exportOrdersImportFiles(orderBy: $orderBy, where: $where)
}
    `
export const ExportPackageItemsQuery = gql`
    mutation ExportPackageItems($package_id: ID!) {
  exportPackageItems(package_id: $package_id)
}
    `
export const ExportDashboardDataQuery = gql`
    mutation exportDashboardData($startDate: String!, $endDate: String!, $packageType: String!, $packageEntity: String!) {
  exportDashboardData(
    startDate: $startDate
    endDate: $endDate
    packageType: $packageType
    packageEntity: $packageEntity
  )
}
    `
export const ExportPackagesQuery = gql`
    mutation ExportPackages($orderBy: [MutationExportPackagesOrderByOrderByClause!], $where: MutationExportPackagesWhereWhereConditions, $whereEntity: MutationExportPackagesWhereEntityWhereHasConditions, $whereAddress: MutationExportPackagesWhereAddressWhereHasConditions) {
  exportPackages(
    orderBy: $orderBy
    where: $where
    whereEntity: $whereEntity
    whereAddress: $whereAddress
  )
}
    `
export const ExportPndPackagesQuery = gql`
    mutation ExportPndPackages($orderBy: [MutationExportPndPackagesOrderByOrderByClause!], $where: MutationExportPndPackagesWhereWhereConditions, $pndFilter: PndFilterInput, $whereEntity: MutationExportPndPackagesWhereEntityWhereHasConditions, $whereAddress: MutationExportPndPackagesWhereAddressWhereHasConditions) {
  exportPndPackages(
    orderBy: $orderBy
    where: $where
    pndFilter: $pndFilter
    whereEntity: $whereEntity
    whereAddress: $whereAddress
  )
}
    `
export const SendPndRecycleRequestQuery = gql`
    mutation SendPndRecycleRequest($package_id: ID!, $badges_to_recycle: [String!]!) {
  sendPndRecycleRequest(
    package_id: $package_id
    badges_to_recycle: $badges_to_recycle
  )
}
    `
export const SendPndRequestQuery = gql`
    mutation SendPndRequest($package_id: ID!, $reason: String!) {
  sendPndRequest(package_id: $package_id, reason: $reason)
}
    `
export const SendPndResendRequestQuery = gql`
    mutation SendPndResendRequest($package_id: ID!, $new_address: PndNewAddressInput!, $additional_information: String) {
  sendPndResendRequest(
    package_id: $package_id
    new_address: $new_address
    additional_information: $additional_information
  )
}
    `
export const SendForgotPasswordOtpCodeQuery = gql`
    mutation SendForgotPasswordOtpCode($email: String!) {
  sendForgotPasswordOtpCode(email: $email)
}
    `
export const UpdateForgottenPasswordQuery = gql`
    mutation updateForgottenPassword($input: UpdateForgottenPasswordInput!) {
  updateForgottenPassword(input: $input)
}
    `
export const CreateUserQuery = gql`
    mutation CreateUser($name: String!, $email: String!, $password: String!, $roles: UserRoleCreate) {
  createUser(name: $name, email: $email, password: $password, roles: $roles) {
    id
    name
    email
    created_at
    updated_at
  }
}
    `
export const UpdateUserQuery = gql`
    mutation UpdateUser($id: Int!, $name: String!, $email: String!, $department_ids: String, $context_department_ids: String, $roles: UserRoleUpdate) {
  updateUser(
    id: $id
    name: $name
    email: $email
    department_ids: $department_ids
    context_department_ids: $context_department_ids
    roles: $roles
  ) {
    id
    name
    email
    created_at
    updated_at
    roles {
      id
      name
    }
  }
}
    `
export const MyAlertsQuery = gql`
    query myAlerts {
  me {
    id
    roles {
      id
      name
    }
    enabledAlerts {
      id
      alert
    }
  }
}
    `
export const GetAddressValidationCitiesQuery = gql`
    query GetAddressValidationCities($country_iso_a2_code: String!, $city: String!, $take: Int, $skip: Int) {
  getAddressValidationCities(
    country_iso_a2_code: $country_iso_a2_code
    city: $city
    take: $take
    skip: $skip
  )
}
    `
export const GetAddressValidationCountriesQuery = gql`
    query GetAddressValidationCountries($take: Int, $skip: Int) {
  getAddressValidationCountries(take: $take, skip: $skip) {
    id
    name
    alpha_two
    alpha_three
    code
    unshippable
  }
}
    `
export const GetAddressValidationZipcodesQuery = gql`
    query GetAddressValidationZipcodes($country_iso_a2_code: String!, $city: String!, $take: Int, $skip: Int) {
  getAddressValidationZipcodes(
    country_iso_a2_code: $country_iso_a2_code
    city: $city
    take: $take
    skip: $skip
  ) {
    data {
      zipcode_from
      zipcode_to
    }
    paginatorInfo {
      count
      currentPage
      hasMorePages
      lastPage
      perPage
      total
    }
  }
}
    `
export const GetAllAddressValidationCountriesQuery = gql`
    query GetAllAddressValidationCountries($take: Int, $skip: Int) {
  getAllAddressValidationCountries(take: $take, skip: $skip) {
    id
    name
    alpha_two
    alpha_three
    code
    unshippable
  }
}
    `
export const ValidateAddressQuery = gql`
    query validateAddress($zipcode: String!, $city: String!, $country_iso_a2_code: String!) {
  validateAddress(
    zipcode: $zipcode
    city: $city
    country_iso_a2_code: $country_iso_a2_code
  )
}
    `
export const IssuesQuery = gql`
    query issues($tagName: String!, $page: Int, $perPage: Int) {
  issues(tagName: $tagName, page: $page, perPage: $perPage) {
    nodes {
      id
      title
      author_name
      web_url
    }
    paginatorInfo {
      count
      currentPage
      hasMorePages
      firstItem
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `
export const ProjectTagsQuery = gql`
    query projectTags($page: Int, $perPage: Int) {
  projectTags(page: $page, perPage: $perPage) {
    nodes {
      id
      name
      createdAt
    }
    paginatorInfo {
      count
      currentPage
      hasMorePages
      firstItem
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `
export const AllDepartmentsQuery = gql`
    query AllDepartments {
  allDepartments {
    id
    code
    entity {
      id
      name
    }
  }
}
    `
export const DocumentTemplatesForDepartmentQuery = gql`
    query DocumentTemplatesForDepartment($first: Int!, $departmentId: Mixed!, $documentType: Mixed!) {
  docTemplates(
    first: $first
    where: {AND: [{column: DEPARTMENT_ID, value: $departmentId}, {column: DOC_TYPE, value: $documentType}]}
  ) {
    data {
      id
      for_languages
    }
  }
}
    `
export const GetDocumentTemplateByIdQuery = gql`
    query GetDocumentTemplateById($id: ID!) {
  docTemplate(id: $id) {
    id
    department {
      id
      code
    }
    for_languages
    flows
    html
    doc_type
    doc_name
    description
    default_for_department
    created_at
    updated_at
  }
}
    `
export const GetDocumentTemplatesListQuery = gql`
    query GetDocumentTemplatesList($first: Int!, $page: Int, $where: QueryDocTemplatesWhereWhereConditions, $orderBy: [QueryDocTemplatesOrderByRelationOrderByClause!]) {
  docTemplates(first: $first, page: $page, where: $where, orderBy: $orderBy) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      id
      department {
        id
        code
        entity {
          id
          name
        }
      }
      for_languages
      flows
      doc_type
      doc_name
      description
      created_at
      updated_at
      default_for_department
    }
  }
}
    `
export const ExtraFileInfoQuery = gql`
    query ExtraFileInfo($page: Int!, $first: Int!, $where: QueryImportFilesWhereWhereConditions, $orderBy: [QueryImportFilesOrderByOrderByClause!]) {
  importFiles(page: $page, first: $first, where: $where, orderBy: $orderBy) {
    data {
      id
      file {
        id
        filename
      }
      packageItemsDistribution {
        departmentCode
        packageItemsCount
      }
      packagesCount
      packageItemsCount
      created_at
    }
  }
}
    `
export const FetchImportFilesQuery = gql`
    query FetchImportFiles($page: Int!, $first: Int!, $where: QueryImportFilesWhereWhereConditions, $orderBy: [QueryImportFilesOrderByOrderByClause!]) {
  importFiles(page: $page, first: $first, where: $where, orderBy: $orderBy) {
    data {
      id
      d0278a_numfichea
      d028x_crtfich
      file {
        id
        filename
      }
      packagesCount
      packageItemsCount
      flows
      entities
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `
export const ImportFilesTilePreviewDataQuery = gql`
    query ImportFilesTilePreviewData($first: Int!, $page: Int, $orderBy: [QueryImportFilesOrderByOrderByClause!]) {
  importFiles(first: $first, page: $page, orderBy: $orderBy) {
    data {
      id
      file {
        id
        filename
      }
      packages {
        ... on LibertPackage {
          id
          packageItems {
            ... on LibertPackageItem {
              id
            }
          }
        }
        ... on HgvPackage {
          id
          packageItems {
            ... on HgvPackageItem {
              id
            }
          }
        }
        ... on SiemensPackage {
          id
          packageItems {
            ... on SiemensPackageItem {
              id
            }
          }
        }
      }
      created_at
    }
  }
}
    `
export const PackageItemsListQuery = gql`
    query PackageItemsList($first: Int!, $page: Int, $where: QueryPackageItemsWhereWhereConditions) {
  packageItems(first: $first, where: $where, page: $page) {
    data {
      ... on HgvPackageItem {
        ...PackageWithPackageItemsBadgesFragment
      }
      ... on LibertPackageItem {
        ...PackageWithPackageItemsBadgesFragment
      }
      ... on SiemensPackageItem {
        ...PackageWithPackageItemsBadgesFragment
      }
    }
    paginatorInfo {
      hasMorePages
    }
  }
}
    ${PackageWithPackageItemsBadgesFragment}`
export const PackageWithPackageItemsIdsQuery = gql`
    query PackageWithPackageItemsIds($first: Int!, $wherePackageItems: QueryPackagesWherePackageItemsWhereHasConditions, $where: QueryPackagesWhereWhereConditions) {
  packages(first: $first, wherePackageItems: $wherePackageItems, where: $where) {
    data {
      ... on HgvPackage {
        id
        packageItems {
          ... on HgvPackageItem {
            id
          }
        }
      }
      ... on LibertPackage {
        id
        packageItems {
          ... on LibertPackageItem {
            id
          }
        }
      }
      ... on SiemensPackage {
        id
        packageItems {
          ... on SiemensPackageItem {
            id
          }
        }
      }
    }
    paginatorInfo {
      total
    }
  }
}
    `
export const FetchPackagesQuery = gql`
    query FetchPackages($orderBy: [QueryPackagesOrderByOrderByClause!], $where: QueryPackagesWhereWhereConditions, $whereEntity: QueryPackagesWhereEntityWhereHasConditions, $whereAddress: QueryPackagesWhereAddressWhereHasConditions, $first: Int!, $page: Int) {
  packages(
    orderBy: $orderBy
    where: $where
    whereEntity: $whereEntity
    whereAddress: $whereAddress
    page: $page
    first: $first
  ) {
    data {
      ... on HgvPackage {
        ...PackageFragment
      }
      ... on LibertPackage {
        ...PackageFragment
      }
      ... on SiemensPackage {
        ...PackageFragment
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${PackageFragment}`
export const FetchPndPackagesQuery = gql`
    query FetchPndPackages($orderBy: [QueryPndPackagesOrderByOrderByClause!], $where: QueryPndPackagesWhereWhereConditions, $pndFilter: PndFilterInput, $whereEntity: QueryPndPackagesWhereEntityWhereHasConditions, $whereAddress: QueryPndPackagesWhereAddressWhereHasConditions, $first: Int!, $page: Int) {
  pndPackages(
    orderBy: $orderBy
    where: $where
    pndFilter: $pndFilter
    whereEntity: $whereEntity
    whereAddress: $whereAddress
    page: $page
    first: $first
  ) {
    data {
      ... on HgvPackage {
        ...PndPackageFragment
      }
      ... on LibertPackage {
        ...PndPackageFragment
      }
      ... on SiemensPackage {
        ...PndPackageFragment
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${PndPackageFragment}`
export const PackageByIdQuery = gql`
    query PackageById($id: ID!, $viewScope: SeePackageScope) {
  packageById(id: $id, viewScope: $viewScope) {
    ... on HgvPackage {
      ...PackageByIdFragment
    }
    ... on LibertPackage {
      ...PackageByIdFragment
    }
    ... on SiemensPackage {
      ...PackageByIdFragment
    }
  }
}
    ${PackageByIdFragment}`
export const PackageByPackageNumberQuery = gql`
    query PackageByPackageNumber($package_number: String!) {
  packageByPackageNumber(package_number: $package_number) {
    id
    package_type
    package_number
    cm_32_4_codclient
    atlandes_client_code
    address {
      name
      company
      street_1
      street_2
      street_3
      zipcode
      city
      country {
        name
      }
    }
    department {
      code
      label
    }
    flow
    fidu
    pan
    shipped_at
    package_items_count
  }
}
    `
export const PackagePndAdditionalInformationQuery = gql`
    query PackagePndAdditionalInformation($id: ID!) {
  packageById(id: $id) {
    ... on HgvPackage {
      id
      pnd_resend_additional_information
    }
    ... on LibertPackage {
      id
      pnd_resend_additional_information
    }
    ... on SiemensPackage {
      id
      pnd_resend_additional_information
    }
  }
}
    `
export const PackageTimelineQuery = gql`
    query PackageTimeline($package_hash: String!) {
  packageTimeline(package_hash: $package_hash) {
    id
    entity_name
    package_number
    state
    tracking_number
    tracking_url
    trackings {
      tracking_number
      tracking_url
    }
    bypassed_real_address_validation
    timeline {
      received_at
      address_validated_at
      address_corrected_at
      personalized_at
      in_transit_at
      delivered_at
      delivery_error_at
      pnd_history {
        id
        old_state
        new_state
        created_at
      }
    }
  }
}
    `
export const PackagesCarriersQuery = gql`
    query packagesCarriers {
  packagesCarriers
}
    `
export const PackagesCountQuery = gql`
    query PackagesCount($where: QueryPackagesWhereWhereConditions, $whereEntity: QueryPackagesWhereEntityWhereHasConditions, $whereAddress: QueryPackagesWhereAddressWhereHasConditions) {
  packages(
    where: $where
    whereEntity: $whereEntity
    whereAddress: $whereAddress
    first: 1
  ) {
    paginatorInfo {
      count
      total
    }
  }
}
    `
export const AddressCorrectionTileStatisticsQuery = gql`
    query AddressCorrectionTileStatistics {
  addressCorrectionTileStatistics {
    as24 {
      hgv {
        today
        recent
        older
      }
      libert {
        today
        recent
        older
      }
      obu {
        today
        recent
        older
      }
    }
    total_energies {
      hgv {
        today
        recent
        older
      }
      libert {
        today
        recent
        older
      }
      obu {
        today
        recent
        older
      }
    }
    circle_k {
      hgv {
        today
        recent
        older
      }
      libert {
        today
        recent
        older
      }
      obu {
        today
        recent
        older
      }
    }
  }
}
    `
export const CountryTrendsStatisticsQuery = gql`
    query CountryTrendsStatistics($type: PackageType, $entity: PackageEntity) {
  countryTrendsStatistics(type: $type, entity: $entity) {
    destination
    percentage
  }
}
    `
export const PackageAverageCorrectionTimeStatisticsQuery = gql`
    query PackageAverageCorrectionTimeStatistics($type: PackageType, $entity: PackageEntity) {
  packageAverageCorrectionTimeStatistics(type: $type, entity: $entity)
}
    `
export const PackageAverageProcessingTimeStatisticsQuery = gql`
    query PackageAverageProcessingTimeStatistics($type: PackageType, $entity: PackageEntity) {
  packageAverageProcessingTimeStatistics(type: $type, entity: $entity) {
    kapsch_packages_processing_average_time
    hgv_packages_processing_average_time
    libert_packages_processing_average_time
    siemens_packages_processing_average_time
  }
}
    `
export const PackageItemsAvailableToPrepareStatisticsQuery = gql`
    query PackageItemsAvailableToPrepareStatistics($daysBefore: Int) {
  packageItemsAvailableToPrepareStatistics(daysBefore: $daysBefore) {
    hgv_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
    libert_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
    siemens_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
  }
}
    `
export const PackageItemsAvailableToPrepareTodayStatisticsQuery = gql`
    query PackageItemsAvailableToPrepareTodayStatistics {
  packageItemsAvailableToPrepareTodayStatistics {
    hgv_package_items_count
    libert_package_items_count
    siemens_package_items_count
  }
}
    `
export const PackageItemsAwaitingAddressCorrectionStatisticsQuery = gql`
    query PackageItemsAwaitingAddressCorrectionStatistics {
  packageItemsAwaitingAddressCorrectionStatistics {
    hgv_package_items_count
    libert_package_items_count
    siemens_package_items_count
  }
}
    `
export const PackageItemsCountPerCountriesStatisticsQuery = gql`
    query PackageItemsCountPerCountriesStatistics($type: PackageType, $entity: PackageEntity) {
  packageItemsCountPerCountriesStatistics(type: $type, entity: $entity) {
    destination_code
    destination
    hgv_package_items_count
    libert_package_items_count
    siemens_package_items_count
  }
}
    `
export const PackageItemsDailyProgressionStatisticsQuery = gql`
    query PackageItemsDailyProgressionStatistics($type: PackageType, $entity: PackageEntity, $monthsBefore: Int) {
  packageItemsDailyProgressionStatistics(
    type: $type
    entity: $entity
    monthsBefore: $monthsBefore
  ) {
    hgv_daily_progression {
      date
      package_items_count
    }
    libert_daily_progression {
      date
      package_items_count
    }
    siemens_daily_progression {
      date
      package_items_count
    }
  }
}
    `
export const PackageItemsPersonalizedStatisticsQuery = gql`
    query PackageItemsPersonalizedStatistics($daysBefore: Int) {
  packageItemsPersonalizedStatistics(daysBefore: $daysBefore) {
    hgv_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
    libert_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
    siemens_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
  }
}
    `
export const PackageItemsPersonalizedTodayStatisticsQuery = gql`
    query PackageItemsPersonalizedTodayStatistics {
  packageItemsPersonalizedTodayStatistics {
    hgv_package_items_count
    libert_package_items_count
    siemens_package_items_count
  }
}
    `
export const PackageItemsReceivedStatisticsQuery = gql`
    query PackageItemsReceivedStatistics($daysBefore: Int) {
  packageItemsReceivedStatistics(daysBefore: $daysBefore) {
    hgv_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
    libert_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
    siemens_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
  }
}
    `
export const PackageItemsReceivedTodayStatisticsQuery = gql`
    query PackageItemsReceivedTodayStatistics {
  packageItemsReceivedTodayStatistics {
    hgv_package_items_count
    libert_package_items_count
    siemens_package_items_count
  }
}
    `
export const PackageItemsRemainingStatisticsQuery = gql`
    query PackageItemsRemainingStatistics {
  packageItemsRemainingStatistics {
    hgv_package_items_count
    libert_package_items_count
    siemens_package_items_count
  }
}
    `
export const PackageItemsShippedPerCountryStatisticsQuery = gql`
    query PackageItemsShippedPerCountryStatistics($year: String!, $month: String) {
  packageItemsShippedPerCountryStatistics(year: $year, month: $month) {
    package_items_shipped_per_country {
      destination_code
      destination_name
      hgv_package_items {
        package_items_count_for_total
        package_items_count_for_as24
      }
      libert_package_items {
        package_items_count_for_total
        package_items_count_for_as24
      }
      siemens_package_items {
        package_items_count_for_total
        package_items_count_for_as24
      }
    }
  }
}
    `
export const PackageItemsShippedStatisticsQuery = gql`
    query PackageItemsShippedStatistics($daysBefore: Int) {
  packageItemsShippedStatistics(daysBefore: $daysBefore) {
    hgv_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
    libert_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
    siemens_package_items {
      date
      package_items_count_for_total_energies
      package_items_count_for_as24
      package_items_count_for_circlek
    }
  }
}
    `
export const PackageItemsShippedTodayCountStatisticsQuery = gql`
    query PackageItemsShippedTodayCountStatistics($type: PackageType, $entity: PackageEntity) {
  packageItemsShippedTodayCountStatistics(type: $type, entity: $entity) {
    hgv_package_items {
      as24_count
      te_count
      all_count
    }
    libert_package_items {
      as24_count
      te_count
      all_count
    }
    siemens_package_items {
      as24_count
      te_count
      all_count
    }
  }
}
    `
export const PackageItemsShippedTodayStatisticsQuery = gql`
    query PackageItemsShippedTodayStatistics {
  packageItemsShippedTodayStatistics {
    hgv_package_items_count
    libert_package_items_count
    siemens_package_items_count
  }
}
    `
export const PackagesAvailableToPrepareStatisticsQuery = gql`
    query PackagesAvailableToPrepareStatistics($daysBefore: Int) {
  packagesAvailableToPrepareStatistics(daysBefore: $daysBefore) {
    hgv_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
    libert_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
    siemens_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
  }
}
    `
export const PackagesAvailableToPrepareTodayStatisticsQuery = gql`
    query PackagesAvailableToPrepareTodayStatistics {
  packagesAvailableToPrepareTodayStatistics {
    hgv_packages_count
    libert_packages_count
    siemens_packages_count
  }
}
    `
export const PackagesAwaitingAddressCorrectionStatisticsQuery = gql`
    query PackagesAwaitingAddressCorrectionStatistics {
  packagesAwaitingAddressCorrectionStatistics {
    hgv_packages_count
    libert_packages_count
    siemens_packages_count
  }
}
    `
export const PackagesCompletedStatisticsQuery = gql`
    query PackagesCompletedStatistics($daysBefore: Int) {
  packagesCompletedStatistics(daysBefore: $daysBefore) {
    hgv_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
    libert_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
    siemens_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
  }
}
    `
export const PackagesCompletedTodayStatisticsQuery = gql`
    query PackagesCompletedTodayStatistics {
  packagesCompletedTodayStatistics {
    hgv_packages_count
    libert_packages_count
    siemens_packages_count
  }
}
    `
export const PackagesCountPerCountriesStatisticsQuery = gql`
    query PackagesCountPerCountriesStatistics($type: PackageType, $entity: PackageEntity) {
  packagesCountPerCountriesStatistics(type: $type, entity: $entity) {
    destination_code
    destination
    hgv_packages_count
    libert_packages_count
    siemens_packages_count
  }
}
    `
export const PackagesDailyAverageProcessingTimeStatisticsQuery = gql`
    query PackagesDailyAverageProcessingTimeStatistics($year: String!, $month: String!) {
  packagesDailyAverageProcessingTimeStatistics(year: $year, month: $month) {
    daily_average_processing_time_hgv {
      date
      average_processing_time
    }
    daily_average_processing_time_libert {
      date
      average_processing_time
    }
    daily_average_processing_time_siemens {
      date
      average_processing_time
    }
  }
}
    `
export const PackagesDailyProgressionStatisticsQuery = gql`
    query PackagesDailyProgressionStatistics($type: PackageType, $entity: PackageEntity, $monthsBefore: Int) {
  packagesDailyProgressionStatistics(
    type: $type
    entity: $entity
    monthsBefore: $monthsBefore
  ) {
    hgv_daily_progression {
      date
      packages_count
    }
    libert_daily_progression {
      date
      packages_count
    }
    siemens_daily_progression {
      date
      packages_count
    }
  }
}
    `
export const PackagesDailyShippedReceivedStatisticsQuery = gql`
    query PackagesDailyShippedReceivedStatistics($year: String!, $month: String!, $entity: PackageEntity, $type: PackageType!) {
  packagesDailyShippedReceivedStatistics(
    year: $year
    month: $month
    entity: $entity
    type: $type
  ) {
    date
    package_daily_shipped_statistics {
      AS24
      TOTAL
    }
    package_daily_received_statistics {
      AS24
      TOTAL
    }
  }
}
    `
export const PackagesReceivedStatisticsQuery = gql`
    query PackagesReceivedStatistics($daysBefore: Int) {
  packagesReceivedStatistics(daysBefore: $daysBefore) {
    hgv_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
    libert_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
    siemens_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
  }
}
    `
export const PackagesReceivedTodayCountStatisticsQuery = gql`
    query PackagesReceivedTodayCountStatistics($type: PackageType, $entity: PackageEntity) {
  packagesReceivedTodayCountStatistics(type: $type, entity: $entity) {
    hgv_packages {
      total_count
      as24_count
      all_count
    }
    hgv_package_items {
      total_count
      as24_count
      all_count
    }
    libert_packages {
      total_count
      as24_count
      all_count
    }
    libert_package_items {
      total_count
      as24_count
      all_count
    }
    siemens_packages {
      total_count
      as24_count
      all_count
    }
    siemens_package_items {
      total_count
      as24_count
      all_count
    }
    kapsch_packages {
      total_count
      as24_count
      all_count
    }
    kapsch_package_items {
      total_count
      as24_count
      all_count
    }
  }
}
    `
export const PackagesReceivedTodayStatisticsQuery = gql`
    query PackagesReceivedTodayStatistics {
  packagesReceivedTodayStatistics {
    hgv_packages_count
    libert_packages_count
    siemens_packages_count
  }
}
    `
export const PackagesRemainingStatisticsQuery = gql`
    query PackagesRemainingStatistics {
  packagesRemainingStatistics {
    hgv_packages_count
    libert_packages_count
    siemens_packages_count
  }
}
    `
export const PackagesShippedStatisticsQuery = gql`
    query PackagesShippedStatistics($daysBefore: Int) {
  packagesShippedStatistics(daysBefore: $daysBefore) {
    hgv_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
    libert_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
    siemens_packages {
      date
      packages_count_for_total_energies
      packages_count_for_as24
      packages_count_for_circlek
    }
  }
}
    `
export const PackagesShippedTodayCountStatisticsQuery = gql`
    query PackagesShippedTodayCountStatistics($type: PackageType, $entity: PackageEntity) {
  packagesShippedTodayCountStatistics(type: $type, entity: $entity) {
    hgv_packages {
      as24_count
      te_count
      all_count
    }
    libert_packages {
      as24_count
      te_count
      all_count
    }
    siemens_packages {
      as24_count
      te_count
      all_count
    }
  }
}
    `
export const PackagesShippedTodayStatisticsQuery = gql`
    query PackagesShippedTodayStatistics {
  packagesShippedTodayStatistics {
    hgv_packages_count
    libert_packages_count
    siemens_packages_count
  }
}
    `
export const PackagesTileStatisticsQuery = gql`
    query PackagesTileStatistics {
  packagesTileStatistics {
    packageStatistics {
      as24 {
        hgv {
          completed
          all
        }
        libert {
          completed
          all
        }
        obu {
          completed
          all
        }
      }
      total_energies {
        hgv {
          completed
          all
        }
        libert {
          completed
          all
        }
        obu {
          completed
          all
        }
      }
      circle_k {
        hgv {
          completed
          all
        }
        libert {
          completed
          all
        }
        obu {
          completed
          all
        }
      }
    }
    packageItemStatistics {
      hgv
      libert
      obu
    }
  }
}
    `
export const PndTileStatisticsQuery = gql`
    query PndTileStatistics {
  pndTileStatistics {
    hgv {
      older
      recent
      today
    }
    libert {
      older
      recent
      today
    }
    obu {
      older
      recent
      today
    }
  }
}
    `
export const StocksStatisticsQuery = gql`
    query StocksStatistics {
  stocksStatistics {
    code_article
    physical_stock
    reserved_stock
    available_stock
  }
}
    `
export const TicketsStatisticsQuery = gql`
    query TicketsStatistics {
  ticketsStatistics {
    average_lifespan_tickets
    top_tagged_tickets
    top_creator_tickets
    tag_counts {
      tag_name_tickets
      tag_count_tickets
    }
    status_counts {
      open_tickets
      pending_tickets
      closed_tickets
      total_tickets
    }
    progression_days {
      date_tickets
      no_tickets
    }
  }
}
    `
export const CheckIfUserIsAuthenticatedQuery = gql`
    query CheckIfUserIsAuthenticated {
  me {
    id
  }
}
    `
export const GetUserByIdQuery = gql`
    query GetUserById($id: Int!) {
  user(id: $id) {
    id
    name
    email
    created_at
    updated_at
    roles {
      id
      name
    }
  }
}
    `
export const GetUsersQuery = gql`
    query GetUsers($first: Int!, $page: Int, $where: QueryUsersWhereWhereConditions, $whereRoles: QueryUsersWhereRolesWhereHasConditions, $orderBy: [QueryUsersOrderByRelationOrderByClause!]) {
  users(
    first: $first
    page: $page
    where: $where
    whereRoles: $whereRoles
    orderBy: $orderBy
  ) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      id
      name
      email
      locale
      created_at
      updated_at
      roles {
        id
        name
      }
    }
  }
}
    `
export const MyRolesQuery = gql`
    query MyRoles {
  me {
    id
    roles {
      id
      name
    }
  }
}
    `
export const RepresentantUserByIdQuery = gql`
    query RepresentantUserById($id: Int!) {
  user(id: $id) {
    id
    name
    email
    departments {
      ...RepresentantUserByIdDepartment
    }
    contextDepartments {
      ...RepresentantUserByIdDepartment
    }
  }
}
    ${RepresentantUserByIdDepartment}`
export const RepresentantUsersListQuery = gql`
    query RepresentantUsersList($first: Int!, $page: Int, $where: QueryUsersWhereWhereConditions, $orderBy: [QueryUsersOrderByRelationOrderByClause!]) {
  users(first: $first, page: $page, where: $where, orderBy: $orderBy) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      id
      name
      email
      locale
      departments {
        ...RepresentantUsersListDepartment
      }
      contextDepartments {
        ...RepresentantUsersListDepartment
      }
    }
  }
}
    ${RepresentantUsersListDepartment}`
export const UserRolesQuery = gql`
    query UserRoles {
  userRoles {
    id
    name
  }
}
    `
export const DocTemplateEventQuery = gql`
    subscription docTemplateEvent {
  docTemplateEvent {
    id
    event
    data {
      id
      department {
        id
        code
      }
      for_languages
      flows
      doc_type
      doc_name
      description
      default_for_department
      created_at
      updated_at
    }
  }
}
    `
export const FileExportEventQuery = gql`
    subscription fileExportEvent {
  fileExportEvent {
    event
    url
  }
}
    `
export const TicketCreatedQuery = gql`
    subscription ticketCreated {
  ticketCreated
}
    `
export const TicketUpdatedQuery = gql`
    subscription ticketUpdated {
  ticketUpdated
}
    `
export const AlertConfirmedQuery = gql`
    subscription alertConfirmed {
  alertConfirmed {
    id
    alert {
      alert
    }
    action
  }
}
    `
export const PackagePndResultQuery = gql`
    subscription packagePndResult {
  packagePndResult {
    id
    success
    errorMessage
    event
    package {
      ... on HgvPackage {
        id
        package_number
      }
      ... on LibertPackage {
        id
        package_number
      }
      ... on SiemensPackage {
        id
        package_number
      }
    }
  }
}
    `
